import gradeA from "../assets/icons/A-Grade.png";
import gradeB from "../assets/icons/B-Grade.png";

export const chinaMarathons = {
  // 北京的马拉松赛事
  beijing: [
    {
      id: "beijing-marathon",
      name: "北京国际马拉松",
      distance: "全马",
      date: "2024年11月03日",
      numberOfParticipants: "约30,000人",
      image: require("../assets/pictures/MarathonPicture/beijng-marathon.jpeg"),
      routeImage: require("../assets/routeMap/beijing-marathon.webp"),
      web: "https://www.beijing-marathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      features: [
        {
          id: "route",
          name: "路线特色",
          content: "起点从天安门广场前跑过，绝对的顶级景点",
        },
        {
          id: "scenery",
          name: "城市风光",
          content: "城市具有较多的景点，如天安门、故宫、长安街等",
        },
        {
          id: "transportation",
          name: "交通便利",
          content: "交通便利，地铁、公交等交通方式都很方便，方便旅游及参赛",
        },
        {
          id: "warning",
          name: "提醒⚠️",
          content: "据往年的经验，比赛日的空气都不太好",
        },
      ],

      travelPlan: {
        title: `北京国际马拉松 - 北京3日跑游攻略`,
        description: `结合北京国际马拉松，为您规划一个融合运动激情与古都魅力的3日行程。`,
        days: [
          {
            day: 1,
            theme: "抵达与古都初探",
            activities: [
              {
                time: "下午",
                activity: "抵达北京，入住推荐酒店（",
                notes: "建议定在终点附近的酒店，价格和交通都合适",
              },
              {
                time: "傍晚",
                activity: "游览天安门广场，感受恢弘气势，参观人民英雄纪念碑。",
                notes: "注意广场开放时间及安检。",
              },
              {
                time: "晚餐",
                activity:
                  "前往王府井或前门大街，品尝北京烤鸭（如：全聚德、四季民福）或特色小吃。",
                notes: "王府井步行街夜晚也很热闹。",
              },
            ],
            hotelRecommendations: [
              "首都宾馆",
              "北京饭店诺金",
              "北京贵宾楼饭店",
              "王府井希尔顿酒店",
            ],
            restaurantRecommendations: [
              "全聚德烤鸭(王府井店)",
              "四季民福烤鸭店(前门店)",
              "利群烤鸭店",
              "都一处烧麦馆",
            ],
            sightseeingRecommendations: [
              "天安门广场",
              "人民英雄纪念碑",
              "中国国家博物馆",
              "王府井步行街",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: `参加 北京国际马拉松 比赛！`,
                notes: "提前规划好交通，预留充足时间。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择参观故宫博物院，领略皇家宫殿的魅力。",
                notes: "故宫需提前预约门票。",
              },
              {
                time: "晚餐",
                activity: "在后海或南锣鼓巷区域享用晚餐，体验北京胡同文化。",
                notes: "可以选择环境轻松的餐厅或酒吧。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "大董烤鸭店(南新仓店)",
              "南门涮肉(后海店)",
              "护国寺小吃(护国寺总店)",
            ],
            sightseeingRecommendations: [
              "故宫博物院",
              "景山公园",
              "后海",
              "南锣鼓巷",
            ],
          },
          {
            day: 3,
            theme: "自然风光与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "根据时间和兴趣选择：游览颐和园，欣赏皇家园林风光；或前往奥林匹克公园，参观鸟巢、水立方。",
                notes: "颐和园较大，建议预留半天时间。",
              },
              {
                time: "午餐",
                activity: "在颐和园附近或奥林匹克公园周边用餐。",
                notes: "奥林匹克公园周边餐饮选择丰富。",
              },
              { time: "下午", activity: "整理行装，适时前往机场/火车站返程。" },
            ],
            hotelRecommendations: ["同上或靠近机场/火车站的酒店"],
            restaurantRecommendations: ["附近特色餐厅"],
            sightseeingRecommendations: [
              "颐和园",
              "奥林匹克公园",
              "圆明园遗址公园",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-half-marathon",
      name: "北京半程马拉松",
      distance: "半马",
      date: "2025年4月20日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/beijng-half-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-half-marathon.jpeg"),
      web: "https://beijing-halfmarathon.btime.com/#/home",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      features: [
        {
          id: "route",
          name: "路线特色",
          content: "虽然不经过天安门前，但在天安门附近起跑，相对较平",
        },
        {
          id: "scenery",
          name: "城市风光",
          content: "城市具有较多的景点，如天安门、故宫、长安街等",
        },
        {
          id: "transportation",
          name: "交通便利",
          content: "交通便利，地铁、公交等交通方式都很方便，方便旅游及参赛",
        },
        {
          id: "warning",
          name: "提醒⚠️",
          content: "2025年报名出现争议，建议选择官网报名",
        },
      ],
      travelPlan: {
        title: `北京半程马拉松 - 北京3日跑游攻略`,
        description: `结合北京半程马拉松，为您规划一个融合运动激情与都市活力的3日行程。`,
        days: [
          {
            day: 1,
            theme: "抵达与奥运遗产探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达北京，入住推荐酒店（如：国家会议中心大酒店、北京中奥马哥孛罗大酒店等鸟巢附近酒店）",
                notes: "选择靠近起终点的酒店。",
              },
              {
                time: "傍晚",
                activity: "游览奥林匹克公园，外观鸟巢、水立方。",
                notes: "夜晚灯光效果更佳。",
              },
              {
                time: "晚餐",
                activity: "在亚运村或奥体中心附近选择餐厅。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "国家会议中心大酒店",
              "北京中奥马哥孛罗大酒店",
              "盘古七星酒店",
            ],
            restaurantRecommendations: ["周边各类餐厅"],
            sightseeingRecommendations: [
              "奥林匹克公园",
              "鸟巢",
              "水立方",
              "中国科学技术馆",
            ],
          },
          {
            day: 2,
            theme: "半马日与艺术熏陶",
            activities: [
              {
                time: "上午",
                activity: `参加 北京半程马拉松 比赛！`,
                notes: "赛道主要在奥森公园内。",
              },
              {
                time: "下午",
                activity:
                  "赛后可在奥林匹克森林公园内放松散步，或前往798艺术区感受艺术氛围。",
                notes: "",
              },
              {
                time: "晚餐",
                activity: "在798艺术区或三里屯附近用餐。",
                notes: "三里屯夜生活丰富。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "798艺术区特色餐厅",
              "三里屯太古里周边餐厅",
            ],
            sightseeingRecommendations: [
              "奥林匹克森林公园",
              "798艺术区",
              "三里屯",
            ],
          },
          {
            day: 3,
            theme: "历史文化或购物与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "根据兴趣选择：参观雍和宫体验藏传佛教文化；或前往市中心王府井、西单购物。",
                notes: "",
              },
              { time: "午餐", activity: "在所选区域附近用餐。", notes: "" },
              { time: "下午", activity: "整理行装，适时返程。" },
            ],
            hotelRecommendations: ["同上或靠近市中心/返程地点的酒店"],
            restaurantRecommendations: [
              "雍和宫附近素食或特色餐厅",
              "王府井/西单商圈餐厅",
            ],
            sightseeingRecommendations: ["雍和宫", "国子监", "王府井", "西单"],
          },
        ],
      },
    },
    {
      id: "beijing-mc-marathon",
      name: "北京城市副中心马拉松",
      distance: "全马",
      date: "2025年4月13日⚠️延期至4月19日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/beijing-mc-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-half-mc-marathon.jpeg"),
      web: "https://bjmcmarathon.chinaath.com/reg/#/race-reg/race-reg-index",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      features: [
        {
          id: "route",
          name: "路线特色",
          content: "赛道主要在通州城市副中心，沿运河而建，风景优美",
        },
        {
          id: "warning",
          name: "注意⚠️",
          content: "赛道有比较长的部分在公园里，比较曲折",
        },
      ],
      travelPlan: {
        title: `北京城市副中心马拉松 - 通州3日探索`,
        description: `结合北京城市副中心马拉松，体验通州运河文化与现代发展的3日行程。`,
        days: [
          {
            day: 1,
            theme: "抵达与运河初体验",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达通州，入住推荐酒店（如：通州希尔顿酒店、北京环球影城度假区酒店）",
                notes: "考虑靠近赛道或交通便利的酒店。",
              },
              {
                time: "傍晚",
                activity: "游览（大）运河森林公园，感受运河风光。",
                notes: "公园较大，可选择部分区域游览。",
              },
              {
                time: "晚餐",
                activity: "在通州万达广场或运河商务区附近用餐。",
                notes: "餐饮选择较多。",
              },
            ],
            hotelRecommendations: [
              "北京通州希尔顿酒店",
              "北京环球影城大酒店",
              "诺金度假酒店-北京环球影城",
            ],
            restaurantRecommendations: ["通州万达广场内餐厅", "运河商务区餐厅"],
            sightseeingRecommendations: [
              "（大）运河森林公园",
              "通州博物馆",
              "燃灯塔",
            ],
          },
          {
            day: 2,
            theme: "副中心马拉松日与环球影城",
            activities: [
              {
                time: "上午",
                activity: `参加 北京城市副中心马拉松 比赛！`,
                notes: "了解赛道起终点交通。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往北京环球影城度假区游玩（需另购门票和规划时间）。",
                notes: "环球影城需要一整天时间才能充分体验。",
              },
              {
                time: "晚餐",
                activity: "在环球影城城市大道或返回通州市区用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["环球影城城市大道餐厅", "通州市区餐厅"],
            sightseeingRecommendations: [
              "北京环球影城度假区",
              "城市绿心森林公园",
            ],
          },
          {
            day: 3,
            theme: "文化艺术与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "参观韩美林艺术馆（通州馆）或宋庄艺术区，感受艺术氛围。",
                notes: "宋庄艺术区范围较大，可选择性参观。",
              },
              {
                time: "午餐",
                activity: "在艺术馆或艺术区附近用餐。",
                notes: "",
              },
              { time: "下午", activity: "整理行装，适时返程。" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["附近特色餐厅"],
            sightseeingRecommendations: [
              "韩美林艺术馆(通州馆)",
              "宋庄艺术区",
              "台湖演艺小镇",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-etown-half-marathon",
      name: "北京亦庄半程马拉松",
      distance: "半马",
      date: "2025年4月13日⚠️延期至4月19日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/bejing-etown-half-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-etown-half-marathon.jpeg"),
      web: null,
      isCAAcertified: true,
      grade: undefined,
      gradeImage: undefined,
      features: [
        {
          id: "route",
          name: "路线特色",
          content: "赛道主要在亦庄经济技术开发区内，沿途有不少科技公司",
        },
        {
          id: "race",
          name: "赛事特色",
          content: "引入机器人跑步的元素，赛道上会有机器人陪跑",
        },
        {
          id: "warning",
          name: "注意⚠️",
          content: "比赛历史不久，有些流程可能不够成熟",
        },
      ],
      travelPlan: {
        title: `北京亦庄半程马拉松 - 亦庄3日科技体验`,
        description: `结合北京亦庄半程马拉松，探索北京经济技术开发区的科技魅力与生活休闲。`,
        days: [
          {
            day: 1,
            theme: "抵达与亦庄初印象",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达亦庄，入住推荐酒店（如：北京亦庄希尔顿逸林酒店、锦江富园大酒店）",
                notes: "选择靠近赛道或地铁站的酒店。",
              },
              {
                time: "傍晚",
                activity:
                  "逛逛亦庄创意生活广场或城乡世纪广场，感受区域商业氛围。",
                notes: "",
              },
              { time: "晚餐", activity: "在酒店或附近商圈用餐。", notes: "" },
            ],
            hotelRecommendations: [
              "北京亦庄希尔顿逸林酒店",
              "锦江富园大酒店",
              "智选假日酒店(亦庄店)",
            ],
            restaurantRecommendations: [
              "亦庄创意生活广场周边餐厅",
              "城乡世纪广场餐厅",
            ],
            sightseeingRecommendations: [
              "南海子公园（部分位于亦庄）",
              "亦庄滨河森林公园",
            ],
          },
          {
            day: 2,
            theme: "亦庄半马日与公园休闲",
            activities: [
              {
                time: "上午",
                activity: `参加 北京亦庄半程马拉松 比赛！`,
                notes: "关注赛事起终点安排。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可前往南海子公园或亦庄滨河森林公园散步、休憩。",
                notes: "南海子公园面积很大，麋鹿苑值得一看。",
              },
              {
                time: "晚餐",
                activity: "选择当地特色餐厅或返回酒店用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["当地特色餐厅"],
            sightseeingRecommendations: [
              "南海子公园",
              "麋鹿苑",
              "亦庄滨河森林公园",
            ],
          },
          {
            day: 3,
            theme: "科技探索或购物与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "根据兴趣选择：参观区内部分开放的企业展厅（需提前了解）；或前往荟聚购物中心购物。",
                notes: "企业参观通常需要预约。",
              },
              { time: "午餐", activity: "在参观地或购物中心用餐。", notes: "" },
              { time: "下午", activity: "整理行装，适时返程。" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["荟聚购物中心餐厅"],
            sightseeingRecommendations: [
              "北京奔驰汽车有限公司（外观或预约参观）",
              "京东总部大厦（外观）",
              "荟聚购物中心",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-haidian-10k",
      name: "中国田协10公里精英赛（海淀站）",
      distance: "10公里、4.8公里",
      date: "2025年4月6日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/beijing-haidian-10k.png"),
      routeImage: require("../assets/routeMap/beijng-haidian-10K.jpeg"),
      web: "http://10k.haidian-marathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `海淀10公里精英赛 - 北京3日高校与园林之旅`,
        description: `结合海淀10公里精英赛，体验北京海淀区的学院氛围与皇家园林。`,
        days: [
          {
            day: 1,
            theme: "抵达与学府漫步",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达海淀，入住推荐酒店（如：北大博雅国际酒店、清华大学周边酒店）",
                notes: "感受高校氛围。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步北京大学或清华大学校园（部分区域可能需预约或有限制）。",
                notes: "感受中国顶尖学府的氛围。",
              },
              {
                time: "晚餐",
                activity: "在五道口或中关村附近用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "北大博雅国际酒店",
              "北京友谊宾馆",
              "北京锡华商务酒店",
            ],
            restaurantRecommendations: ["五道口周边餐厅", "中关村食宝街"],
            sightseeingRecommendations: ["北京大学", "清华大学", "五道口"],
          },
          {
            day: 2,
            theme: "10K赛与皇家园林",
            activities: [
              {
                time: "上午",
                activity: `参加 中国田协10公里精英赛（海淀站） 比赛！`,
                notes: "比赛通常在公园或高校附近。",
              },
              {
                time: "下午",
                activity: "赛后放松，游览颐和园，欣赏皇家园林典范。",
                notes: "颐和园非常大，建议乘船游览。",
              },
              {
                time: "晚餐",
                activity: "在颐和园附近或返回中关村用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "颐和园周边餐厅",
              "听鹂馆(颐和园内)",
              "中关村欧美汇购物中心餐厅",
            ],
            sightseeingRecommendations: ["颐和园", "圆明园遗址公园"],
          },
          {
            day: 3,
            theme: "科技探索或文化与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "参观中关村国家自主创新示范区展示中心（需预约）；或前往国家图书馆。",
                notes: "",
              },
              {
                time: "午餐",
                activity: "在中关村或图书馆附近用餐。",
                notes: "",
              },
              { time: "下午", activity: "整理行装，适时返程。" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["中关村地区餐厅"],
            sightseeingRecommendations: [
              "中关村",
              "国家图书馆",
              "北京航空航天大学航空航天博物馆",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-haidian-marathon",
      name: "海淀马拉松",
      distance: "全马",
      date: "2024年10月27日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/beijing-haidian-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-haidian-marathon.jpeg"),
      web: "https://www.haidian-marathon.com/",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: `海淀马拉松 - 北京3日科技与园林深度游`,
        description: `结合海淀马拉松，深度体验北京海淀区的科技创新、高等学府与皇家园林。`,
        days: [
          {
            day: 1,
            theme: "抵达与学府漫步",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达海淀，入住推荐酒店（如：北大博雅国际酒店、中关村皇冠假日酒店）",
                notes: "考虑靠近起点中关村的酒店。",
              },
              {
                time: "傍晚",
                activity: "漫步北京大学或清华大学校园。",
                notes: "",
              },
              {
                time: "晚餐",
                activity: "在五道口或中关村附近用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "北大博雅国际酒店",
              "北京友谊宾馆",
              "北京锡华商务酒店",
              "中关村皇冠假日酒店",
            ],
            restaurantRecommendations: ["五道口周边餐厅", "中关村食宝街"],
            sightseeingRecommendations: ["北京大学", "清华大学", "中关村"],
          },
          {
            day: 2,
            theme: "海淀马拉松日与园林",
            activities: [
              {
                time: "上午",
                activity: `参加 海淀马拉松 比赛！`,
                notes: "起点中关村，终点奥森公园，注意交通。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可在终点奥林匹克森林公园休息，或前往颐和园。",
                notes: "",
              },
              {
                time: "晚餐",
                activity: "在奥森公园附近或颐和园附近用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["奥森公园周边餐厅", "颐和园附近餐厅"],
            sightseeingRecommendations: [
              "奥林匹克森林公园",
              "颐和园",
              "圆明园遗址公园",
            ],
          },
          {
            day: 3,
            theme: "科技探索或文化与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "参观中关村国家自主创新示范区展示中心（需预约）；或前往香山公园。",
                notes: "香山红叶季人较多。",
              },
              { time: "午餐", activity: "在中关村或香山附近用餐。", notes: "" },
              { time: "下午", activity: "整理行装，适时返程。" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["中关村地区餐厅", "香山附近农家院"],
            sightseeingRecommendations: ["中关村", "香山公园", "北京植物园"],
          },
        ],
      },
    },
    {
      id: "beijing-daxing-marathon",
      name: "大兴半程马拉松",
      distance: "半马、6.5公里",
      date: "2025年5月11日",
      numberOfParticipants: "约6000人",
      image: require("../assets/pictures/MarathonPicture/beijing-daxing-half-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-daxing-half-marathon.jpeg"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      features: [
        {
          id: "route",
          name: "路线特色",
          content: "路线比较原生态，主要在公园附近，风景优美",
        },
        {
          id: "rewards",
          name: "完赛物资",
          content: "2025年完赛物资有西瓜和鲜花可以带走",
        },
        {
          id: "signup",
          name: "报名方式",
          content: "A1级别比赛，先到先得，不需要抽签，报名较为省心",
        },
        {
          id: "warning",
          name: "提醒⚠️",
          content:
            "交通不太方便，比赛较远，建议开车，官方有停车场。赛道比较偏僻，观众较少",
        },
      ],
      travelPlan: {
        title: `大兴半程马拉松 - 北京3日新城与机场探索`,
        description: `结合大兴半程马拉松，体验北京南部新城的活力与大兴国际机场的魅力。`,
        days: [
          {
            day: 1,
            theme: "抵达与新城感受",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达大兴，入住推荐酒店（如：大兴希尔顿酒店、北京大兴国际机场希尔顿酒店）",
                notes: "考虑靠近赛道或机场线。",
              },
              {
                time: "傍晚",
                activity: "逛逛大兴龙湖天街或荟聚西红门店。",
                notes: "",
              },
              { time: "晚餐", activity: "在酒店或商圈用餐。", notes: "" },
            ],
            hotelRecommendations: [
              "北京大兴希尔顿酒店",
              "北京兴基铂尔曼饭店",
              "格林豪泰(大兴黄村火车站店)",
            ],
            restaurantRecommendations: [
              "大兴龙湖天街餐厅",
              "荟聚西红门购物中心餐厅",
            ],
            sightseeingRecommendations: ["念坛公园", "北京野生动物园"],
          },
          {
            day: 2,
            theme: "大兴半马日与公园",
            activities: [
              {
                time: "上午",
                activity: `参加 大兴半程马拉松 比赛！`,
                notes: "比赛地点通常在大兴新城。",
              },
              {
                time: "下午",
                activity: "赛后放松，可前往北京野生动物园或念坛公园。",
                notes: "野生动物园需要较长时间。",
              },
              { time: "晚餐", activity: "选择当地特色餐厅。", notes: "" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["大兴本地特色餐厅"],
            sightseeingRecommendations: [
              "北京野生动物园",
              "念坛公园",
              "中华文化园",
            ],
          },
          {
            day: 3,
            theme: "机场探索或购物与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "前往北京大兴国际机场参观（即使不乘机也可参观部分区域）；或在附近奥特莱斯购物。",
                notes: "机场本身就是一大景观。",
              },
              { time: "午餐", activity: "在机场或奥特莱斯用餐。", notes: "" },
              {
                time: "下午",
                activity: "整理行装，适时返程（可从大兴机场出发）。",
              },
            ],
            hotelRecommendations: ["同上或机场酒店"],
            restaurantRecommendations: ["大兴国际机场内餐厅", "奥特莱斯餐饮"],
            sightseeingRecommendations: [
              "北京大兴国际机场",
              "世界月季主题园",
              "庞各庄西瓜小镇（季节性）",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-miyun-marathon",
      name: "密云马拉松",
      distance: "全马、半马、5公里",
      date: "2025年5月25日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/beijing-miyun-marathon.png"),
      routeImage: require("../assets/routeMap/beijng-miyun-marathon(2024).jpeg"),
      web: "http://miyun-ecomarathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      feature: [
        {
          id: "route",
          name: "路线特色",
          content: "赛道主要在密云水库和周边山地，风景优美",
        },
        {
          id: "warning",
          name: "注意⚠️",
          content: "赛道比较偏僻，观众较少",
        },
      ],
      travelPlan: {
        title: `密云马拉松 - 北京3日山水生态之旅`,
        description: `结合密云马拉松，享受北京远郊的湖光山色与自然生态。`,
        days: [
          {
            day: 1,
            theme: "抵达与水库风光",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达密云，入住推荐酒店或民宿（如：密云万豪酒店、古北水镇周边）",
                notes: "密云城区或景区住宿皆可。",
              },
              {
                time: "傍晚",
                activity: "游览密云水库周边，欣赏湖光山色。",
                notes: "可选择观景台或沿湖步道。",
              },
              {
                time: "晚餐",
                activity: "品尝密云水库鱼或农家菜。",
                notes: "当地特色美食。",
              },
            ],
            hotelRecommendations: [
              "北京密云万豪酒店",
              "海湾半山温泉酒店",
              "古北水镇大酒店及特色客栈",
            ],
            restaurantRecommendations: ["密云水库鱼餐馆", "当地农家院"],
            sightseeingRecommendations: ["密云水库", "密云博物馆"],
          },
          {
            day: 2,
            theme: "密云马拉松日与古北水镇",
            activities: [
              {
                time: "上午",
                activity: `参加 密云马拉松 比赛！`,
                notes: "赛道通常环绕水库或山地。",
              },
              {
                time: "下午",
                activity: "赛后放松，前往古北水镇游览，体验北方水乡风情。",
                notes: "可考虑夜游古北水镇。",
              },
              {
                time: "晚餐",
                activity: "在古北水镇内或密云城区用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["古北水镇内餐厅", "密云城区餐厅"],
            sightseeingRecommendations: [
              "古北水镇",
              "司马台长城（需预约，可从古北水镇前往）",
            ],
          },
          {
            day: 3,
            theme: "自然风光与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "根据兴趣选择：游览黑龙潭自然风景区或清凉谷等自然景区；或体验采摘（季节性）。",
                notes: "密云自然景区众多。",
              },
              {
                time: "午餐",
                activity: "在景区附近或返回密云城区用餐。",
                notes: "",
              },
              { time: "下午", activity: "整理行装，适时返回市区或直接返程。" },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["景区周边农家院"],
            sightseeingRecommendations: [
              "黑龙潭自然风景区",
              "清凉谷",
              "桃源仙谷",
            ],
          },
        ],
      },
    },
    {
      id: "beijing-shunyi-half-marathon",
      name: "顺义半程马拉松",
      distance: "半马",
      date: "2025年4月13日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/beijing-shunyi-half-marathon.png"),
      routeImage: require("../assets/routeMap/beijing-shunyi-half-marathon.jpeg"),
      web: null,
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: `顺义半程马拉松 - 北京3日临空经济与休闲之旅`,
        description: `结合顺义半程马拉松，体验北京东北部临空经济区的活力与休闲度假氛围。`,
        days: [
          {
            day: 1,
            theme: "抵达与水上公园",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达顺义，入住推荐酒店（如：北京首都机场希尔顿酒店、顺义国展地区酒店）",
                notes: "靠近机场和国展。",
              },
              {
                time: "傍晚",
                activity: "游览顺义奥林匹克水上公园。",
                notes: "感受奥运遗产。",
              },
              {
                time: "晚餐",
                activity: "在顺义城区或祥云小镇用餐。",
                notes: "祥云小镇是较新的商业区。",
              },
            ],
            hotelRecommendations: [
              "北京首都机场希尔顿酒店",
              "北京临空皇冠假日酒店",
              "和园景逸大酒店",
            ],
            restaurantRecommendations: ["祥云小镇餐厅", "顺义城区餐厅"],
            sightseeingRecommendations: [
              "顺义奥林匹克水上公园",
              "北京国际鲜花港（季节性）",
            ],
          },
          {
            day: 2,
            theme: "顺义半马日与休闲",
            activities: [
              {
                time: "上午",
                activity: `参加 顺义半程马拉松 比赛！`,
                notes: "了解赛道信息。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往春晖园温泉度假村泡温泉，或逛逛祥云小镇。",
                notes: "",
              },
              {
                time: "晚餐",
                activity: "在温泉度假村或祥云小镇用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上", "春晖园温泉度假酒店"],
            restaurantRecommendations: ["祥云小镇", "度假村内餐厅"],
            sightseeingRecommendations: [
              "祥云小镇",
              "春晖园温泉度假区",
              "罗红摄影艺术馆",
            ],
          },
          {
            day: 3,
            theme: "航空或艺术与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "参观中国航空博物馆（位于昌平，距离顺义不远）；或前往松美术馆。",
                notes: "航空博物馆内容丰富。",
              },
              {
                time: "午餐",
                activity: "在博物馆或美术馆附近用餐。",
                notes: "",
              },
              { time: "下午", activity: "整理行装，适时前往首都机场返程。" },
            ],
            hotelRecommendations: ["同上或机场酒店"],
            restaurantRecommendations: ["附近餐厅"],
            sightseeingRecommendations: [
              "中国航空博物馆",
              "松美术馆",
              "七彩蝶园（季节性）",
            ],
          },
        ],
      },
    },
  ],

  // 上海的马拉松赛事
  shanghai: [
    {
      id: "shanghai-marathon",
      name: "上海马拉松",
      distance: "全马、5公里",
      date: "2024年12月01日",
      numberOfParticipants: "约38,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-Marathon.png"),
      routeImage: require("../assets/routeMap/shanghai-marathon.jpg"),
      web: "https://www.shang-ma.com/#/marathon/219/inter",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `上海马拉松 - 上海3日经典魅力之旅`,
        description: `结合上海马拉松，为您规划一个融合运动激情与魔都风情的3日行程。`,
        days: [
          {
            day: 1,
            theme: "抵达与都市初体验",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住推荐酒店（如：上海外滩华尔道夫酒店、上海半岛酒店等外滩/南京东路附近酒店）",
                notes: "选择靠近起点的外滩酒店便于比赛日出行。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步外滩，欣赏黄浦江两岸风光，包括外滩万国建筑群和浦东陆家嘴天际线。",
                notes: "晚上灯光秀非常值得一看。",
              },
              {
                time: "晚餐",
                activity:
                  "在南京东路或外滩附近品尝上海本帮菜（如：绿波廊、老饭店）。",
                notes: "上海本帮菜特色是浓油赤酱，口味偏甜。",
              },
            ],
            hotelRecommendations: [
              "上海外滩华尔道夫酒店",
              "上海半岛酒店",
              "上海和平饭店",
              "上海外滩英迪格酒店",
            ],
            restaurantRecommendations: [
              "上海老饭店(南京东路店)",
              "绿波廊(南京东路店)",
              "外滩十六铺豫园店(黄浦店)",
              "南翔馒头店(豫园店)",
            ],
            sightseeingRecommendations: [
              "外滩",
              "南京东路步行街",
              "豫园",
              "陆家嘴观光",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与城市漫步",
            activities: [
              {
                time: "上午",
                activity: `参加 上海马拉松 比赛！`,
                notes: "赛道主要覆盖外滩、南京东路、淮海路等上海精华区域。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择在酒店休息，或前往淮海路/新天地区域轻松逛街。",
                notes: "新天地是上海石库门建筑与现代商业的完美结合。",
              },
              {
                time: "晚餐",
                activity: "在新天地或田子坊附近享用晚餐，品尝各国美食。",
                notes: "此区域餐厅选择多样，从传统到创新应有尽有。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "南麓·浙里(新天地店)",
              "福1039号小馆(田子坊店)",
              "喜粤8号花园餐厅(新天地店)",
              "杏花楼(淮海路店)",
            ],
            sightseeingRecommendations: [
              "上海新天地",
              "田子坊",
              "淮海路商业街",
              "思南公馆",
            ],
          },
          {
            day: 3,
            theme: "艺术人文与告别",
            activities: [
              {
                time: "上午",
                activity:
                  "根据时间和兴趣选择：参观上海博物馆了解中国艺术；或前往上海科技馆探索科学奥秘；或游览静安寺及周边。",
                notes: "上海博物馆周一闭馆，建议提前预约。",
              },
              {
                time: "午餐",
                activity: "在静安区或人民广场附近用餐。",
                notes: "静安区有众多精致餐厅。",
              },
              {
                time: "下午",
                activity:
                  "可选：前往上海迪士尼度假区（需要一整天时间）或环球港购物中心购物；整理行装，适时前往机场/火车站返程。",
              },
            ],
            hotelRecommendations: ["同上或靠近机场/火车站的酒店"],
            restaurantRecommendations: [
              "上海小南国(会展中心店)",
              "鲜饮港式茶餐厅(环球港店)",
              "上海松鹤楼(黄浦店)",
            ],
            sightseeingRecommendations: [
              "上海博物馆",
              "上海科技馆",
              "静安寺",
              "上海迪士尼度假区",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-half",
      name: "上海半程马拉松",
      distance: "半马",
      date: "2025年4月20日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-half.png"),
      routeImage: require("../assets/routeMap/shanghai-half-marathon.png"),
      web: "https://www.shang-ma.com/#/dashboard",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `上海半程马拉松 - 上海2日城市艺术之旅`,
        description: `结合上海半程马拉松，体验上海的艺术与城市魅力。`,
        days: [
          {
            day: 1,
            theme: "抵达与赛前准备",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住推荐酒店（如：上海静安香格里拉大酒店、静安瑞吉酒店等静安区附近酒店）",
                notes: "静安区位置便捷，离赛道不远。",
              },
              {
                time: "傍晚",
                activity:
                  "游览静安寺及周边，或前往上海展览中心（俄罗斯风格建筑）附近漫步。",
                notes: "静安区是上海的文艺中心之一。",
              },
              {
                time: "晚餐",
                activity: "在静安寺商圈用餐，可品尝上海特色菜或国际美食。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "上海静安香格里拉大酒店",
              "静安瑞吉酒店",
              "上海静安JW万豪侯爵酒店",
              "上海安达仕酒店",
            ],
            restaurantRecommendations: [
              "上海老正兴菜馆(南京西路店)",
              "宋园(静安寺店)",
              "新雅粤菜馆(江宁路店)",
            ],
            sightseeingRecommendations: [
              "静安寺",
              "上海展览中心",
              "静安公园",
              "静安嘉里中心",
            ],
          },
          {
            day: 2,
            theme: "半马日与城市艺术",
            activities: [
              {
                time: "上午",
                activity: `参加 上海半程马拉松 比赛！`,
                notes: "赛事多集中在市中心区域。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往苏州河畔的M50创意园区或上海当代艺术博物馆，感受上海的艺术氛围。",
                notes: "M50是上海最知名的艺术区之一。",
              },
              {
                time: "晚餐",
                activity: "在苏州河畔或静安区用餐，之后适时返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上或靠近交通枢纽的酒店"],
            restaurantRecommendations: [
              "鲜粤汇(上海中心店)",
              "甬府(静安寺店)",
              "桃园眷村(南京西路店)",
            ],
            sightseeingRecommendations: [
              "M50创意园",
              "上海当代艺术博物馆",
              "武康路",
              "1933老场坊",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-10k",
      name: "上海10K精英赛",
      distance: "10公里",
      date: "预计2025年10月26日",
      numberOfParticipants: "约7,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-10k.png"),
      routeImage: require("../assets/routeMap/shanghai-10k.jpeg"),
      web: "https://www.shang-ma.com/#/marathon/218/inter",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `上海10K精英赛 - 上海2日闪电游`,
        description: `结合上海10K精英赛，体验上海的现代与传统。`,
        days: [
          {
            day: 1,
            theme: "抵达与赛事准备",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住推荐酒店（如：上海徐家汇凯悦酒店或徐家汇附近酒店）",
                notes: "徐家汇是上海重要商业区，交通便利。",
              },
              {
                time: "傍晚",
                activity: "徐家汇公园慢跑，调整状态。",
                notes: "徐家汇公园有跑道，适合赛前热身。",
              },
              {
                time: "晚餐",
                activity: "在徐家汇商圈用餐，补充能量。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "上海徐家汇凯悦酒店",
              "上海虹桥雅高美爵酒店",
              "上海龙之梦大酒店",
            ],
            restaurantRecommendations: [
              "老卤人家大食堂(美罗城店)",
              "蔡澜港式点心(港汇恒隆店)",
              "南小馆(徐汇店)",
            ],
            sightseeingRecommendations: [
              "徐家汇天主教堂",
              "徐家汇公园",
              "上海体育场",
            ],
          },
          {
            day: 2,
            theme: "10K赛与城市漫步",
            activities: [
              {
                time: "上午",
                activity: `参加 上海10K精英赛 比赛！`,
                notes: "比赛后做好拉伸。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可在上海最繁华的南京西路、淮海中路逛街购物；或前往上海博物馆、上海历史博物馆了解上海历史文化。",
                notes: "",
              },
              {
                time: "晚餐",
                activity: "在人民广场附近享用晚餐，之后适时返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上或靠近人民广场的酒店"],
            restaurantRecommendations: [
              "丰收日(正大广场店)",
              "南麓·浙里(人民广场店)",
              "小南国(黄浦店)",
            ],
            sightseeingRecommendations: [
              "上海博物馆",
              "人民广场",
              "南京路步行街",
              "淮海中路",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-sheshan-half",
      name: "上海佘山半程马拉松",
      distance: "半马",
      date: "2025年04月13日",
      numberOfParticipants: "约8,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-sheshan-half.png"),
      routeImage: require("../assets/routeMap/shanghai-sheshan-half.png"),
      web: "https://www.sj-marathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `佘山半程马拉松 - 上海郊区2日绿色之旅`,
        description: `结合佘山半程马拉松，体验上海西郊的绿色生态与人文景观。`,
        days: [
          {
            day: 1,
            theme: "抵达与赛前准备",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达松江区，入住推荐酒店（如：上海佘山茂御臻品之选酒店、佘山世茂洲际酒店）",
                notes: "佘山地区环境优美，是上海重要的生态区。",
              },
              {
                time: "傍晚",
                activity: "游览佘山国家森林公园，轻松徒步或乘坐索道上山。",
                notes: "佘山是上海最高的山，虽然只有100多米高，但视野开阔。",
              },
              {
                time: "晚餐",
                activity: "在酒店或佘山天主教堂附近用餐。",
                notes: "佘山地区餐厅不多，建议提前规划。",
              },
            ],
            hotelRecommendations: [
              "上海佘山茂御臻品之选酒店",
              "佘山世茂洲际酒店",
              "上海廊下郊野公园度假酒店",
            ],
            restaurantRecommendations: [
              "佘山酒店餐厅",
              "天马山素斋馆",
              "九峰茶社",
            ],
            sightseeingRecommendations: [
              "佘山国家森林公园",
              "佘山天主教堂",
              "月湖雕塑公园",
            ],
          },
          {
            day: 2,
            theme: "佘山半马与人文探索",
            activities: [
              {
                time: "上午",
                activity: `参加 上海佘山半程马拉松 比赛！`,
                notes: "佘山赛道有一定坡度，与平地马拉松不同。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往松江老城区体验历史文化，游览松江方塔、醉白池等古迹；或前往欢乐谷游玩。",
                notes: "松江是上海的历史文化名城。",
              },
              {
                time: "晚餐",
                activity:
                  "在松江老城享用晚餐，品尝松江三白、腌笃鲜等地方特色菜。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上或靠近松江城区的酒店"],
            restaurantRecommendations: [
              "松江鱼圣（老城区店）",
              "旧州客栈",
              "松江名苑",
            ],
            sightseeingRecommendations: [
              "松江方塔园",
              "醉白池",
              "上海欢乐谷",
              "G60科创云廊",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-huangpu-half",
      name: "上海黄浦半程马拉松",
      distance: "半马",
      date: "2025年3月30日",
      numberOfParticipants: "约8,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-huangpu-half.png"),
      routeImage: require("../assets/routeMap/Shanghai-Huangpu-Half-Maratho.jpg"),
      web: "https://huangpu.marathon.org.cn/",
      isCAAcertified: false,
      feature: [
        {
          id: "warning",
          title: "注意⚠️",
          description: "2025年最后的赛道十分狭窄，仿佛在人行道上跑一样",
        },
      ],
      travelPlan: {
        title: `黄浦半程马拉松 - 上海中心城区2日文化探索`,
        description: `结合黄浦半程马拉松，深度体验上海中心城区的历史文化与现代魅力。`,
        days: [
          {
            day: 1,
            theme: "抵达与城市探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住黄浦区酒店（如：上海外滩茂悦大酒店、和平饭店等外滩附近酒店）",
                notes: "黄浦区是上海的行政、金融和文化中心。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步外滩，欣赏黄浦江两岸风光，晚上可观赏陆家嘴灯光秀。",
                notes: "外滩是上海标志性景点。",
              },
              {
                time: "晚餐",
                activity:
                  "在外滩附近用餐，可选择南京东路或福州路上的老字号餐厅。",
                notes: "上海本帮菜推荐：绿波廊、老半斋、老正兴等。",
              },
            ],
            hotelRecommendations: [
              "上海外滩茂悦大酒店",
              "和平饭店",
              "上海半岛酒店",
              "上海外滩华尔道夫酒店",
            ],
            restaurantRecommendations: [
              "绿波廊(南京东路店)",
              "老半斋(南京东路店)",
              "老正兴菜馆(福州路店)",
              "大壶春(四川北路店)",
            ],
            sightseeingRecommendations: [
              "外滩",
              "南京东路步行街",
              "人民广场",
              "黄浦公园",
              "十六铺码头",
            ],
          },
          {
            day: 2,
            theme: "半马日与历史文化",
            activities: [
              {
                time: "上午",
                activity: `参加 上海黄浦半程马拉松 比赛！`,
                notes: "黄浦区赛道平坦，但人流量大，注意安全。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往豫园商城、上海老街体验老上海风情；或前往黄浦区的新兴艺术区如思南公馆、外滩金融中心等。",
                notes: "豫园是上海明清园林代表。",
              },
              {
                time: "晚餐",
                activity:
                  "在豫园或人民广场附近享用晚餐，可品尝南翔小笼包、生煎馒头等上海特色小吃。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "南翔馒头店(豫园店)",
              "上海老饭店(豫园店)",
              "功德林(南京东路店)",
              "松鹤楼(豫园店)",
            ],
            sightseeingRecommendations: [
              "豫园",
              "上海老街",
              "上海城市规划展示馆",
              "思南公馆",
              "中共一大会址",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-changjiang-half",
      name: "上海长江半程马拉松赛",
      distance: "半马",
      date: "2025年3月30日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-yangtze-half.png"),
      routeImage: require("../assets/routeMap/Shanghai-Yangtze-Half-Marathon.jpg"),
      web: "http://www.world550.com/qy/main",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `长江半程马拉松 - 崇明岛2日生态体验之旅`,
        description: `结合上海长江半程马拉松，体验崇明岛的生态环境与湿地风光。`,
        days: [
          {
            day: 1,
            theme: "抵达与崇明生态探索",
            activities: [
              {
                time: "上午",
                activity:
                  "从上海市区出发，经长江隧桥前往崇明岛，入住推荐酒店（如：上海崇明金茂凯悦酒店、崇明东滩鸟类国家级自然保护区生态酒店等）",
                notes: "崇明岛是中国第三大岛，有'长江门户、东海瀛洲'之称。",
              },
              {
                time: "下午",
                activity:
                  "游览崇明东滩湿地公园，欣赏湿地生态和候鸟，或前往前卫生态村体验乡村生活。",
                notes: "崇明以其优质生态环境著称，被誉为'长三角绿肺'。",
              },
              {
                time: "晚餐",
                activity:
                  "在酒店或崇明当地农家乐品尝崇明生态特色菜，如崇明糕、崇明白山羊等。",
                notes: "崇明美食以原生态、绿色健康著称。",
              },
            ],
            hotelRecommendations: [
              "上海崇明金茂凯悦酒店",
              "崇明东滩鸟类国家级自然保护区生态酒店",
              "上海崇明金茂智选假日酒店",
              "东平森林公园度假村",
            ],
            restaurantRecommendations: [
              "生态岛农家乐",
              "崇明糕点博物馆餐厅",
              "崇明长江口渔村",
              "金茂凯悦酒店中餐厅",
            ],
            sightseeingRecommendations: [
              "崇明东滩湿地公园",
              "东平国家森林公园",
              "前卫生态村",
              "崇明西沙湿地",
            ],
          },
          {
            day: 2,
            theme: "长江半马与生态休闲",
            activities: [
              {
                time: "上午",
                activity: `参加 上海长江半程马拉松赛 比赛！`,
                notes: "赛道沿崇明岛生态区域，风景秀丽，空气清新。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择前往明珠湖公园休闲，或体验崇明生态农业采摘（季节性），或参观崇明学宫。",
                notes: "崇明学宫是明清时期的历史建筑，具有文化价值。",
              },
              {
                time: "晚餐",
                activity: "在返回市区前享用当地特色晚餐，尝尝崇明河鲜。",
                notes: "崇明的河鲜以鲜嫩可口著称。",
              },
            ],
            hotelRecommendations: ["同上或返回市区酒店"],
            restaurantRecommendations: [
              "明珠湖农家菜",
              "崇明三湘四海大酒店",
              "东滩渔家乐",
            ],
            sightseeingRecommendations: [
              "明珠湖公园",
              "崇明学宫",
              "瀛东生态园",
              "崇明博物馆",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-jiading-half",
      name: "上海嘉定半程马拉松暨蒸蒸日上迎新跑",
      distance: "半马、5.4公里",
      date: "2025年1月1日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-jiading-half.png"),
      routeImage: require("../assets/routeMap/shanghai-jiading-half.webp"),
      web: "http://runshanghai.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `嘉定半程马拉松 - 上海嘉定2日新年文化之旅`,
        description: `结合上海嘉定半程马拉松暨蒸蒸日上迎新跑，感受新年氛围与嘉定古镇的文化魅力。`,
        days: [
          {
            day: 1,
            theme: "抵达与嘉定古镇探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达嘉定，入住推荐酒店（如：上海嘉定喜来登酒店、嘉定蓝堡公寓酒店等赛道附近酒店）",
                notes: "嘉定区中心靠近赛道起点，选择区中心酒店便于比赛日出行。",
              },
              {
                time: "傍晚",
                activity:
                  "游览嘉定古镇，感受江南水乡风情，参观嘉定孔庙、秋霞圃等古迹。",
                notes: "嘉定古镇历史悠久，是上海保存最完好的古镇之一。",
              },
              {
                time: "晚餐",
                activity: "在嘉定古镇内品尝南翔小笼包等地方特色小吃。",
                notes: "南翔小笼包是嘉定的招牌美食。",
              },
            ],
            hotelRecommendations: [
              "上海嘉定喜来登酒店",
              "嘉定蓝堡公寓酒店",
              "嘉定学府快捷酒店",
              "和颐酒店(上海嘉定新城地铁站店)",
            ],
            restaurantRecommendations: [
              "南翔馒头店(嘉定店)",
              "嘉定老街人家",
              "状元里餐厅",
              "蟹庄溪云",
            ],
            sightseeingRecommendations: [
              "嘉定古镇",
              "嘉定孔庙",
              "秋霞圃",
              "嘉定博物馆",
            ],
          },
          {
            day: 2,
            theme: "新年半马与汽车文化",
            activities: [
              {
                time: "上午",
                activity: `参加 上海嘉定半程马拉松暨蒸蒸日上迎新跑 比赛！`,
                notes: "这是新年第一天的比赛，充满新年祝福与欢庆氛围。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择参观上海汽车博物馆，了解中国汽车工业发展历程；或前往安亭老街感受传统风情。",
                notes: "嘉定是中国汽车工业重镇，汽车博物馆值得一游。",
              },
              {
                time: "晚餐",
                activity: "在嘉定新城享用晚餐，品尝当地特色菜，之后适时返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "锦江之星（嘉定新城店）",
              "嘉定壹品坊",
              "嘉定老街面馆",
              "云湖会所",
            ],
            sightseeingRecommendations: [
              "上海汽车博物馆",
              "安亭老街",
              "马陆葡萄园",
              "嘉定新城规划馆",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-fengxian-half",
      name: "上海奉贤海湾森林半程马拉松赛",
      distance: "半马",
      date: "2024年11月24日",
      numberOfParticipants: "约4,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-fengxian-half.png"),
      routeImage: require("../assets/routeMap/shanghai-fengxian-half.webp"),
      web: null,
      isCAAcertified: false,
      travelPlan: {
        title: `奉贤海湾森林半程马拉松 - 上海奉贤2日海滨生态之旅`,
        description: `结合奉贤海湾森林半程马拉松，体验上海南部海湾风光与生态环境。`,
        days: [
          {
            day: 1,
            theme: "抵达与海湾探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达奉贤，入住海湾旅游区附近酒店（如：上海碧海金沙酒店、上海茉莉海岸酒店等海湾赛道附近酒店）",
                notes: "海湾森林公园是马拉松起点，选择附近酒店便于第二天参赛。",
              },
              {
                time: "傍晚",
                activity:
                  "游览海湾国家森林公园，感受滨海生态景观，适当放松身心为第二天比赛做准备。",
                notes: "公园内有多样的植被和湿地景观。",
              },
              {
                time: "晚餐",
                activity: "在海湾旅游区品尝海鲜特色菜肴。",
                notes: "奉贤海湾以新鲜海鲜著称。",
              },
            ],
            hotelRecommendations: [
              "上海碧海金沙酒店",
              "上海茉莉海岸酒店",
              "上海东方假日酒店",
              "上海海湾壹号公寓酒店",
            ],
            restaurantRecommendations: [
              "碧海金沙海鲜城",
              "奉贤东海渔村",
              "好望角海鲜餐厅",
              "月亮湾酒家",
            ],
            sightseeingRecommendations: [
              "海湾国家森林公园",
              "碧海金沙沙滩",
              "东方假日田园",
              "奉贤海湾旅游区",
            ],
          },
          {
            day: 2,
            theme: "半马日与休闲体验",
            activities: [
              {
                time: "上午",
                activity: `参加 奉贤海湾森林半程马拉松赛 比赛！`,
                notes: "赛道平坦，风景优美，沿途可欣赏海湾风光。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可前往碧海金沙沙滩休闲，享受阳光沙滩；或参观东方假日田园，体验田园风光。",
                notes: "秋季的碧海金沙人少景美。",
              },
              {
                time: "晚餐",
                activity: "在返回市区路上或市区享用晚餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上或返回市区酒店"],
            restaurantRecommendations: [
              "金汇海鲜排挡",
              "九棵树农家乐",
              "金海湾大酒店餐厅",
            ],
            sightseeingRecommendations: [
              "碧海金沙沙滩",
              "上海之鱼生态园",
              "古华公园",
              "奉贤博物馆",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-women-half-2024",
      name: "上海女子半程马拉松赛",
      distance: "半马、5公里",
      date: "2024年3月10日",
      numberOfParticipants: "约5,800人",
      image: require("../assets/pictures/MarathonPicture/shanghai-women-half.png"),
      routeImage: require("../assets/routeMap/shanghai-woman-half.jpeg"),
      web: "https://www.shang-ma.com/#/marathon/220/inter",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: `上海女子半程马拉松 - 上海2日魅力淑女之旅`,
        description: `结合上海女子半程马拉松，打造一场专属于女性的轻松愉悦之旅。`,
        days: [
          {
            day: 1,
            theme: "抵达与城市休闲",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住浦东陆家嘴或世纪公园附近酒店（如：上海浦东嘉里大酒店、上海东锦江希尔顿逸林酒店等赛道附近酒店）",
                notes:
                  "世纪公园是女子马拉松的起点区域，住在附近方便比赛日出行。",
              },
              {
                time: "傍晚",
                activity:
                  "在世纪公园轻松散步，欣赏公园美景，为次日马拉松做准备；或前往上海新国际博览中心附近的正大广场购物休闲。",
                notes: "世纪公园环境优美，适合赛前放松。",
              },
              {
                time: "晚餐",
                activity:
                  "在陆家嘴或正大广场享用健康晚餐，为明天的比赛补充能量。",
                notes: "记得多补充碳水化合物。",
              },
            ],
            hotelRecommendations: [
              "上海浦东嘉里大酒店",
              "上海东锦江希尔顿逸林酒店",
              "上海世纪公园假日酒店",
              "上海金茂君悦大酒店",
            ],
            restaurantRecommendations: [
              "元気寿司（正大广场店）",
              "绿茵阁（世纪公园店）",
              "老乡鸡（浦东嘉里城店）",
              "新元素餐厅（嘉里大酒店）",
            ],
            sightseeingRecommendations: [
              "世纪公园",
              "陆家嘴中心绿地",
              "正大广场",
              "上海环球金融中心",
            ],
          },
          {
            day: 2,
            theme: "女子半马与休闲SPA",
            activities: [
              {
                time: "上午",
                activity: `参加 上海女子半程马拉松赛 比赛！`,
                notes: "这是专为女性设计的赛事，赛道平坦，沿途风景优美。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择在酒店SPA中心享受专业的按摩服务；或前往陆家嘴商圈购物，在国金中心、正大广场等地尽情享受购物乐趣。",
                notes: "赛后SPA有助于肌肉恢复。",
              },
              {
                time: "晚餐",
                activity: "在浦东滨江或小陆家嘴美食广场享用晚餐，庆祝完赛。",
                notes: "可以选择江景餐厅，欣赏黄浦江夜景。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "Mr & Mrs Bund（外滩店）",
              "金轩中餐厅（金茂君悦酒店）",
              "田舍家（正大广场店）",
              "小陆家嘴美食城",
            ],
            sightseeingRecommendations: [
              "东方明珠",
              "上海中心",
              "上海科技馆",
              "滨江大道",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-bayarea-half",
      name: "上海湾区半程马拉松赛",
      distance: "半马、3.5公里",
      date: "2025年3月16日",
      numberOfParticipants: "约4,800人",
      image: require("../assets/pictures/MarathonPicture/shanghai-bayarea-half.png"),
      routeImage: require("../assets/routeMap/shanghai-bayarea-half.jpg"),
      web: "https://www.shanghai.gov.cn/cmsres/27/274e3fdf53264bed89cb76ff4e8ce311/4159d68c167dff3d0245f29507527794.jpg",
      isCAAcertified: false,
      travelPlan: {
        title: `上海湾区半程马拉松 - 上海临港2日科技与海湾体验`,
        description: `结合上海湾区半程马拉松，探索上海临港新片区的科技魅力与海湾风情。`,
        days: [
          {
            day: 1,
            theme: "抵达与湾区探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海临港新片区，入住推荐酒店（如：上海临港豪生大酒店、上海临港喜来登酒店等新片区酒店）",
                notes:
                  "临港新片区是上海自贸区新片区，也是湾区马拉松赛道所在地。",
              },
              {
                time: "傍晚",
                activity:
                  "游览滴水湖公园，欣赏上海最大人工湖的美景，或沿着海湾漫步，感受海风。",
                notes: "滴水湖是临港新城的标志性景点。",
              },
              {
                time: "晚餐",
                activity: "在临港万达广场或滴水湖商业区用餐。",
                notes: "临港新城餐饮选择较为丰富。",
              },
            ],
            hotelRecommendations: [
              "上海临港豪生大酒店",
              "上海临港喜来登酒店",
              "上海东荟城智选假日酒店",
              "南汇嘴假日酒店",
            ],
            restaurantRecommendations: [
              "渔纳百川(临港店)",
              "海湾渔村(临港店)",
              "唐宫(临港万达店)",
              "季季红(临港店)",
            ],
            sightseeingRecommendations: [
              "滴水湖",
              "上海天文馆",
              "上海海昌海洋公园",
              "芦潮港海滨",
            ],
          },
          {
            day: 2,
            theme: "湾区半马与科技体验",
            activities: [
              {
                time: "上午",
                activity: `参加 上海湾区半程马拉松赛 比赛！`,
                notes: "临港新城赛道平坦，沿途有湖景和海景。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择参观上海天文馆，这是全球最大的天文馆；或前往上海海昌海洋公园，体验海洋主题乐园的乐趣。",
                notes: "天文馆需要提前预约。",
              },
              {
                time: "晚餐",
                activity: "在返回市区的路上或市区用餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上或返回市区酒店"],
            restaurantRecommendations: [
              "临港海鲜大排档",
              "上海天文馆餐厅",
              "海昌海洋公园餐厅",
              "临港万达广场餐厅",
            ],
            sightseeingRecommendations: [
              "上海天文馆",
              "临港重装备产业园",
              "上海电影博物馆",
              "洋山深水港",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-suzhou-half",
      name: "上海苏州河半程马拉松赛",
      distance: "半马",
      date: "2025年3月23日",
      numberOfParticipants: "约7,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-suzhou-half.png"),
      routeImage: require("../assets/routeMap/shanghai-suzhou-half.jpeg"),
      web: "https://www.shang-ma.com/#/marathon/221/inter",
      isCAAcertified: false,
      travelPlan: {
        title: `苏州河半程马拉松 - 上海苏河两岸2日文艺之旅`,
        description: `结合上海苏州河半程马拉松，探索苏州河两岸的历史文化与创意艺术。`,
        days: [
          {
            day: 1,
            theme: "抵达与苏河漫步",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住推荐酒店（如：上海静安香格里拉大酒店、上海璞丽酒店等靠近苏州河的酒店）",
                notes: "选择苏州河沿线的酒店，便于第二天参赛。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步苏州河滨河步道，感受河岸景观；或前往M50创意园，体验上海的艺术氛围。",
                notes: "苏州河是上海的母亲河，历史悠久。",
              },
              {
                time: "晚餐",
                activity: "在1933老场坊或苏河湾附近享用晚餐。",
                notes: "1933老场坊是改造的历史建筑，充满文艺气息。",
              },
            ],
            hotelRecommendations: [
              "上海静安香格里拉大酒店",
              "上海璞丽酒店",
              "上海外滩英迪格酒店",
              "上海建业里嘉佩乐酒店",
            ],
            restaurantRecommendations: [
              "1933美食空间",
              "小绍兴餐厅",
              "海上捞瓷",
              "福1039号小馆",
            ],
            sightseeingRecommendations: [
              "M50创意园",
              "1933老场坊",
              "苏州河滨河步道",
              "上海邮政博物馆",
            ],
          },
          {
            day: 2,
            theme: "苏河半马与历史探索",
            activities: [
              {
                time: "上午",
                activity: `参加 上海苏州河半程马拉松赛 比赛！`,
                notes: "赛道沿苏州河岸，穿过众多历史地标。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择参观上海犹太难民纪念馆（原虹口犹太区），了解上海独特的历史；或前往多伦路文化名人街，体验上海文化底蕴。",
                notes: "上海是二战时期接纳犹太难民最多的城市之一。",
              },
              {
                time: "晚餐",
                activity: "在外滩附近享用晚餐，欣赏黄浦江夜景，之后适时返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "外滩三号",
              "望江门(吴淞路店)",
              "南翔馒头店(四川北路店)",
              "上海老饭店(南京东路店)",
            ],
            sightseeingRecommendations: [
              "上海犹太难民纪念馆",
              "多伦路文化街",
              "苏州河源头公园",
              "大昌行公寓",
            ],
          },
        ],
      },
    },
    {
      id: "shanghai-jingan-half",
      name: "上海静安半程马拉松赛",
      distance: "半马、5公里",
      date: "2025年3月16日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/shanghai-jingan-half.jpeg"),
      routeImage: require("../assets/routeMap/shanghai-jingan-half.jpeg"),
      web: "https://mp.weixin.qq.com/s/v3Kn1y1bIr65H5HtmyGMiQ",
      isCAAcertified: false,
      travelPlan: {
        title: `静安半程马拉松 - 上海静安2日文化休闲之旅`,
        description: `结合上海静安半程马拉松，探索上海静安区的历史人文与时尚风情。`,
        days: [
          {
            day: 1,
            theme: "抵达与静安漫步",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达上海，入住推荐酒店（如：上海静安瑞吉酒店、上海静安JW万豪侯爵酒店等静安寺附近酒店）",
                notes:
                  "静安寺附近是静安马拉松的起点区域，选择此区域酒店便于比赛日出行。",
              },
              {
                time: "傍晚",
                activity:
                  "游览静安寺，感受历史与现代交融的氛围；或在南京西路商圈购物休闲。",
                notes: "静安寺是上海著名的历史文化地标。",
              },
              {
                time: "晚餐",
                activity: "在静安寺商圈或静安嘉里中心品尝美食。",
                notes: "此区域国际化餐厅选择丰富。",
              },
            ],
            hotelRecommendations: [
              "上海静安瑞吉酒店",
              "上海静安JW万豪侯爵酒店",
              "上海静安香格里拉大酒店",
              "上海中谷小南国花园酒店",
            ],
            restaurantRecommendations: [
              "新斋上海菜",
              "唐宫小聚(静安嘉里中心店)",
              "小绍兴(西康路店)",
              "福1088号",
            ],
            sightseeingRecommendations: [
              "静安寺",
              "静安公园",
              "静安嘉里中心",
              "武康路",
            ],
          },
          {
            day: 2,
            theme: "静安半马与人文探索",
            activities: [
              {
                time: "上午",
                activity: `参加 上海静安半程马拉松赛 比赛！`,
                notes: "赛道途经静安区多个地标性建筑。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可选择参观上海展览中心（原中苏友好大厦），欣赏苏式建筑风格；或前往武康路，感受上海老洋房的魅力。",
                notes: "上海展览中心是典型的苏联古典主义建筑。",
              },
              {
                time: "晚餐",
                activity: "在兴业太古汇或静安寺商圈享用晚餐，之后适时返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "新元素西餐厅(静安JW万豪)",
              "壹零捌坊",
              "家全七福(静安寺店)",
              "梧桐(武康路店)",
            ],
            sightseeingRecommendations: [
              "上海展览中心",
              "武康路",
              "多伦路文化街",
              "上海自然博物馆",
            ],
          },
        ],
      },
    },
  ],

  // 广州的马拉松赛事
  guangzhou: [
    {
      id: "guangzhou-marathon",
      name: "广州马拉松",
      distance: "全马",
      date: "2024年12月08日",
      numberOfParticipants: "约26,000人",
      image: require("../assets/pictures/MarathonPicture/guangzhou-marathon.png"),
      routeImage: require("../assets/routeMap/guangzhou-marathon.jpg"),
      web: "http://www.guangzhou-marathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "广州马拉松 - 广州3日文化与城市体验",
        description:
          "结合广州马拉松，深度感受广州的城市文化与美食，领略珠江夜景与岭南风情。",
        days: [
          {
            day: 1,
            theme: "抵达与城市初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达广州，入住天汇大酒店或广州塔附近酒店（如：广州塔希尔顿酒店）。",
                notes: "建议选择靠近赛事起点的酒店，方便赛事当天出行。",
              },
              {
                time: "傍晚",
                activity: "游览广州塔（小蛮腰），登塔俯瞰珠江夜景。",
                notes: "广州塔的夜景非常美丽，是广州的标志性建筑之一。",
              },
              {
                time: "晚餐",
                activity:
                  "在广州塔附近的餐厅享用晚餐，推荐尝试广东菜，如烧鹅、白切鸡。",
                notes: "广州的餐饮文化丰富多样，可以尝试传统的粤菜。",
              },
            ],
            hotelRecommendations: [
              "广州塔希尔顿酒店",
              "天汇大酒店",
              "广州万豪酒店",
            ],
            restaurantRecommendations: [
              "广州塔旋转餐厅",
              "广州酒家",
              "陶陶居(广州塔店)",
            ],
            sightseeingRecommendations: ["广州塔", "珠江夜游", "上下九步行街"],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 广州马拉松 比赛！",
                notes: "提前了解比赛路线和起点，确保顺利参与。",
              },
              {
                time: "下午",
                activity: "赛后休整，推荐前往陈家祠，领略岭南建筑艺术。",
                notes: "陈家祠保存完好，是广州传统文化的代表之一。",
              },
              {
                time: "晚餐",
                activity: "在上下九步行街尝试广州传统小吃，如肠粉、云吞面。",
                notes: "这里的小吃店非常多，口味地道。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "上下九步行街的小吃店",
              "餐馆：新荔枝湾小吃",
            ],
            sightseeingRecommendations: [
              "陈家祠",
              "广州博物馆",
              "上下九步行街",
            ],
          },
          {
            day: 3,
            theme: "历史文化与购物体验",
            activities: [
              {
                time: "上午",
                activity: "参观广州历史博物馆，了解广州的悠久历史和文化。",
                notes:
                  "广州博物馆展览内容丰富，可以更好地了解这座城市的历史底蕴。",
              },
              {
                time: "午餐",
                activity:
                  "在广州塔附近享用早午餐，或者在天汇大酒店内的自助餐厅用餐。",
                notes: "餐厅内的菜品丰富，可以选择享用广东特色的点心。",
              },
              {
                time: "下午",
                activity:
                  "前往广州的购物中心，如天汇大厦、太古汇等，体验现代都市的购物氛围。",
                notes: "天汇大厦提供高端购物体验，也可购买纪念品。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["广州塔餐厅", "天汇大厦内的餐厅"],
            sightseeingRecommendations: [
              "广州历史博物馆",
              "天汇大厦",
              "太古汇",
            ],
          },
        ],
      },
    },
    {
      id: "guangzhou-half-marathon",
      name: "广州黄埔马拉松",
      distance: "全程、半程、5公里",
      date: "2024年12月22日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/guangzhou-huangpu-marathon.png"),
      routeImage: require("../assets/routeMap/guangzhou-huangpu-marathon.webp"),
      web: "http://www.hp-marathon.com/",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "广州黄埔马拉松 - 黄埔3日历史与现代融合之旅",
        description:
          "结合广州黄埔马拉松，深入了解广州黄埔的历史文化与现代化建设。",
        days: [
          {
            day: 1,
            theme: "抵达与黄埔历史",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达广州，入住黄埔区附近的酒店（如：广州黄埔酒店或黄埔建业酒店）。",
                notes: "黄埔区的酒店选择较为集中，适合赛事当天的出行。",
              },
              {
                time: "傍晚",
                activity: "参观黄埔军校，了解中国近代历史上的重要地标。",
                notes: "黄埔军校是中国革命的重要历史遗址，值得一游。",
              },
              {
                time: "晚餐",
                activity: "在黄埔区品尝广东传统美食，如黄埔小炒、烧肉。",
                notes: "黄埔区有许多本地的餐馆，地道的粤菜不可错过。",
              },
            ],
            hotelRecommendations: ["广州黄埔酒店", "黄埔建业酒店"],
            restaurantRecommendations: ["黄埔小炒餐厅", "本地烧腊店"],
            sightseeingRecommendations: [
              "黄埔军校",
              "黄埔文化园",
              "广州国际灯光节",
            ],
          },
          {
            day: 2,
            theme: "黄埔马拉松日与城市体验",
            activities: [
              {
                time: "上午",
                activity: "参加 广州黄埔马拉松 比赛！",
                notes: "赛事起终点较为接近，可以提前规划好交通。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以前往广州塔或海珠湖公园享受休闲时光。",
                notes: "广州塔和海珠湖是当地非常适合放松的景点。",
              },
              {
                time: "晚餐",
                activity: "在珠江新城附近的餐厅尝试广式早茶，经典粤式点心等。",
                notes: "珠江新城的餐厅选择丰富，非常适合品尝正宗广东茶点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["珠江新城的茶楼", "地道的早茶店"],
            sightseeingRecommendations: ["广州塔", "海珠湖公园", "珠江夜游"],
          },
          {
            day: 3,
            theme: "现代都市与购物",
            activities: [
              {
                time: "上午",
                activity: "参观广州国际会展中心，感受现代广州的商业氛围。",
                notes: "广州会展中心是国内外大规模展览会的主场地。",
              },
              {
                time: "午餐",
                activity: "在会展中心附近的餐厅或商业区用餐。",
                notes: "附近有许多商场和餐饮区域，适合购物和就餐。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes:
                  "广州的公共交通非常便利，可以直接乘地铁或打车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "广州国际会展中心餐厅",
              "周边商业区餐饮",
            ],
            sightseeingRecommendations: [
              "广州国际会展中心",
              "天汇大厦",
              "花城广场",
            ],
          },
        ],
      },
    },
    {
      id: "guangzhou-bayarea-half-marathon",
      name: "广州南沙（湾区）半程马拉松赛",
      distance: "半程、5公里",
      date: "2024年12月01日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/guangzhou-nansha-half.jpeg"),
      routeImage: require("../assets/routeMap/guangzhou-nansha-half.webp"),
      web: "https://nsmls.gusto.cn/",
      isCAAcertified: false,
      travelPlan: {
        title: "广州南沙湾区马拉松 - 现代城市与湾区之旅",
        description:
          "结合广州南沙马拉松，领略广州南沙湾区现代化的港口与城市建设。",
        days: [
          {
            day: 1,
            theme: "抵达与湾区探索",
            activities: [
              {
                time: "下午",
                activity: "抵达广州南沙，入住南沙万达文华酒店或南沙洲际酒店。",
                notes: "南沙地区较为现代化，有不少高端酒店，适合赛事期间住宿。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步南沙港或参观南沙海滨公园，感受现代化城市与自然的和谐融合。",
                notes: "南沙有许多滨海景点，景色宜人。",
              },
              {
                time: "晚餐",
                activity: "在南沙港区尝试海鲜或现代融合菜肴。",
                notes: "南沙的海鲜非常新鲜，可以尝试当地特色菜肴。",
              },
            ],
            hotelRecommendations: ["南沙万达文华酒店", "南沙洲际酒店"],
            restaurantRecommendations: ["南沙海鲜餐厅", "南沙港的餐馆"],
            sightseeingRecommendations: [
              "南沙海滨公园",
              "南沙港",
              "南沙天后宫",
            ],
          },
          {
            day: 2,
            theme: "南沙半马赛事与休闲",
            activities: [
              {
                time: "上午",
                activity: "参加 广州南沙（湾区）半程马拉松赛！",
                notes: "赛事路线环绕湾区，体验现代港口和城市景观。",
              },
              {
                time: "下午",
                activity:
                  "赛后休整，可以在南沙旅游区逛街，或参观广州南沙大剧院。",
                notes: "南沙大剧院是广州的文化地标之一，值得一游。",
              },
              {
                time: "晚餐",
                activity: "在南沙购物中心附近用餐，尝试特色餐厅。",
                notes: "南沙商业区有许多餐饮选择。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["南沙购物中心餐厅", "南沙港的风味餐厅"],
            sightseeingRecommendations: ["南沙大剧院", "南沙滨海公园"],
          },
          {
            day: 3,
            theme: "湾区现代与返程",
            activities: [
              {
                time: "上午",
                activity: "参观南沙天后宫，了解广州的历史文化。",
                notes: "南沙天后宫是当地著名的历史景点。",
              },
              {
                time: "午餐",
                activity: "在南沙大厦或商圈附近的餐厅用餐。",
                notes: "可以品尝本地海鲜或粤式早茶。",
              },
              {
                time: "下午",
                activity: "整理行装，适时返回广州或前往机场返程。",
                notes: "南沙区域交通便利，可以直接前往广州的其他景点或机场。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["南沙餐厅", "南沙大厦餐饮区"],
            sightseeingRecommendations: ["南沙天后宫", "南沙湾"],
          },
        ],
      },
    },
    {
      id: "guangzhou-women-half-marathon",
      name: "2025粤港澳大湾区女子半程马拉松",
      distance: "半程、6公里",
      date: "2025年1月1日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/guangzhou-bayarea-women-half.png"),
      routeImage: require("../assets/routeMap/guangzhou-bayarea-women-half.jpg"),
      web: "http://marathon.zengcheng.gov.cn/index.html",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "粤港澳大湾区女子半程马拉松 - 女性专属的三日都市与休闲之旅",
        description:
          "结合粤港澳大湾区女子半程马拉松，为女性跑者定制的专属旅行，尽情享受都市生活与自然风光。",
        days: [
          {
            day: 1,
            theme: "抵达与大湾区体验",
            activities: [
              {
                time: "下午",
                activity: "抵达广州，入住天汇酒店或天汇大厦附近的酒店。",
                notes: "酒店附近有购物中心，适合女性跑者休息和放松。",
              },
              {
                time: "傍晚",
                activity: "参观珠江新城，沿珠江漫步，欣赏广州的天际线。",
                notes: "珠江新城是广州最现代化的商业中心之一，适合晚间散步。",
              },
              {
                time: "晚餐",
                activity: "在珠江新城的高端餐厅享用晚餐。",
                notes: "可以选择风景优美的餐厅，边用餐边欣赏珠江夜景。",
              },
            ],
            hotelRecommendations: ["天汇酒店", "天汇大厦附近酒店"],
            restaurantRecommendations: ["珠江新城餐厅", "广州塔餐厅"],
            sightseeingRecommendations: ["珠江新城", "珠江夜游"],
          },
          {
            day: 2,
            theme: "女子半马赛事与放松",
            activities: [
              {
                time: "上午",
                activity: "参加 粤港澳大湾区女子半程马拉松！",
                notes: "赛事为女性专设，赛道平坦，氛围友好。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，推荐前往广州花城广场或天汇大厦购物中心体验购物。",
                notes: "购物中心内有丰富的品牌和女性服饰选择。",
              },
              {
                time: "晚餐",
                activity: "在花城广场附近选择精致餐厅，享受温馨的晚餐。",
                notes: "这里有不少时尚餐厅，适合放松享用美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["花城广场餐厅", "时尚餐厅"],
            sightseeingRecommendations: ["花城广场", "天汇大厦"],
          },
          {
            day: 3,
            theme: "珠江风光与返程",
            activities: [
              {
                time: "上午",
                activity: "参观广州花园酒店附近的花园或游览广州博物馆。",
                notes: "花园酒店周边绿树成荫，适合散步。",
              },
              {
                time: "午餐",
                activity: "在酒店或博物馆附近用餐，体验粤式风味。",
                notes: "广州博物馆内有丰富的文化展览，适合参观。",
              },
              {
                time: "下午",
                activity: "整理行装，前往机场或火车站返程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["广州博物馆餐厅", "附近餐饮区"],
            sightseeingRecommendations: ["广州博物馆", "花园酒店"],
          },
        ],
      },
    },
  ],

  // 天津的马拉松赛事
  tianjin: [
    {
      id: "tianjin-marathon",
      name: "天津马拉松",
      distance: "全马，半程，5公里",
      date: "预计2025年10月中旬",
      numberOfParticipants: "约33,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-marathon.jpeg"),
      routeImage: require("../assets/routeMap/tianjn-marathon.jpg"),
      web: "http://www.tianjin-marathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "天津马拉松 - 天津3日城市文化之旅",
        description:
          "结合天津马拉松，探索这座拥有百年历史的城市，品味美食与古建筑。",
        days: [
          {
            day: 1,
            theme: "抵达与古文化街",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达天津，入住市中心或津南区的酒店（如：天津希尔顿酒店、天津万达文华酒店）。",
                notes: "选择靠近比赛起点的酒店，便于赛事当天出行。",
              },
              {
                time: "傍晚",
                activity: "参观天津古文化街，感受天津的历史氛围。",
                notes:
                  "古文化街是天津的文化名片，充满了地方特色的店铺和古建筑。",
              },
              {
                time: "晚餐",
                activity:
                  "在古文化街附近尝试天津的传统美食，如狗不理包子、天津麻花等。",
                notes: "天津的传统小吃不容错过，尤其是狗不理包子。",
              },
            ],
            hotelRecommendations: [
              "天津希尔顿酒店",
              "天津万达文华酒店",
              "天津滨海国际酒店",
            ],
            restaurantRecommendations: [
              "狗不理包子(古文化街店)",
              "耳朵眼炸糕(古文化街店)",
              "天津麻花(王府井店)",
            ],
            sightseeingRecommendations: [
              "天津古文化街",
              "天津之眼(摩天轮)",
              "意式风情区",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与城市体验",
            activities: [
              {
                time: "上午",
                activity: "参加 天津马拉松 比赛！",
                notes: "提前了解比赛路线和起点，确保顺利参与。",
              },
              {
                time: "下午",
                activity: "赛后放松，推荐参观天津博物馆或天津自然博物馆。",
                notes: "天津博物馆是了解这座城市历史与文化的好地方。",
              },
              {
                time: "晚餐",
                activity: "前往天津滨海新区，尝试滨海的海鲜或其他地方美食。",
                notes: "滨海新区拥有许多餐厅，海鲜尤为推荐。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["滨海新区海鲜餐厅", "意式风情区餐厅"],
            sightseeingRecommendations: [
              "天津博物馆",
              "天津自然博物馆",
              "天津之眼",
            ],
          },
          {
            day: 3,
            theme: "现代都市与购物",
            activities: [
              {
                time: "上午",
                activity: "参观天津的购物中心，如津塔、天津大悦城。",
                notes: "这些购物中心提供丰富的购物和娱乐体验。",
              },
              {
                time: "午餐",
                activity: "在天津大悦城或附近餐厅享用午餐。",
                notes: "餐厅选择丰富，适合购物后休息。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes:
                  "北京的公共交通非常便利，可以直接乘地铁或打车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["天津大悦城餐厅", "滨海新区海鲜餐厅"],
            sightseeingRecommendations: ["天津大悦城", "津塔", "意式风情区"],
          },
        ],
      },
    },
    {
      id: "tianjin-tb-lake-half-marathon",
      name: "天津团泊湖半程马拉松",
      distance: "半程、4公里",
      date: "2025年9月21日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-tuanbo-half.jpeg"),
      routeImage: require("../assets/routeMap/tianjin-tuanbo-half.webp"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "天津团泊湖半程马拉松 - 湖泊与自然的三日休闲之旅",
        description:
          "结合天津团泊湖半程马拉松，体验湖泊自然风光与宁静的生活氛围。",
        days: [
          {
            day: 1,
            theme: "抵达与团泊湖散步",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达天津，入住团泊湖附近的酒店（如：天津团泊湖度假村）。",
                notes: "选择靠近赛事起点的酒店，方便比赛日出行。",
              },
              {
                time: "傍晚",
                activity: "前往团泊湖周围散步，感受自然和宁静的湖区环境。",
                notes: "团泊湖是天津著名的湿地，景色宜人。",
              },
              {
                time: "晚餐",
                activity: "在团泊湖周围的餐厅享用晚餐，推荐尝试天津特色菜。",
                notes: "可以品尝当地的水产和其他地方特色美食。",
              },
            ],
            hotelRecommendations: ["天津团泊湖度假村", "天津海河大厦酒店"],
            restaurantRecommendations: ["团泊湖餐厅", "天津传统餐馆"],
            sightseeingRecommendations: ["团泊湖", "海河", "天津欢乐谷"],
          },
          {
            day: 2,
            theme: "半马赛事与放松",
            activities: [
              {
                time: "上午",
                activity: "参加 天津团泊湖半程马拉松！",
                notes: "提前了解比赛路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity: "赛后可以前往天津的自然景区，如滨海新区的海滨公园。",
                notes: "滨海新区的海滨公园是放松身心的好地方。",
              },
              {
                time: "晚餐",
                activity: "在滨海新区或市区的餐厅享用晚餐。",
                notes: "可以尝试天津海鲜或传统粤菜。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["滨海新区海鲜餐厅", "天津传统餐馆"],
            sightseeingRecommendations: ["滨海新区", "海滨公园", "天津欢乐谷"],
          },
          {
            day: 3,
            theme: "现代城市与购物",
            activities: [
              {
                time: "上午",
                activity: "参观天津的购物中心，如津塔、天津大悦城。",
                notes: "这些购物中心提供丰富的购物和娱乐体验。",
              },
              {
                time: "午餐",
                activity: "在购物中心附近的餐厅用餐。",
                notes: "购物中心内餐饮选择丰富，适合购物后休息。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "天津的交通非常便利，可以使用地铁或出租车。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["天津大悦城餐厅", "滨海新区餐厅"],
            sightseeingRecommendations: ["天津大悦城", "津塔", "海滨公园"],
          },
        ],
      },
    },
    {
      id: "tianjin-jinnan-half-marathon",
      name: "天津津南半程马拉松",
      distance: "半程、5公里",
      date: "2025年4月20日",
      numberOfParticipants: "约6,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-jinnan-half.png"),
      routeImage: require("../assets/routeMap/tianjin-jinnan-half.jpg"),
      web: null,
      isCAAcertified: false,
      travelPlan: {
        title: "天津津南半程马拉松 - 城市与自然的二日体验",
        description:
          "结合天津津南半程马拉松，享受天津城区的现代化和郊区的自然景观。",
        days: [
          {
            day: 1,
            theme: "抵达与城市探索",
            activities: [
              {
                time: "下午",
                activity: "抵达天津，入住市区酒店（如：天津金茂大酒店）。",
                notes: "选择市中心的酒店，便于参与赛事。",
              },
              {
                time: "傍晚",
                activity: "参观天津之眼，感受天津的现代城市景观。",
                notes: "天津之眼是天津的标志性摩天轮，可以俯瞰全市。",
              },
              {
                time: "晚餐",
                activity: "在天津市中心享用晚餐，推荐尝试天津传统的夜市美食。",
                notes: "天津的夜市充满活力，可以尝试各种传统小吃。",
              },
            ],
            hotelRecommendations: ["天津金茂大酒店", "天津万丽酒店"],
            restaurantRecommendations: ["天津传统夜市", "高端餐厅(天津市中心)"],
            sightseeingRecommendations: [
              "天津之眼",
              "天津博物馆",
              "意式风情区",
            ],
          },
          {
            day: 2,
            theme: "半马赛事与休闲",
            activities: [
              {
                time: "上午",
                activity: "参加 天津津南半程马拉松！",
                notes: "提前熟悉赛道，确保比赛当天顺利参赛。",
              },
              {
                time: "下午",
                activity: "赛后可以前往天津南湖公园或市区散步，放松身心。",
                notes: "南湖公园是放松和散步的好地方。",
              },
              {
                time: "晚餐",
                activity: "在市区餐厅享用晚餐，品尝天津的特色菜。",
                notes: "推荐尝试天津的扒肋排、海鲜等菜肴。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["天津南湖公园餐厅", "市中心餐馆"],
            sightseeingRecommendations: [
              "南湖公园",
              "天津博物馆",
              "意式风情区",
            ],
          },
        ],
      },
    },
    {
      id: "tianjin-ninghe-qilihai-half-marathon",
      name: "天津·宁河七里海半程马拉松",
      distance: "半程、5公里",
      date: "2025年4月20日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-ninghe-half.jpeg"),
      routeImage: require("../assets/routeMap/tianjin-ninghe-half.png"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "天津·宁河七里海半程马拉松 - 自然与乡村体验",
        description:
          "结合宁河七里海半程马拉松，探索天津远郊的自然景观与乡村风光。",
        days: [
          {
            day: 1,
            theme: "抵达与乡村风光",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达天津，入住宁河区附近酒店（如：宁河七里海度假村）。",
                notes: "选择靠近赛事起点的酒店，便于第二天赛事出行。",
              },
              {
                time: "傍晚",
                activity: "参观七里海湿地公园，感受自然湿地的美丽与宁静。",
                notes: "七里海是天津重要的湿地保护区，非常适合徒步和放松。",
              },
              {
                time: "晚餐",
                activity:
                  "在七里海附近的餐厅享用晚餐，推荐尝试当地的水产和乡村菜肴。",
                notes: "七里海周边的餐馆提供新鲜的水产和地方特色美食。",
              },
            ],
            hotelRecommendations: ["宁河七里海度假村", "宁河国际大酒店"],
            restaurantRecommendations: ["七里海餐厅", "本地农家乐"],
            sightseeingRecommendations: ["七里海湿地公园", "宁河老街"],
          },
          {
            day: 2,
            theme: "赛事与自然体验",
            activities: [
              {
                time: "上午",
                activity: "参加 天津·宁河七里海半程马拉松！",
                notes: "提前了解赛事路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity: "赛后可以前往天津东丽湖，享受自然湖泊景色。",
                notes: "东丽湖是天津的一个大湖泊，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity: "返回市区或在东丽湖周边的餐厅享用晚餐。",
                notes: "可以尝试天津传统菜肴或东丽湖附近的海鲜餐厅。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["东丽湖餐厅", "市区餐厅"],
            sightseeingRecommendations: ["东丽湖", "东丽公园"],
          },
          {
            day: 3,
            theme: "返程与休闲",
            activities: [
              {
                time: "上午",
                activity:
                  "参观宁河的农村文化展览或小镇景点，感受宁静的乡村生活。",
                notes: "可以参观当地的文化景点，体验传统的农村风情。",
              },
              {
                time: "午餐",
                activity: "在当地的餐厅享用午餐，品尝天津的地方特色。",
                notes: "天津的地方特色非常多样，特别是乡村风味的餐厅。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往天津或直接返程。",
                notes: "交通方便，适合尽早安排返程。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["本地特色餐厅", "乡村餐馆"],
            sightseeingRecommendations: ["宁河文化景点", "七里海"],
          },
        ],
      },
    },
    {
      id: "tianjin-eastlil-lake-half-marathon",
      name: "天津欢乐东丽湖半程马拉松",
      distance: "半程、10公里、3公里",
      date: "2025年4月13日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-dongli-half.jpg"),
      routeImage: require("../assets/routeMap/tianjin-dongli-half.jpg"),
      web: null,
      isCAAcertified: false,
      travelPlan: {
        title: "天津欢乐东丽湖半程马拉松 - 湖泊与城市绿地体验",
        description:
          "结合天津欢乐东丽湖半程马拉松，体验东丽湖的美丽景色与天津的城市绿地。",
        days: [
          {
            day: 1,
            theme: "抵达与东丽湖公园",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达天津，入住东丽湖附近的酒店（如：东丽湖大酒店）。",
                notes: "选择靠近比赛起点的酒店，便于赛事当天出行。",
              },
              {
                time: "傍晚",
                activity: "参观东丽湖公园，享受湖泊的宁静和自然风光。",
                notes: "东丽湖公园是天津的一个美丽的绿地，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity:
                  "在东丽湖附近的餐厅享用晚餐，推荐尝试天津本地特色菜。",
                notes: "东丽湖周围有许多提供地道天津菜的餐馆。",
              },
            ],
            hotelRecommendations: ["东丽湖大酒店", "东丽酒店"],
            restaurantRecommendations: ["东丽湖餐厅", "天津传统餐馆"],
            sightseeingRecommendations: ["东丽湖公园", "东丽湖"],
          },
          {
            day: 2,
            theme: "半马赛事与休闲",
            activities: [
              {
                time: "上午",
                activity: "参加 天津欢乐东丽湖半程马拉松！",
                notes: "提前了解比赛路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以在东丽湖周边的公园散步，享受清新的空气。",
                notes: "东丽湖附近有很多适合放松的地方，赛后可以轻松散步。",
              },
              {
                time: "晚餐",
                activity: "返回市区，尝试天津的特色小吃。",
                notes: "天津的小吃街非常热闹，可以品尝各种地道美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["天津小吃街", "东丽湖餐厅"],
            sightseeingRecommendations: ["天津之眼", "东丽湖公园"],
          },
          {
            day: 3,
            theme: "城市与购物",
            activities: [
              {
                time: "上午",
                activity: "参观天津的大型购物中心，如天津大悦城或津塔。",
                notes: "购物中心内有丰富的购物选择，适合赛后购物放松。",
              },
              {
                time: "午餐",
                activity: "在购物中心内享用午餐，继续享受天津的美食。",
                notes: "购物中心内的餐厅也提供各种风味的美食，方便便捷。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes:
                  "北京的公共交通非常便利，可以直接通过地铁或出租车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["购物中心餐厅", "天津市区餐厅"],
            sightseeingRecommendations: ["天津大悦城", "津塔"],
          },
        ],
      },
    },
    {
      id: "tianjin-eco-city-half-marathon",
      name: "天津生态城半程马拉松",
      distance: "半程、6公里",
      date: "2025年4月13日⚠️（延期至4月26日）",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/tianjin-shengtaicheng-half.jpeg"),
      routeImage: require("../assets/routeMap/tianjin-shengtaicheng-half.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "天津生态城半程马拉松 - 现代城市与生态体验",
        description:
          "结合天津生态城半程马拉松，体验天津生态城市的绿色环境与现代化建筑。",
        days: [
          {
            day: 1,
            theme: "抵达与生态城参观",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达天津，入住天津生态城的酒店（如：天津生态城大酒店）。",
                notes: "选择靠近赛事起点的酒店，方便赛事当天出行。",
              },
              {
                time: "傍晚",
                activity:
                  "参观天津生态城，感受这座现代化生态城市的设计与绿色环境。",
                notes:
                  "生态城是天津的现代化城市区域，环境优美，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity:
                  "在生态城附近的餐厅享用晚餐，尝试当地的绿色健康餐饮。",
                notes:
                  "生态城内的餐厅注重健康和绿色饮食，可以品尝当地的特色餐。",
              },
            ],
            hotelRecommendations: ["天津生态城大酒店"],
            restaurantRecommendations: ["生态城餐厅", "绿色健康餐厅"],
            sightseeingRecommendations: ["天津生态城", "滨海新区"],
          },
          {
            day: 2,
            theme: "赛事与放松",
            activities: [
              {
                time: "上午",
                activity: "参加 天津生态城半程马拉松！",
                notes: "提前了解赛事路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity: "赛后可以前往滨海新区的海滨公园，放松身心。",
                notes: "滨海新区的海滨公园风景如画，非常适合休闲散步。",
              },
              {
                time: "晚餐",
                activity: "在滨海新区的餐厅享用晚餐，品尝地道的天津美食。",
                notes: "滨海新区有丰富的餐饮选择，海鲜尤为推荐。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["滨海新区餐厅", "生态城附近餐厅"],
            sightseeingRecommendations: ["滨海新区", "生态城公园"],
          },
          {
            day: 3,
            theme: "现代城市与购物体验",
            activities: [
              {
                time: "上午",
                activity: "参观天津的大型购物中心，如天津大悦城或津塔。",
                notes: "购物中心内有丰富的购物选择，适合赛后购物放松。",
              },
              {
                time: "午餐",
                activity: "在购物中心内享用午餐，继续享受天津的美食。",
                notes: "购物中心内的餐厅也提供各种风味的美食，方便便捷。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes:
                  "北京的公共交通非常便利，可以直接通过地铁或出租车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["购物中心餐厅", "天津市区餐厅"],
            sightseeingRecommendations: ["天津大悦城", "津塔"],
          },
        ],
      },
    },
  ],

  // 无锡的马拉松赛事
  wuxi: [
    {
      id: "wuxi-marathon",
      name: "无锡马拉松",
      distance: "全马",
      date: "每年3月",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-marathon.png"),
      routeImage: require("../assets/routeMap/wuxi-marathon.jpeg"),
      web: "https://wuxi.marathon.org.cn/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "无锡马拉松 - 太湖风光3日深度游",
        description: "结合无锡马拉松，体验太湖明珠的山水园林与江南美食",
        days: [
          {
            day: 1,
            theme: "抵达与太湖夜游",
            activities: [
              {
                time: "下午",
                activity:
                  "入住太湖大道附近酒店（推荐君来世尊酒店/太湖皇冠假日）",
                notes: "步行可达马拉松起点，建议提前2天入住适应环境",
              },
              {
                time: "傍晚",
                activity: "游览鼋头渚景区，观赏太湖日落",
                notes: "三月正值樱花季，可夜赏樱花灯光秀",
              },
              {
                time: "晚餐",
                activity: "三凤桥酒家品尝无锡排骨",
                notes: "老字号餐厅，建议提前预约",
              },
            ],
            hotelRecommendations: ["无锡君来世尊酒店", "太湖皇冠假日酒店"],
            restaurantRecommendations: ["三凤桥酒家", "熙盛源(南禅寺店)"],
            sightseeingRecommendations: ["鼋头渚", "蠡园", "南长街"],
          },
          {
            day: 2,
            theme: "赛事日与古镇体验",
            activities: [
              {
                time: "上午",
                activity: "参加无锡马拉松（起点：太湖大道隐秀路口）",
                notes: "赛道经过蠡湖大桥、江南大学等标志性景点",
              },
              {
                time: "下午",
                activity: "惠山古镇文化体验（泥人博物馆+锡剧表演）",
                notes: "赛后放松推荐足浴+中医推拿",
              },
              {
                time: "晚餐",
                activity: "古镇内老菜馆品尝无锡酱排骨",
                notes: "推荐搭配无锡老酒",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["惠山豆腐花", "忆秦园小笼包"],
            sightseeingRecommendations: [
              "惠山古镇",
              "锡惠公园",
              "清名桥古运河",
            ],
          },
          {
            day: 3,
            theme: "灵山胜境与返程",
            activities: [
              {
                time: "上午",
                activity: "参观灵山大佛景区",
                notes: "包含梵宫、九龙灌浴等景点，建议购买电瓶车票",
              },
              {
                time: "午餐",
                activity: "灵山蔬食馆体验禅意素食",
                notes: "招牌菜：素面、禅饼",
              },
              {
                time: "下午",
                activity: "购买无锡特产（清水油面筋、阳山水蜜桃制品）",
                notes: "推荐南禅寺步行街或三阳广场商圈",
              },
            ],
            hotelRecommendations: ["无锡灵山精舍禅意酒店"],
            restaurantRecommendations: ["灵山蔬食馆", "穆桂英美食城"],
            sightseeingRecommendations: ["灵山大佛", "拈花湾小镇", "梅园"],
          },
        ],
      },
    },
    {
      id: "jiangyin-half-marathon",
      name: "无锡江阴半程马拉松",
      distance: "半程、5公里",
      date: "2025年04月13日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-jiangyin-half.png"),
      routeImage: require("../assets/routeMap/wuxi-jiangyin-half.webp"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "江阴半马 - 长江文化2日游",
        description: "结合江阴马拉松，探索长江要塞的历史文化与江鲜美食",
        days: [
          {
            day: 1,
            theme: "抵达与滨江游览",
            activities: [
              {
                time: "下午",
                activity: "入住江阴体育中心周边酒店（喜来登/全季酒店）",
                notes: "步行10分钟可达赛事起点",
              },
              {
                time: "傍晚",
                activity: "鹅鼻嘴公园观长江落日",
                notes: "参观江阴长江大桥纪念馆",
              },
              {
                time: "晚餐",
                activity: "天水雅居品尝长江三鲜",
                notes: "清明前后刀鱼最肥美",
              },
            ],
            hotelRecommendations: ["江阴黄嘉喜来登酒店", "全季酒店体育馆店"],
            restaurantRecommendations: ["天水雅居", "陶兴宝点心店"],
            sightseeingRecommendations: [
              "鹅鼻嘴公园",
              "江阴要塞",
              "黄山湖公园",
            ],
          },
          {
            day: 2,
            theme: "赛事日与古镇探访",
            activities: [
              {
                time: "上午",
                activity: "参加江阴半程马拉松",
                notes: "赛道经过芙蓉湖公园、江阴外滩",
              },
              {
                time: "下午",
                activity: "游览徐霞客故里",
                notes: "车程40分钟，建议租车前往",
              },
              {
                time: "晚餐",
                activity: "青阳镇老字号羊肉馆",
                notes: "推荐白切羊肉配麦饼",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["青阳羊肉馆", "顾山八大碗"],
            sightseeingRecommendations: ["徐霞客故居", "华西村", "长泾古镇"],
          },
        ],
      },
    },
    {
      id: "yangshan-half-marathon",
      name: "阳山半程马拉松",
      distance: "半程、8公里",
      date: "每年3月桃花节期间",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-yangshan-half.jpeg"),
      routeImage: require("../assets/routeMap/wuxi-yangshan-half.jpg"),
      web: "http://www.yangshan-marathon.com",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "阳山半马 - 桃园春色3日游",
        description: "结合阳山半马，体验中国水蜜桃之乡的田园风情",
        days: [
          {
            day: 1,
            theme: "抵达与桃园体验",
            activities: [
              {
                time: "下午",
                activity: "入住阳山田园主题民宿（推荐花间堂·桃花岛/隐居桃源）",
                notes: "民宿提供免费自行车租赁服务",
              },
              {
                time: "傍晚",
                activity: "阳山桃花岛摄影+桃文化博物馆参观",
                notes: "三月中下旬为最佳赏花期",
              },
              {
                time: "晚餐",
                activity: "田园农家乐（推荐桃缘山庄）",
                notes: "必点：桃木烤鸡、桃胶银耳羹",
              },
            ],
            hotelRecommendations: ["花间堂·桃花岛", "隐居桃源酒店"],
            restaurantRecommendations: ["桃缘山庄", "老味道农家菜"],
            sightseeingRecommendations: [
              "阳山桃花岛",
              "亿年火山地质公园",
              "田园东方",
            ],
          },
          {
            day: 2,
            theme: "赛事日与温泉疗愈",
            activities: [
              {
                time: "上午",
                activity: "参加阳山半程马拉松（穿越万亩桃林）",
                notes: "赛道含丘陵地形，建议提前适应",
              },
              {
                time: "下午",
                activity: "阳山温泉度假村放松",
                notes: "提供赛事专属按摩套餐",
              },
              {
                time: "晚餐",
                activity: "度假村内桃花宴定制晚餐",
                notes: "需提前24小时预约",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["桃花泉餐厅", "火山泥煨鸡专卖店"],
            sightseeingRecommendations: ["阳山温泉", "朝阳禅寺", "桃花岛夜景"],
          },
          {
            day: 3,
            theme: "手作体验与返程",
            activities: [
              {
                time: "上午",
                activity: "桃木雕刻工坊体验",
                notes: "可制作专属纪念品",
              },
              {
                time: "午餐",
                activity: "阳山老街品传统桃脂烧肉",
                notes: "搭配当地杨梅酒更佳",
              },
              {
                time: "下午",
                activity: "采购水蜜桃衍生品（桃酱/果干）后返程",
                notes: "推荐品牌：阳山牌",
              },
            ],
            hotelRecommendations: [],
            restaurantRecommendations: ["阳山老街酒楼", "桃甜手作工坊"],
            sightseeingRecommendations: ["阳山老街", "桃文化博览馆"],
          },
        ],
      },
    },
    {
      id: "taihu-women-half-marathon",
      name: "无锡太湖女子半程马拉松",
      distance: "半程、6.6公里",
      date: "2025年03月02日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-taihu-woman-half.webp"),
      routeImage: require("../assets/routeMap/wuxi-taihu-woman-half.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "无锡太湖女子半程马拉松 - 无锡3日浪漫湖泊与文化之旅",
        description:
          "结合无锡太湖女子半程马拉松，感受无锡的自然风光与文化魅力，享受湖泊与古城的完美融合。",
        days: [
          {
            day: 1,
            theme: "抵达与太湖风光",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达无锡，入住太湖附近的酒店（如：无锡太湖大酒店、无锡洲际酒店）。",
                notes: "选择靠近比赛起点的酒店，方便参赛当天的出行。",
              },
              {
                time: "傍晚",
                activity: "游览太湖，乘船观赏湖泊的美丽景色。",
                notes: "太湖风景如画，特别适合放松心情和拍照。",
              },
              {
                time: "晚餐",
                activity:
                  "在太湖周边的餐厅享用晚餐，推荐尝试无锡的特色美食如无锡排骨、太湖三白。",
                notes: "太湖的三白（白鱼、白虾、白蟹）非常有名，绝对值得尝试。",
              },
            ],
            hotelRecommendations: [
              "无锡太湖大酒店",
              "无锡洲际酒店",
              "无锡希尔顿酒店",
            ],
            restaurantRecommendations: ["太湖渔庄", "无锡排骨馆", "湖鲜馆"],
            sightseeingRecommendations: ["太湖", "灵山大佛", "无锡博物院"],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加无锡太湖女子半程马拉松！",
                notes: "提前熟悉赛事路线，做好赛前准备。",
              },
              {
                time: "下午",
                activity: "赛后可以参观无锡博物院，体验无锡丰富的文化和历史。",
                notes:
                  "无锡博物院有丰富的展品，适合赛后放松和学习无锡的历史文化。",
              },
              {
                time: "晚餐",
                activity: "前往无锡老街，品尝更多无锡特色小吃。",
                notes:
                  "无锡老街有着丰富的美食，适合边逛边吃，感受地道的江南风味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["无锡老街餐馆", "南长街小吃"],
            sightseeingRecommendations: ["无锡博物院", "南长街", "无锡老街"],
          },
          {
            day: 3,
            theme: "湖泊与购物",
            activities: [
              {
                time: "上午",
                activity: "参观无锡的购物中心，如无锡大悦城，享受购物与休闲。",
                notes: "无锡大悦城是当地著名的购物中心，适合赛后放松和购物。",
              },
              {
                time: "午餐",
                activity: "在购物中心内享用午餐，继续享受无锡的美食。",
                notes: "购物中心内餐厅提供各式各样的美食，便捷又美味。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "无锡的交通非常便利，可以通过地铁或出租车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["无锡大悦城餐厅", "购物中心周边餐馆"],
            sightseeingRecommendations: ["无锡大悦城", "无锡购物街区"],
          },
        ],
      },
    },
    {
      id: "jiangyin-new-bridge-half-marathon",
      name: "无锡江阴新桥镇半程马拉松",
      distance: "半程、10公里、5公里",
      date: "2024年11月10日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-jiangyin-xinqiao-half.png"),
      routeImage: require("../assets/routeMap/wuxi-xinqiao-half.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "无锡江阴新桥镇半程马拉松 - 江阴文化与美食之旅",
        description: "结合江阴新桥镇半程马拉松，体验江阴的历史文化与地方美食。",
        days: [
          {
            day: 1,
            theme: "抵达与江阴水乡",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达江阴，入住市中心的酒店（如：江阴华美达大酒店、江阴富力丽思卡尔顿）。",
                notes: "选择靠近比赛起点的酒店，方便参赛。",
              },
              {
                time: "傍晚",
                activity: "参观江阴的老街或江南水乡，感受江南古镇的魅力。",
                notes: "江阴有着典型的江南水乡风貌，非常适合散步游览。",
              },
              {
                time: "晚餐",
                activity:
                  "在江阴市区品尝江南美食，推荐尝试江阴的阳春面、清蒸白鱼。",
                notes: "江阴的阳春面与清蒸白鱼是当地的特色美食。",
              },
            ],
            hotelRecommendations: ["江阴华美达大酒店", "江阴富力丽思卡尔顿"],
            restaurantRecommendations: ["江阴老街餐厅", "江南水乡餐厅"],
            sightseeingRecommendations: ["江阴老街", "江南水乡", "江阴博物馆"],
          },
          {
            day: 2,
            theme: "半马赛事与江阴探索",
            activities: [
              {
                time: "上午",
                activity: "参加无锡江阴新桥镇半程马拉松！",
                notes: "提前熟悉赛事路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity: "赛后参观江阴博物馆，体验江阴的历史和文化。",
                notes: "江阴博物馆展示了丰富的江阴历史，适合赛后放松。",
              },
              {
                time: "晚餐",
                activity: "在江阴的餐馆享用晚餐，推荐尝试当地水乡风味的菜肴。",
                notes: "江阴的水乡美食和长江鲜鱼是必试的传统美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["江阴餐厅", "长江水产餐馆"],
            sightseeingRecommendations: ["江阴博物馆", "长江沿岸景点"],
          },
          {
            day: 3,
            theme: "江南美景与休闲",
            activities: [
              {
                time: "上午",
                activity:
                  "参观江阴的景点，如江阴博物馆，或到无锡其他自然景区。",
                notes: "无锡周边有丰富的自然景点，适合赛后放松。",
              },
              {
                time: "午餐",
                activity: "在当地的餐馆品尝午餐，继续享受江南美食。",
                notes: "江阴和无锡的地方特色餐饮不容错过。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往返程地点。",
                notes: "无锡的交通非常便利，可以选择地铁或出租车前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["江阴餐厅", "本地小吃店"],
            sightseeingRecommendations: ["江阴博物馆", "长江沿岸景点"],
          },
        ],
      },
    },
    {
      id: "yadi-xishan-wanshan-lake-marathon",
      name: "无锡锡山宛山湖马拉松",
      distance: "全程、5公里",
      date: "预计2025年11月9日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-xishan-half.png"),
      routeImage: require("../assets/routeMap/wuxi-xishan-wanshanhu.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "无锡锡山宛山湖马拉松 - 自然与文化之旅",
        description:
          "结合无锡锡山宛山湖马拉松，体验锡山的自然景观与当地的文化遗产。",
        days: [
          {
            day: 1,
            theme: "抵达与锡山探索",
            activities: [
              {
                time: "下午",
                activity: "抵达无锡，入住锡山附近的酒店（如：锡山湖大酒店）。",
                notes: "选择靠近赛事起点的酒店，便于第二天出行。",
              },
              {
                time: "傍晚",
                activity: "参观锡山，享受湖泊和周围自然环境的美景。",
                notes: "锡山的湖泊和自然环境非常宜人，适合放松。",
              },
              {
                time: "晚餐",
                activity: "在锡山的餐馆享用晚餐，尝试锡山特色美食。",
                notes: "锡山的湖鲜和当地风味菜肴不容错过。",
              },
            ],
            hotelRecommendations: ["锡山湖大酒店", "锡山度假村"],
            restaurantRecommendations: ["锡山湖餐厅", "锡山风味餐馆"],
            sightseeingRecommendations: ["锡山湖", "锡山古镇"],
          },
          {
            day: 2,
            theme: "赛事与自然体验",
            activities: [
              {
                time: "上午",
                activity: "参加无锡锡山宛山湖马拉松！",
                notes: "提前了解赛事路线，确保顺利完成比赛。",
              },
              {
                time: "下午",
                activity: "赛后参观锡山的景点，或前往无锡的其他景点。",
                notes: "锡山周边有许多自然景点，适合赛后放松。",
              },
              {
                time: "晚餐",
                activity: "在锡山周边餐厅用餐，尝试锡山特色美食。",
                notes: "锡山的湖鲜和传统菜肴深受当地居民喜爱。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["锡山湖餐厅", "锡山风味餐馆"],
            sightseeingRecommendations: ["锡山湖", "锡山景点"],
          },
          {
            day: 3,
            theme: "自然景点与休闲",
            activities: [
              {
                time: "上午",
                activity: "参观锡山的自然景点，或前往无锡其他的自然保护区。",
                notes: "锡山的景点丰富，适合游览和放松。",
              },
              {
                time: "午餐",
                activity: "在锡山餐馆享用午餐，继续体验无锡美食。",
                notes: "锡山餐馆提供丰富的传统菜肴。",
              },
              {
                time: "下午",
                activity: "整理行装，适时返回。",
                notes: "准备好行李，适时前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["锡山餐厅", "无锡本地餐馆"],
            sightseeingRecommendations: ["锡山景点", "锡山湖"],
          },
        ],
      },
    },
    {
      id: "huanlihu-half-marathon",
      name: "无锡环蠡湖半程马拉松",
      distance: "半程、4公里",
      date: "2024年11月03日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/wuxi-lihu-half.png"),
      routeImage: require("../assets/routeMap/wuxi-lihu-half.jpg"),
      web: "https://lihu.marathon.org.cn/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "无锡环蠡湖半程马拉松 - 蠡湖与风景之旅",
        description: "结合无锡环蠡湖半程马拉松，享受湖泊景色与无锡的历史文化。",
        days: [
          {
            day: 1,
            theme: "抵达与蠡湖风光",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达无锡，入住蠡湖周边的酒店（如：无锡蠡湖大酒店）。",
                notes: "选择靠近赛事起点的酒店，方便第二天的赛事。",
              },
              {
                time: "傍晚",
                activity: "游览蠡湖，欣赏湖泊的美丽景色。",
                notes: "蠡湖是无锡的一个著名景点，湖泊风光极为迷人。",
              },
              {
                time: "晚餐",
                activity: "在蠡湖附近的餐厅用餐，推荐尝试无锡的湖鲜美食。",
                notes: "蠡湖的湖鲜菜肴非常有特色，推荐品尝。",
              },
            ],
            hotelRecommendations: ["蠡湖大酒店", "无锡城市酒店"],
            restaurantRecommendations: ["蠡湖餐厅", "湖鲜馆"],
            sightseeingRecommendations: ["蠡湖", "无锡博物馆", "灵山大佛"],
          },
          {
            day: 2,
            theme: "赛事与湖泊体验",
            activities: [
              {
                time: "上午",
                activity: "参加无锡环蠡湖半程马拉松！",
                notes: "提前了解赛事路线，确保顺利完成比赛。",
              },
              {
                time: "下午",
                activity: "赛后参观无锡博物院或其他文化景点。",
                notes: "无锡博物院展示了丰富的历史与文化，适合赛后放松。",
              },
              {
                time: "晚餐",
                activity:
                  "前往无锡的餐馆品尝无锡小吃，推荐尝试无锡排骨等特色美食。",
                notes: "无锡的小吃非常丰富，值得一试。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["无锡排骨馆", "南长街小吃"],
            sightseeingRecommendations: ["无锡博物院", "南长街"],
          },
          {
            day: 3,
            theme: "自然景点与休闲",
            activities: [
              {
                time: "上午",
                activity: "参观无锡的自然景点，如太湖或蠡湖周边。",
                notes: "无锡的自然景点非常适合游览，尤其是湖泊景色。",
              },
              {
                time: "午餐",
                activity: "在无锡餐馆享用午餐，继续体验无锡特色美食。",
                notes: "无锡有许多餐馆，提供丰富的美食选择。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "无锡的交通非常便利，适合安排轻松返程。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["蠡湖周边餐厅", "无锡本地餐馆"],
            sightseeingRecommendations: ["太湖", "蠡湖"],
          },
        ],
      },
    },
  ],

  // 厦门的马拉松赛事
  xiamen: [
    {
      id: "xiamen-marathon",
      name: "厦门马拉松",
      distance: "全马",
      date: "2025年01月05日",
      numberOfParticipants: "约35,000人",
      image: require("../assets/pictures/MarathonPicture/xiamen-marathon.png"),
      routeImage: require("../assets/routeMap/xiamen-marathon.png"),
      web: "https://www.xmim.org/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "厦门马拉松 - 厦门3日海滨文化之旅",
        description: "结合厦门马拉松，体验厦门的海滨景点、历史文化与美食。",
        days: [
          {
            day: 1,
            theme: "抵达与海滨风光",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达厦门，入住思明区的酒店（如：厦门国际大酒店、厦门瑞颐大酒店）。",
                notes: "选择靠近赛事起点的酒店，方便参赛当天出行。",
              },
              {
                time: "傍晚",
                activity: "参观鼓浪屿，感受厦门的海滨风光和独特的历史建筑。",
                notes: "鼓浪屿是厦门的著名旅游景点，适合散步和拍照。",
              },
              {
                time: "晚餐",
                activity:
                  "在海边餐厅享用晚餐，推荐尝试厦门的特色小吃如沙茶面、海鲜。",
                notes: "厦门的海鲜非常新鲜，沙茶面是当地的代表美食。",
              },
            ],
            hotelRecommendations: ["厦门国际大酒店", "厦门瑞颐大酒店"],
            restaurantRecommendations: [
              "海鲜餐厅（鼓浪屿附近）",
              "厦门沙茶面店",
            ],
            sightseeingRecommendations: ["鼓浪屿", "厦门大学", "环岛路"],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加厦门马拉松！",
                notes: "提前了解比赛路线，确保顺利完成赛事。",
              },
              {
                time: "下午",
                activity: "赛后可以参观厦门大学，体验这座美丽校园的魅力。",
                notes:
                  "厦门大学被誉为中国最美的大学之一，校园内有许多经典的景点。",
              },
              {
                time: "晚餐",
                activity: "在厦门的餐馆品尝更多当地美食。",
                notes: "厦门是著名的美食之都，可以尝试更多厦门特色的小吃。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["厦门大学周边餐厅", "鼓浪屿的海鲜餐厅"],
            sightseeingRecommendations: [
              "厦门大学",
              "南普陀寺",
              "中山路步行街",
            ],
          },
          {
            day: 3,
            theme: "自然风光与购物",
            activities: [
              {
                time: "上午",
                activity: "参观厦门的自然景点，如环岛路或胡里山炮台。",
                notes: "厦门的环岛路风光宜人，非常适合散步和骑行。",
              },
              {
                time: "午餐",
                activity: "在当地的购物中心如世贸商城或中山路小吃街享用午餐。",
                notes: "购物中心内有丰富的美食选择，适合赛后休息和放松。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "厦门交通便利，可以选择轻松的方式前往返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["世贸商城餐厅", "中山路小吃街"],
            sightseeingRecommendations: ["环岛路", "胡里山炮台"],
          },
        ],
      },
    },
    {
      id: "xiamen-dewen",
      name: "德文厦门工学院马拉松赛",
      distance: "全程、半程",
      date: "2025年04月13日",
      numberOfParticipants: "约4,200人",
      image: require("../assets/pictures/MarathonPicture/xiameng-dewen.png"),
      routeImage: require("../assets/routeMap/xiamen-dewen.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "德文厦门工学院马拉松赛 - 厦门4日校园与文化之旅",
        description:
          "结合德文厦门工学院马拉松赛，体验厦门的校园文化与现代城市景观。",
        days: [
          {
            day: 1,
            theme: "抵达与厦门工学院体验",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达厦门，入住思明区的酒店（如：厦门国际会议中心酒店）。",
                notes: "选择靠近赛事起点的酒店，方便赛事当天出行。",
              },
              {
                time: "傍晚",
                activity: "参观厦门工学院，感受这所校园的独特魅力。",
                notes: "厦门工学院的校园现代而富有活力，适合散步和拍照。",
              },
              {
                time: "晚餐",
                activity: "在思明区享用晚餐，推荐尝试厦门特色的海鲜与小吃。",
                notes: "厦门的小吃非常丰富，可以尝试沙茶面、花生汤等传统美食。",
              },
            ],
            hotelRecommendations: [
              "厦门国际会议中心酒店",
              "厦门湖里皇冠假日酒店",
            ],
            restaurantRecommendations: ["厦门海鲜餐厅", "沙茶面馆"],
            sightseeingRecommendations: ["厦门工学院", "环岛路", "鼓浪屿"],
          },
          {
            day: 2,
            theme: "马拉松日与校园游览",
            activities: [
              {
                time: "上午",
                activity: "参加德文厦门工学院马拉松赛！",
                notes: "提前了解赛事起点和路线，确保顺利完成赛事。",
              },
              {
                time: "下午",
                activity: "赛后参观厦门大学，游览校园美景，放松身心。",
                notes: "厦门大学校园内有许多经典景点，适合赛后散步。",
              },
              {
                time: "晚餐",
                activity: "在厦门的本地餐馆享用晚餐，尝试更多的当地美食。",
                notes: "厦门是著名的美食之城，有许多特色餐馆。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["厦门大学周边餐厅", "厦门沙茶面店"],
            sightseeingRecommendations: ["厦门大学", "南普陀寺"],
          },
          {
            day: 3,
            theme: "自然景点与购物",
            activities: [
              {
                time: "上午",
                activity: "参观厦门的环岛路，享受海边的风景与自然美景。",
                notes:
                  "环岛路是厦门的标志性景点，风景如画，非常适合慢跑与散步。",
              },
              {
                time: "午餐",
                activity: "在厦门的购物区享用午餐，如世贸商城或中山路小吃街。",
                notes: "购物区内有丰富的餐饮选择，适合赛后放松。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "厦门的公共交通便利，适合快速出行。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["世贸商城餐厅", "中山路小吃街"],
            sightseeingRecommendations: ["环岛路", "胡里山炮台"],
          },
        ],
      },
    },
    {
      id: "xiamen-huandong-half",
      name: "厦门环东半程马拉松赛",
      distance: "半程、5公里",
      date: "2024年12月22日",
      numberOfParticipants: "约25,000人",
      image: require("../assets/pictures/MarathonPicture/xiamen-huandong-half.png"),
      routeImage: require("../assets/routeMap/xiamen-huandong-half.jpg"),
      web: "http://www.xiamenhuandongmarathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "厦门环东半程马拉松赛 - 厦门3日探索之旅",
        description: "结合厦门环东半程马拉松赛，体验厦门的海岸线与文化景点。",
        days: [
          {
            day: 1,
            theme: "抵达与海滨景点",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达厦门，入住酒店（如：厦门环东大酒店、厦门国际会议中心）。",
                notes: "选择靠近赛事起点的酒店，便于赛事当天出行。",
              },
              {
                time: "傍晚",
                activity: "参观环东路沿线的海滩，享受厦门的海风与自然景色。",
                notes: "环东路是厦门最美丽的海滨大道，非常适合散步和观光。",
              },
              {
                time: "晚餐",
                activity: "在海滨附近餐厅用餐，尝试更多的厦门海鲜和传统小吃。",
                notes: "厦门的海鲜新鲜可口，推荐尝试厦门传统的沙茶面。",
              },
            ],
            hotelRecommendations: ["厦门环东大酒店", "厦门国际会议中心"],
            restaurantRecommendations: ["海鲜餐厅", "沙茶面馆"],
            sightseeingRecommendations: ["环东路", "鼓浪屿"],
          },
          {
            day: 2,
            theme: "马拉松赛事与海景",
            activities: [
              {
                time: "上午",
                activity: "参加厦门环东半程马拉松赛！",
                notes: "提前了解赛事路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity: "赛后参观厦门的海滩或游览鼓浪屿。",
                notes:
                  "鼓浪屿是厦门的著名旅游景点，有许多美丽的建筑和自然景观。",
              },
              {
                time: "晚餐",
                activity: "在厦门的海鲜餐厅用餐，继续享受厦门的美食。",
                notes: "厦门的海鲜菜肴深受游客喜爱。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["厦门沙茶面店", "鼓浪屿餐厅"],
            sightseeingRecommendations: ["鼓浪屿", "南普陀寺"],
          },
          {
            day: 3,
            theme: "自然景点与购物",
            activities: [
              {
                time: "上午",
                activity: "参观厦门的自然景点，如环岛路或胡里山炮台。",
                notes: "环岛路和胡里山炮台是厦门最具代表性的景点之一。",
              },
              {
                time: "午餐",
                activity: "在厦门的购物中心如世贸商城享用午餐。",
                notes: "世贸商城内有多家餐厅，适合赛后用餐。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "厦门的交通非常便利，可以轻松到达机场或火车站。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["世贸商城餐厅", "购物区餐馆"],
            sightseeingRecommendations: ["胡里山炮台", "厦门大学"],
          },
        ],
      },
    },
    {
      id: "xiamen-haicang-half",
      name: "厦门海沧半程马拉松赛",
      distance: "半程、6.6公里",
      date: "2024年12月01日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/xiamen-haicang-half.png"),
      routeImage: require("../assets/routeMap/xiamen-haicang-half.jpg"),
      web: "https://www.xmhaicangmarathon.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "厦门海沧半程马拉松赛 - 厦门3日自然与海滨之旅",
        description: "结合厦门海沧半程马拉松赛，体验厦门的海滨景点与自然美景。",
        days: [
          {
            day: 1,
            theme: "抵达与海沧风光",
            activities: [
              {
                time: "下午",
                activity: "抵达厦门，入住海沧区的酒店（如：海沧大酒店）。",
                notes: "选择靠近赛事起点的酒店，方便出行。",
              },
              {
                time: "傍晚",
                activity: "参观厦门海沧区，享受海滨风景。",
                notes: "海沧区有许多美丽的海滩和自然景点，非常适合休闲放松。",
              },
              {
                time: "晚餐",
                activity: "在当地餐厅享用晚餐，尝试厦门的海鲜美食。",
                notes: "厦门的海鲜和沙茶面是非常受欢迎的地方特色菜肴。",
              },
            ],
            hotelRecommendations: ["海沧大酒店", "厦门海景酒店"],
            restaurantRecommendations: ["海鲜餐厅", "沙茶面店"],
            sightseeingRecommendations: ["海沧区", "鼓浪屿", "环岛路"],
          },
          {
            day: 2,
            theme: "赛事与自然景点",
            activities: [
              {
                time: "上午",
                activity: "参加厦门海沧半程马拉松赛！",
                notes: "提前熟悉比赛路线，确保顺利完成赛事。",
              },
              {
                time: "下午",
                activity: "赛后参观厦门的自然景点，如环岛路或胡里山炮台。",
                notes: "环岛路和胡里山炮台非常适合赛后游览。",
              },
              {
                time: "晚餐",
                activity: "在当地餐厅品尝美味的厦门海鲜与传统小吃。",
                notes: "厦门的海鲜菜肴非常新鲜美味，值得一试。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["厦门海鲜餐厅", "沙茶面馆"],
            sightseeingRecommendations: ["环岛路", "胡里山炮台"],
          },
          {
            day: 3,
            theme: "购物与休闲",
            activities: [
              {
                time: "上午",
                activity: "参观厦门的购物中心或商业区，享受购物与放松。",
                notes: "世贸商城等地是厦门购物的好去处。",
              },
              {
                time: "午餐",
                activity: "在购物中心享用午餐，继续享受厦门美食。",
                notes: "购物中心内的餐厅有许多美味选择，适合赛后放松。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "无锡交通便利，可以轻松到达返程地点。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["购物中心餐厅", "当地特色餐馆"],
            sightseeingRecommendations: ["世贸商城", "鼓浪屿"],
          },
        ],
      },
    },
  ],

  // 深圳的马拉松赛事
  shenzhen: [
    {
      id: "shenzhen-marathon",
      name: "深圳马拉松",
      distance: "全程",
      date: "2024年12月01日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/shenzhen-marathon.png"),
      routeImage: require("../assets/routeMap/shenzhen-marathon.png"),
      web: "http://shenzhenmarathon.org.cn/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "深圳马拉松 - 深圳3日都市与海滨之旅",
        description: "结合深圳马拉松，深度感受深圳的现代化风貌和海滨文化。",
        days: [
          {
            day: 1,
            theme: "抵达与城市初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达深圳，入住福田或南山附近的酒店（如：深圳福田香格里拉大酒店、南山万豪酒店）。",
                notes: "住在福田或南山区方便参加比赛，交通便利。",
              },
              {
                time: "傍晚",
                activity: "游览深圳湾公园，欣赏深圳湾的美丽海景。",
                notes: "深圳湾是深圳的重要海滨区域，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity:
                  "在深圳湾或南山区的餐厅享用晚餐，推荐尝试海鲜或粤菜。",
                notes: "深圳的餐饮以粤菜为主，海鲜尤为出名。",
              },
            ],
            hotelRecommendations: [
              "深圳福田香格里拉大酒店",
              "南山万豪酒店",
              "深圳湾一号酒店",
            ],
            restaurantRecommendations: [
              "深圳湾海鲜餐厅",
              "南山区餐厅",
              "深圳大中华酒店中餐厅",
            ],
            sightseeingRecommendations: [
              "深圳湾公园",
              "深圳大梅沙海滨公园",
              "深圳欢乐谷",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 深圳马拉松 比赛！",
                notes: "提前了解比赛路线和起点，确保顺利参与。",
              },
              {
                time: "下午",
                activity: "赛后放松，推荐前往深圳博物馆或深圳欢乐谷体验。",
                notes: "深圳博物馆展品丰富，是了解深圳历史文化的好地方。",
              },
              {
                time: "晚餐",
                activity:
                  "在华强北商圈或深圳湾享用晚餐，尝试一些深圳特色小吃。",
                notes: "华强北是深圳的电子街，周边也有许多餐馆。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["深圳湾海鲜餐厅", "深圳市华强北美食街"],
            sightseeingRecommendations: [
              "深圳博物馆",
              "欢乐谷",
              "深圳人才公园",
            ],
          },
          {
            day: 3,
            theme: "现代都市与购物体验",
            activities: [
              {
                time: "上午",
                activity:
                  "参观深圳的购物天堂——COCO Park或深圳书城，感受深圳的时尚和现代化。",
                notes: "COCO Park是深圳最著名的购物中心之一，适合购物和休闲。",
              },
              {
                time: "午餐",
                activity: "在购物中心享用午餐或咖啡，轻松享受午后时光。",
                notes: "可以选择一家时尚的餐厅，享受深圳的美食。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "COCO Park位于福田，交通非常便利。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["COCO Park内餐厅", "深圳湾海鲜餐厅"],
            sightseeingRecommendations: [
              "COCO Park购物中心",
              "深圳书城",
              "深圳人才公园",
            ],
          },
        ],
      },
    },
    {
      id: "shenzhen-nanshan-half-marathon",
      name: "深圳南山半程马拉松",
      distance: "半程",
      date: "2024年12月15日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/shenzhen-nanshan-half.jpeg"),
      routeImage: require("../assets/routeMap/shenzhen-nanshan-half.png"),
      web: null,
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      travelPlan: {
        title: "深圳南山半程马拉松 - 深圳海滨与现代文化之旅",
        description:
          "结合深圳南山半程马拉松，体验现代深圳与海滨文化的完美融合。",
        days: [
          {
            day: 1,
            theme: "抵达与海滨探索",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达深圳，入住南山区酒店（如：南山文华东方酒店、深圳香格里拉大酒店）。",
                notes: "南山区位于深圳湾旁，赛道及起点都较为方便。",
              },
              {
                time: "傍晚",
                activity: "前往深圳湾海滨公园，散步并欣赏深圳湾的美丽景色。",
                notes: "深圳湾的海景非常迷人，是放松心情的好地方。",
              },
              {
                time: "晚餐",
                activity:
                  "在深圳湾附近的餐厅用餐，尝试深圳本地的海鲜和粤式美食。",
                notes: "深圳湾周边的海鲜餐厅非常有名，可以尝试龙虾、鲍鱼等。",
              },
            ],
            hotelRecommendations: [
              "南山文华东方酒店",
              "深圳香格里拉大酒店",
              "深圳湾一号酒店",
            ],
            restaurantRecommendations: [
              "深圳湾海鲜餐厅",
              "香格里拉自助餐厅",
              "南山餐厅",
            ],
            sightseeingRecommendations: [
              "深圳湾海滨公园",
              "深圳大梅沙海滨公园",
              "深圳欢乐谷",
            ],
          },
          {
            day: 2,
            theme: "南山半程马拉松与城市体验",
            activities: [
              {
                time: "上午",
                activity: "参加 深圳南山半程马拉松！",
                notes: "提前了解比赛路线，确保顺利完成半程马拉松。",
              },
              {
                time: "下午",
                activity:
                  "赛后可以前往深圳欢乐谷或深圳博物馆，享受深圳的现代文化与历史。",
                notes: "深圳博物馆有许多有趣的展览，适合赛后放松。",
              },
              {
                time: "晚餐",
                activity: "在深圳湾或福田区的餐厅享用晚餐，尝试地道的广东菜。",
                notes: "深圳的餐饮选择丰富，推荐尝试烧鹅、清蒸石斑鱼等。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["深圳湾海鲜餐厅", "深圳博物馆附近餐厅"],
            sightseeingRecommendations: [
              "深圳欢乐谷",
              "深圳博物馆",
              "深圳人才公园",
            ],
          },
          {
            day: 3,
            theme: "现代深圳与购物体验",
            activities: [
              {
                time: "上午",
                activity:
                  "前往深圳的购物中心，如COCO Park或京基100大厦，体验购物与美食。",
                notes: "深圳的购物中心非常现代化，可以选购各种品牌商品。",
              },
              {
                time: "午餐",
                activity: "在COCO Park或附近餐厅享用午餐。",
                notes: "COCO Park是深圳的时尚地标，周边餐饮和购物非常方便。",
              },
              {
                time: "下午",
                activity: "整理行装，适时前往机场或火车站返程。",
                notes: "COCO Park附近的交通非常便利，适合返程时使用。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["COCO Park内餐厅", "深圳湾餐厅"],
            sightseeingRecommendations: [
              "COCO Park购物中心",
              "京基100大厦",
              "深圳人才公园",
            ],
          },
        ],
      },
    },
  ],

  // 重庆的马拉松赛事
  chongqing: [
    {
      id: "chongqing-marathon",
      name: "重庆马拉松",
      distance: "全程、5公里",
      date: "2025年03月02日",
      numberOfParticipants: "约35,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-marathon.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-marathon.jpeg"),
      web: "https://www.cqmarathon.com/",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "重庆马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆马拉松，为您规划一个融合运动激情与山水之美的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与山水初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在解放碑或市中心区域的酒店，方便赛事当天出行）",
                notes: "建议提前预定酒店，确保交通便利。",
              },
              {
                time: "傍晚",
                activity:
                  "游览解放碑步行街，感受重庆独特的山城气息，体验火锅文化。",
                notes: "解放碑区域餐饮选择丰富，可以尝试地道的重庆火锅。",
              },
              {
                time: "晚餐",
                activity:
                  "前往较场口夜市，品尝重庆小面、酸辣粉等地方特色小吃。",
                notes: "夜市热闹，提前规划好用餐时间，避免人流高峰。",
              },
            ],
            hotelRecommendations: [
              "重庆大厦",
              "万豪酒店（解放碑）",
              "重庆悦来大酒店",
              "重庆喜来登大酒店",
            ],
            restaurantRecommendations: [
              "老灶火锅（解放碑店）",
              "八一路小吃街",
              "重庆小面（较场口）",
              "火锅老火锅（观音桥店）",
            ],
            sightseeingRecommendations: [
              "解放碑步行街",
              "朝天门广场",
              "洪崖洞",
              "长江索道",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆马拉松 比赛！",
                notes: "提前规划好交通，确保能够准时到达起点。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以选择参观重庆博物馆或白公馆，了解重庆的历史文化。",
                notes: "博物馆和白公馆的参观需要提前安排好时间。",
              },
              {
                time: "晚餐",
                activity:
                  "品尝重庆的经典小吃，可以选择在磁器口古镇或江北区的餐馆。",
                notes: "磁器口古镇的氛围独特，非常适合品尝地道美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "磁器口老街火锅",
              "小天鹅火锅",
              "辣妹子火锅（江北店）",
              "重庆陈麻花",
            ],
            sightseeingRecommendations: [
              "重庆博物馆",
              "白公馆",
              "磁器口古镇",
              "长江大桥",
            ],
          },
        ],
      },
    },

    {
      id: "chongqing-changshouhu-half-marathon",
      name: "重庆长寿湖半程马拉松",
      distance: "半程、4公里",
      date: "2025年03月16日",
      numberOfParticipants: "约8,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-changshouhu-half-marathon.png"),
      routeImage: require("../assets/routeMap/chongqing-changshouhu-half-marathon.png"),
      web: null,
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "重庆长寿湖半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆长寿湖马拉松，为您规划一个融合运动激情与湖光山色的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与长寿湖初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在长寿湖附近的酒店，便于赛事当天出行）",
                notes: "尽量选择靠近长寿湖的住宿，便于比赛和休息。",
              },
              {
                time: "傍晚",
                activity: "游览长寿湖，欣赏湖泊的自然美景，参加湖畔散步。",
                notes: "长寿湖是重庆著名的休闲景点，周围环境宜人。",
              },
              {
                time: "晚餐",
                activity: "品尝长寿湖附近的特色农家乐，享受新鲜的湖鲜美食。",
                notes: "可以体验地道的乡村美味，推荐尝试长寿湖鱼类。",
              },
            ],
            hotelRecommendations: [
              "长寿湖大酒店",
              "重庆长寿湖度假村",
              "长寿湖生态酒店",
            ],
            restaurantRecommendations: [
              "长寿湖渔家餐厅",
              "田园风光农家乐",
              "长寿湖特色餐馆",
            ],
            sightseeingRecommendations: ["长寿湖", "长寿文化公园", "长寿塔"],
          },
          {
            day: 2,
            theme: "半程马拉松日与湖区体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆长寿湖半程马拉松 比赛！",
                notes: "确保提前到达赛事起点，做好热身准备。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以选择参观长寿区的其他自然景点，享受自然风光。",
                notes: "推荐前往长寿文化公园或登长寿塔，欣赏湖区全貌。",
              },
              {
                time: "晚餐",
                activity: "在长寿湖周边餐馆享用晚餐，感受静谧的湖畔氛围。",
                notes: "长寿湖的夜晚宁静，适合放松身心。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "长寿湖渔家餐厅",
              "田园风光农家乐",
              "长寿湖特色餐馆",
            ],
            sightseeingRecommendations: ["长寿湖", "长寿文化公园", "长寿塔"],
          },
        ],
      },
    },

    {
      id: "chongqing-yongchuan-marathon",
      name: "永川马拉松",
      distance: "全程、半程、5公里",
      date: "2025年03月16日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-yongchuan-marathon.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-yongchuan-marathon.png"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1529",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "永川马拉松 - 重庆3日跑游攻略",
        description:
          "结合永川马拉松，为您规划一个融合运动激情与自然田园风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与永川风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在永川城区或马拉松起终点附近的酒店）",
                notes: "选择交通方便的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览永川的特色景点，如永川公园和莲花池。",
                notes: "永川的自然景观与人文景观交相辉映，是理想的休闲去处。",
              },
              {
                time: "晚餐",
                activity: "在当地餐厅品尝重庆的经典美食。",
                notes: "永川的地方特色美食不容错过。",
              },
            ],
            hotelRecommendations: ["永川大酒店", "永川宾馆", "永川喜来登酒店"],
            restaurantRecommendations: [
              "永川酸辣粉",
              "莲花池餐馆",
              "永川老街小吃",
            ],
            sightseeingRecommendations: [
              "永川公园",
              "莲花池",
              "永川大剧院",
              "永川文化广场",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与田园体验",
            activities: [
              {
                time: "上午",
                activity: "参加 永川马拉松 比赛！",
                notes: "确保赛事当天提前到达起点，预留足够的热身时间。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以参观永川附近的田园景点，享受悠闲时光。",
                notes: "推荐前往永川的田园风光区，感受自然之美。",
              },
              {
                time: "晚餐",
                activity: "在永川的传统餐馆享用晚餐，享受地道的重庆味道。",
                notes: "永川的美食非常具有地方特色，值得尝试。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "永川酸辣粉",
              "莲花池餐馆",
              "永川老街小吃",
            ],
            sightseeingRecommendations: [
              "永川公园",
              "莲花池",
              "永川大剧院",
              "永川文化广场",
            ],
          },
        ],
      },
    },

    {
      id: "chongqing-women's-half-marathon",
      name: "重庆女子半程马拉松赛",
      distance: "半程、5公里",
      date: "2025年03月23日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-women's-half-marathon.jpg"),
      routeImage: require("../assets/routeMap/chongqing-women's-half-marathon.jpg"),
      web: "https://www.sherowm.com/#/home",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "重庆女子半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆女子半程马拉松，为您规划一个融合运动激情与女性特色的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与重庆女性文化初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议选择市中心或解放碑附近的酒店）",
                notes: "便于参加赛事，建议选择靠近起点和终点的酒店。",
              },
              {
                time: "傍晚",
                activity: "参观重庆的女性文化景点，如重庆女性文化艺术馆。",
                notes: "了解重庆女性文化的独特魅力。",
              },
              {
                time: "晚餐",
                activity: "在市区的餐厅享用晚餐，品尝重庆的经典小吃。",
                notes: "可以选择重庆火锅或小面。",
              },
            ],
            hotelRecommendations: [
              "重庆大厦",
              "万豪酒店（解放碑）",
              "重庆悦来大酒店",
            ],
            restaurantRecommendations: [
              "老灶火锅（解放碑店）",
              "重庆小面（解放碑店）",
              "江北观音桥火锅",
            ],
            sightseeingRecommendations: [
              "重庆女性文化艺术馆",
              "解放碑步行街",
              "洪崖洞",
              "长江索道",
            ],
          },
          {
            day: 2,
            theme: "女子马拉松日与女性魅力体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆女子半程马拉松 比赛！",
                notes: "提前做好热身和准备，确保顺利参赛。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以选择去参观重庆女性文化艺术馆。",
                notes: "了解重庆女性的文化和历史。",
              },
              {
                time: "晚餐",
                activity: "在重庆的精品餐厅享用晚餐。",
                notes: "可以选择适合女性放松的环境，享受美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "大董烤鸭店(南新仓店)",
              "南门涮肉(后海店)",
              "护国寺小吃(护国寺总店)",
            ],
            sightseeingRecommendations: [
              "重庆女性文化艺术馆",
              "解放碑步行街",
              "洪崖洞",
              "长江索道",
            ],
          },
        ],
      },
    },

    {
      id: "chongqing-dianjiang-marathon",
      name: "重庆垫江马拉松",
      distance: "全程、半程、5公里",
      date: "2025年03月23日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-dianjiang-marathon.jpg"),
      routeImage: require("../assets/routeMap/chongqing-dianjiang-marathon.webp"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1524",
      isCAAcertified: true,
      grade: "A (A2)",
      gradeImage: gradeA,
      travelPlan: {
        title: "重庆垫江马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆垫江马拉松，为您规划一个融合运动激情与地方文化的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与垫江风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在垫江城区附近的酒店，便于赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览垫江的自然景点，如垫江大足石刻。",
                notes:
                  "垫江拥有丰富的历史文化遗产，可以参观大足石刻，了解当地文化。",
              },
              {
                time: "晚餐",
                activity: "在当地餐馆享用垫江的特色美食。",
                notes: "垫江的农家菜非常有地方特色，推荐尝试豆腐菜、腊肉等。",
              },
            ],
            hotelRecommendations: ["垫江大酒店", "垫江宾馆"],
            restaurantRecommendations: ["垫江本地特色餐厅", "垫江农家菜"],
            sightseeingRecommendations: ["大足石刻", "垫江大自然公园"],
          },
          {
            day: 2,
            theme: "马拉松日与地方文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆垫江马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观垫江大足石刻，领略古老的石雕文化。",
                notes:
                  "大足石刻是联合国教科文组织的世界文化遗产，历史悠久，值得一游。",
              },
              {
                time: "晚餐",
                activity: "在垫江本地特色餐厅享用晚餐。",
                notes: "可以选择口味清淡的农家菜，放松身心。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["垫江特色餐馆", "垫江农家菜"],
            sightseeingRecommendations: ["大足石刻", "垫江大自然公园"],
          },
        ],
      },
    },

    {
      id: "chongqing-hechuan-half-marathon",
      name: "合川半程马拉松",
      distance: "半程、4.2公里",
      date: "2025年03月30日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-hechuan-half.jpg"),
      routeImage: require("../assets/routeMap/chongqing-hechuan-half-marathon.png"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1528",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "合川半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合合川马拉松，为您规划一个融合运动激情与合川自然风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与合川风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在合川城区或赛事起点附近的酒店）",
                notes: "选择交通便利的酒店，确保赛事当天能够准时出发。",
              },
              {
                time: "傍晚",
                activity: "游览合川的自然景点，如合川大峡谷。",
                notes:
                  "合川大峡谷以其险峻的山景和丰富的植被闻名，是一处理想的旅游景点。",
              },
              {
                time: "晚餐",
                activity: "在合川的地方餐馆享用晚餐。",
                notes: "合川特色的川菜口味鲜香，可以尝试辣椒牛肉等。",
              },
            ],
            hotelRecommendations: ["合川大酒店", "合川宾馆"],
            restaurantRecommendations: ["合川川菜馆", "合川特色餐厅"],
            sightseeingRecommendations: ["合川大峡谷", "合川古城"],
          },
          {
            day: 2,
            theme: "半程马拉松日与自然体验",
            activities: [
              {
                time: "上午",
                activity: "参加 合川半程马拉松 比赛！",
                notes: "确保提前做好热身，准备充分参加赛事。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以参观合川大峡谷或其他自然景点。",
                notes: "合川大峡谷是著名的自然景点，适合赛后休闲放松。",
              },
              {
                time: "晚餐",
                activity: "在合川的餐馆享用地方美食。",
                notes: "推荐尝试合川的地方特色菜肴，享受美味的晚餐。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["合川川菜馆", "合川特色餐厅"],
            sightseeingRecommendations: ["合川大峡谷", "合川古城"],
          },
        ],
      },
    },

    {
      id: "chongqing-wanzhou-marathon",
      name: "重庆万州环湖马拉松",
      distance: "全程、半程、5公里",
      date: "2025年03月30日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-wanzhou-marathon.jpg"),
      routeImage: require("../assets/routeMap/chongqing-wanzhou-marathon.jpg"),
      web: "http://wanzhoumls.com/",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,

      travelPlan: {
        title: "重庆万州环湖马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆万州环湖马拉松，为您规划一个融合运动激情与湖光山色的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与万州风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在万州城区附近的酒店，方便赛事当天出行）",
                notes: "选择靠近起点的酒店，确保赛事当天方便出行。",
              },
              {
                time: "傍晚",
                activity: "游览万州的自然风光，参观美丽的万州湖。",
                notes: "万州湖被誉为重庆的“明珠”，是一个理想的休闲场所。",
              },
              {
                time: "晚餐",
                activity: "在万州的本地餐厅品尝特色美食。",
                notes: "万州的山水风光非常迷人，可以尝试万州特色的酸菜鱼等。",
              },
            ],
            hotelRecommendations: ["万州大酒店", "万州宾馆"],
            restaurantRecommendations: ["万州酸菜鱼", "万州川菜馆"],
            sightseeingRecommendations: ["万州湖", "万州长江大桥"],
          },
          {
            day: 2,
            theme: "环湖马拉松日与湖区体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆万州环湖马拉松 比赛！",
                notes: "提前规划好交通，确保能够准时到达起点。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以参观万州湖，欣赏湖光山色。",
                notes: "万州湖四周的自然景色非常迷人，适合赛后放松。",
              },
              {
                time: "晚餐",
                activity: "品尝万州的特色美食，可以选择湖区附近的餐馆。",
                notes: "万州的湖区附近餐馆环境优美，非常适合休闲就餐。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["万州酸菜鱼", "万州川菜馆"],
            sightseeingRecommendations: ["万州湖", "万州长江大桥"],
          },
        ],
      },
    },
    {
      id: "chongqing-dazulongshuihu-marathon",
      name: "重庆大足龙水湖半程马拉松",
      distance: "半程、4.2公里",
      date: "2025年04月13日",
      numberOfParticipants: "约6,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-dazulong-half.jpg"),
      routeImage: require("../assets/routeMap/chongqing-dazulong-half.jpg"),
      web: "http://sports.cqsports.org/signSetUp/index?game_id=1527",
      isCAAcertified: false,

      travelPlan: {
        title: "重庆大足龙水湖半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆大足龙水湖半程马拉松，为您规划一个融合运动激情与大足自然风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与大足风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在大足城区附近的酒店，方便赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览大足的自然景点，如大足石刻。",
                notes: "大足石刻是世界文化遗产，值得一游。",
              },
              {
                time: "晚餐",
                activity: "在大足的地方餐馆享用晚餐。",
                notes: "大足的本地美食非常有特色，可以尝试大足的腊肉、土豆等。",
              },
            ],
            hotelRecommendations: ["大足大酒店", "大足宾馆"],
            restaurantRecommendations: ["大足特色餐厅", "大足农家乐"],
            sightseeingRecommendations: ["大足石刻", "大足古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与大足文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆大足龙水湖半程马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观大足的文化遗产，了解大足的历史文化。",
                notes: "大足拥有丰富的文化资源，值得在赛后参观。",
              },
              {
                time: "晚餐",
                activity: "在大足本地特色餐厅享用晚餐。",
                notes: "可以尝试大足的地方特色菜肴，享受美味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["大足特色餐厅", "大足农家乐"],
            sightseeingRecommendations: ["大足石刻", "大足古镇"],
          },
        ],
      },
    },
    {
      id: "chongqing-fengjie-half-marathon",
      name: "奉节半程马拉松",
      distance: "半程、4公里",
      date: "2025年04月13日",
      numberOfParticipants: "约11,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-fengjie-half.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-fengjie-half.jpeg"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1537",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,

      travelPlan: {
        title: "重庆奉节半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆奉节半程马拉松，为您规划一个融合运动激情与奉节自然风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与奉节风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在奉节城区附近的酒店，便于赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览奉节的自然景点，如奉节天坑。",
                notes: "奉节天坑是世界级自然景点，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity: "在奉节的地方餐馆享用晚餐。",
                notes:
                  "奉节的地方美食非常有特色，可以尝试奉节的辣椒牛肉、酸菜鱼等。",
              },
            ],
            hotelRecommendations: ["奉节大酒店", "奉节宾馆"],
            restaurantRecommendations: ["奉节传统餐厅", "奉节农家乐"],
            sightseeingRecommendations: ["奉节天坑", "奉节古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与奉节文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆奉节半程马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观奉节的文化遗产，了解奉节的历史文化。",
                notes: "奉节有着丰富的历史和文化资源，值得参观。",
              },
              {
                time: "晚餐",
                activity: "在奉节本地特色餐厅享用晚餐。",
                notes: "可以尝试奉节的地方特色菜肴，享受美味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["奉节传统餐厅", "奉节农家乐"],
            sightseeingRecommendations: ["奉节天坑", "奉节古镇"],
          },
        ],
      },
    },
    {
      id: "chongqing-dadukou-half-marathon",
      name: "重庆大渡口半程马拉松",
      distance: "半程、5公里",
      date: "2025年04月19日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-dadukou-half.png"),
      routeImage: require("../assets/routeMap/chongqing-dadukou-half.jpeg"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1535",
      isCAAcertified: false,

      travelPlan: {
        title: "重庆大渡口半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆大渡口半程马拉松，为您规划一个融合运动激情与大渡口城市风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与大渡口风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在大渡口城区附近的酒店，方便赛事当天出行）",
                notes: "选择靠近赛事起点的酒店，确保当天方便参赛。",
              },
              {
                time: "傍晚",
                activity: "游览大渡口的城市景观，如大渡口公园。",
                notes: "大渡口公园是一个美丽的城市公园，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity: "在大渡口的地方餐馆享用晚餐。",
                notes: "可以尝试大渡口的地方美食，享受独特的川菜。",
              },
            ],
            hotelRecommendations: ["大渡口大酒店", "大渡口宾馆"],
            restaurantRecommendations: ["大渡口传统餐厅", "大渡口小吃街"],
            sightseeingRecommendations: ["大渡口公园", "大渡口老街"],
          },
          {
            day: 2,
            theme: "马拉松日与城市体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆大渡口半程马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以参观大渡口的文化景点，如大渡口博物馆。",
                notes: "了解大渡口的历史和文化。",
              },
              {
                time: "晚餐",
                activity: "在大渡口的餐馆享用晚餐。",
                notes: "尝试大渡口的地方美食，享受美好时光。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["大渡口传统餐厅", "大渡口小吃街"],
            sightseeingRecommendations: ["大渡口公园", "大渡口博物馆"],
          },
        ],
      },
    },

    {
      id: "chongqing-shapingba-half-marathon",
      name: "重庆沙坪坝“全球校友”半程马拉松",
      distance: "半程、5公里",
      date: "2025年04月20日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-shapingba-half.jpg"),
      routeImage: require("../assets/routeMap/chongqing-shapingba-half.jpeg"),
      web: null,
      isCAAcertified: false,

      travelPlan: {
        title: "重庆沙坪坝“全球校友”半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆沙坪坝马拉松，为您规划一个融合运动激情与沙坪坝历史文化的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与沙坪坝风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在沙坪坝城区附近的酒店，方便赛事当天出行）",
                notes: "选择靠近赛事起点的酒店，方便第二天参赛。",
              },
              {
                time: "傍晚",
                activity: "游览沙坪坝的历史景点，如沙坪坝老街。",
                notes: "沙坪坝老街保存了丰富的历史文化遗迹，适合参观。",
              },
              {
                time: "晚餐",
                activity: "在沙坪坝的地方餐馆享用晚餐。",
                notes: "沙坪坝的餐馆提供丰富的重庆地方美食，推荐尝试火锅等。",
              },
            ],
            hotelRecommendations: ["沙坪坝大酒店", "沙坪坝宾馆"],
            restaurantRecommendations: ["沙坪坝川菜馆", "沙坪坝小吃街"],
            sightseeingRecommendations: ["沙坪坝老街", "沙坪坝博物馆"],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆沙坪坝“全球校友”半程马拉松 比赛！",
                notes: "提前做好热身，确保比赛顺利进行。",
              },
              {
                time: "下午",
                activity: "赛后可以参观沙坪坝的历史文化景点。",
                notes: "沙坪坝是重庆的历史文化重地，值得参观。",
              },
              {
                time: "晚餐",
                activity: "在沙坪坝的餐馆享用晚餐，品尝重庆的传统美食。",
                notes: "沙坪坝有许多有特色的餐厅，适合放松身心。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["沙坪坝川菜馆", "沙坪坝小吃街"],
            sightseeingRecommendations: ["沙坪坝老街", "沙坪坝博物馆"],
          },
        ],
      },
    },
    {
      id: "chongqing-zhongxian-sanxia-marathon",
      name: "重庆忠县三峡橘乡田园半程马拉松",
      distance: "半程、6公里",
      date: "2025年04月26日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-orange-half.jpg"),
      routeImage: require("../assets/routeMap/chongqing-orange-half.jpg"),
      web: null,
      isCAAcertified: false,

      travelPlan: {
        title: "重庆忠县三峡橘乡田园半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆忠县三峡橘乡田园半程马拉松，为您规划一个融合运动激情与田园风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与忠县风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在忠县城区附近的酒店，便于赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览忠县的自然景点，如忠县三峡橘乡。",
                notes:
                  "忠县三峡橘乡拥有美丽的田园风光，是参赛前放松身心的理想场所。",
              },
              {
                time: "晚餐",
                activity: "在忠县的地方餐馆享用晚餐。",
                notes:
                  "忠县的农家菜非常有地方特色，可以尝试橘子相关的美食，搭配本地的辣椒和香料。",
              },
            ],
            hotelRecommendations: ["忠县大酒店", "忠县宾馆"],
            restaurantRecommendations: ["忠县橘乡餐馆", "忠县农家乐"],
            sightseeingRecommendations: [
              "忠县三峡橘乡",
              "忠县天坑",
              "忠县古镇",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与忠县文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆忠县三峡橘乡田园半程马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观忠县的文化遗产，了解忠县的历史文化。",
                notes: "忠县有着丰富的文化和历史背景，值得深入了解。",
              },
              {
                time: "晚餐",
                activity: "在忠县本地特色餐厅享用晚餐。",
                notes: "可以尝试忠县的地方特色菜肴，享受美味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["忠县橘乡餐馆", "忠县农家乐"],
            sightseeingRecommendations: [
              "忠县三峡橘乡",
              "忠县天坑",
              "忠县古镇",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-zongxian-marathon",
      name: "重庆忠县马拉松",
      distance: "全程、半程、7公里",
      date: "2024年12月01日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-zhongxian.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-zhongxian.jpg"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1485",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "重庆忠县马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆忠县马拉松，为您规划一个融合运动激情与忠县自然风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与忠县风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在忠县城区附近的酒店，便于赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览忠县的自然景点，如忠县大峡谷。",
                notes: "忠县大峡谷是一个著名的旅游景点，适合散步和放松。",
              },
              {
                time: "晚餐",
                activity: "在忠县的地方餐馆享用晚餐。",
                notes: "忠县的本地美食非常有特色，可以尝试忠县的腊肉、土豆等。",
              },
            ],
            hotelRecommendations: ["忠县大酒店", "忠县宾馆"],
            restaurantRecommendations: ["忠县特色餐厅", "忠县农家乐"],
            sightseeingRecommendations: ["忠县大峡谷", "忠县古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与忠县文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆忠县马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观忠县的文化遗产，了解忠县的历史文化。",
                notes: "忠县拥有丰富的文化资源，值得在赛后参观。",
              },
              {
                time: "晚餐",
                activity: "在忠县本地特色餐厅享用晚餐。",
                notes: "可以尝试忠县的地方特色菜肴，享受美味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["忠县特色餐厅", "忠县农家乐"],
            sightseeingRecommendations: ["忠县大峡谷", "忠县古镇"],
          },
        ],
      },
    },

    {
      id: "chongqing-jiangjin-half-marathon",
      name: "重庆江津东方爱情马拉松",
      distance: "全程、半程、14公里、4公里",
      date: "2024年12月08日",
      numberOfParticipants: "约10,040人",
      image: require("../assets/pictures/MarathonPicture/chongqing-jiangjin-half.jpg"),
      routeImage: require("../assets/routeMap/chongqing-jiangjin-half.jpg"),
      web: null,
      isCAAcertified: false,

      travelPlan: {
        title: "重庆江津东方爱情马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆江津马拉松，为您规划一个融合运动激情与江津自然景观的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与江津风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在江津城区附近的酒店，方便赛事当天出行）",
                notes: "确保住宿离赛事起点较近，方便参与马拉松。",
              },
              {
                time: "傍晚",
                activity: "游览江津的自然景观，如白沙湖。",
                notes: "白沙湖景区有美丽的自然景色，适合休闲游玩。",
              },
              {
                time: "晚餐",
                activity: "在江津本地餐馆享用晚餐。",
                notes: "可以尝试江津特色的地方美食，享受风味餐。",
              },
            ],
            hotelRecommendations: ["江津大酒店", "江津宾馆"],
            restaurantRecommendations: ["江津本地特色餐厅", "江津农家乐"],
            sightseeingRecommendations: ["白沙湖", "江津古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与江津文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆江津马拉松 比赛！",
                notes: "提前做好热身，确保比赛顺利进行。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以参观江津的历史景点，如江津博物馆。",
                notes: "江津博物馆展示了江津的历史文化，值得参观。",
              },
              {
                time: "晚餐",
                activity: "在江津本地餐厅享用晚餐。",
                notes: "可以品尝江津的地道美食，体验当地特色。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["江津本地特色餐厅", "江津农家乐"],
            sightseeingRecommendations: ["白沙湖", "江津博物馆"],
          },
        ],
      },
    },

    {
      id: "chongqing-bishan-marathon",
      name: "重庆璧山马拉松",
      distance: "全程、半程、5.4公里",
      date: "2024年12月15日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-bishan.jpg"),
      routeImage: require("../assets/routeMap/chongqing-bishan.jpg"),
      web: "http://bishan-marathon.com/cms/home/134#zh-CN",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "重庆璧山马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆璧山马拉松，为您规划一个融合运动激情与璧山自然风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与璧山风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在璧山城区附近的酒店，方便赛事当天出行）",
                notes: "选择靠近赛事起点的酒店，便于第二天比赛。",
              },
              {
                time: "傍晚",
                activity: "游览璧山的自然景点，如璧山湖。",
                notes: "璧山湖景色优美，是一个理想的散步和放松场所。",
              },
              {
                time: "晚餐",
                activity: "在璧山的本地餐馆享用晚餐。",
                notes: "璧山的地方特色美食值得一试，可以尝试辣味小面等。",
              },
            ],
            hotelRecommendations: ["璧山大酒店", "璧山宾馆"],
            restaurantRecommendations: ["璧山川菜馆", "璧山特色餐厅"],
            sightseeingRecommendations: ["璧山湖", "璧山古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与璧山风光体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆璧山马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充足，迎接挑战。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以参观璧山湖或附近的自然景点。",
                notes: "璧山湖是休闲放松的好地方，适合赛后游玩。",
              },
              {
                time: "晚餐",
                activity: "在璧山餐馆享用晚餐，尝试地道的川菜。",
                notes: "璧山的餐馆提供丰富的地方美食，可以尝试小面等特色美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["璧山川菜馆", "璧山特色餐厅"],
            sightseeingRecommendations: ["璧山湖", "璧山古镇"],
          },
        ],
      },
    },
    {
      id: "chongqing-half-marathon",
      name: "重庆半程马拉松",
      distance: "半程、5.8公里",
      date: "2024年12月29日",
      numberOfParticipants: "约18,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-half.png"),
      routeImage: require("../assets/routeMap/chongqing-half.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,

      travelPlan: {
        title: "重庆半程马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆半程马拉松，为您规划一个融合运动激情与重庆市区风光的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与重庆市区初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在解放碑或市中心区域的酒店，方便赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览重庆解放碑，感受重庆的城市气息。",
                notes:
                  "解放碑是重庆的地标性区域，可以在周边购物并品尝地方美食。",
              },
              {
                time: "晚餐",
                activity: "在解放碑或周边的餐馆享用晚餐。",
                notes: "推荐尝试重庆火锅或小面，体验地道美味。",
              },
            ],
            hotelRecommendations: [
              "重庆大厦",
              "万豪酒店（解放碑）",
              "重庆悦来大酒店",
            ],
            restaurantRecommendations: [
              "全聚德烤鸭(王府井店)",
              "重庆小面（解放碑店）",
              "江北观音桥火锅",
            ],
            sightseeingRecommendations: ["解放碑", "长江索道", "洪崖洞"],
          },
          {
            day: 2,
            theme: "马拉松日与城市文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆半程马拉松 比赛！",
                notes: "确保提前到达起点，做好热身准备。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以参观重庆博物馆或洪崖洞，体验重庆独特的文化氛围。",
                notes: "洪崖洞是重庆的特色景点，非常适合赛后放松。",
              },
              {
                time: "晚餐",
                activity: "在附近的餐厅享用晚餐，体验重庆的夜生活。",
                notes: "夜晚的重庆别具魅力，可以去品尝更多地方小吃。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "大董烤鸭店(南新仓店)",
              "南门涮肉(后海店)",
              "护国寺小吃(护国寺总店)",
            ],
            sightseeingRecommendations: ["重庆博物馆", "洪崖洞", "长江索道"],
          },
        ],
      },
    },
    {
      id: "chongqing-rongchang-marathon",
      name: "重庆荣昌马拉松",
      distance: "全程、半程、5公里",
      date: "2024年12月29日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-rongchang.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-rongchang.jpg"),
      web: "http://rongchangmarathon.org.cn/",
      isCAAcertified: false,
      travelPlan: {
        title: "重庆荣昌马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆荣昌马拉松，为您规划一个融合运动激情与荣昌自然景观的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与荣昌风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在荣昌城区附近的酒店，方便赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览荣昌的自然景点，如荣昌湖。",
                notes: "荣昌湖风景优美，适合休闲散步。",
              },
              {
                time: "晚餐",
                activity: "在荣昌的地方餐馆享用晚餐。",
                notes: "荣昌的地方特色菜非常有特色，值得一试。",
              },
            ],
            hotelRecommendations: ["荣昌大酒店", "荣昌宾馆"],
            restaurantRecommendations: ["荣昌本地特色餐馆", "荣昌农家乐"],
            sightseeingRecommendations: ["夏布小镇", "昌州故里", "万灵古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆荣昌马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后可以参观荣昌的历史景点，了解荣昌的文化背景。",
                notes: "荣昌有着丰富的文化和历史背景，值得深入了解。",
              },
              {
                time: "晚餐",
                activity: "在荣昌的传统餐厅享用晚餐。",
                notes: "可以尝试荣昌的地方特色美食，享受地道的川菜。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["荣昌本地特色餐馆", "荣昌农家乐"],
            sightseeingRecommendations: ["荣昌湖", "荣昌古镇"],
          },
        ],
      },
    },

    {
      id: "chongqing-tongliang-marathon",
      name: "重庆铜梁马拉松",
      distance: "全程、半程、4公里",
      date: "2025年02月23日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-tongliang.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-tongliang.jpg"),
      web: "https://weixin.cloudcq.com/wechat/thisInfo/9/1518",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "重庆铜梁马拉松 - 重庆3日跑游攻略",
        description:
          "结合重庆铜梁马拉松，为您规划一个融合运动激情与铜梁自然景观的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与铜梁风光初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达重庆，入住推荐酒店（建议定在铜梁城区附近的酒店，便于赛事当天出行）",
                notes: "选择交通便利的酒店，确保赛事当天顺利出行。",
              },
              {
                time: "傍晚",
                activity: "游览铜梁的自然景点，如铜梁湖。",
                notes: "铜梁湖风景如画，是放松身心的理想场所。",
              },
              {
                time: "晚餐",
                activity: "在铜梁的地方餐馆享用晚餐。",
                notes: "铜梁的地方美食非常有特色，推荐尝试铜梁特色小吃。",
              },
            ],
            hotelRecommendations: ["铜梁大酒店", "铜梁宾馆"],
            restaurantRecommendations: ["铜梁本地特色餐馆", "铜梁农家乐"],
            sightseeingRecommendations: ["铜梁湖", "安居古镇"],
          },
          {
            day: 2,
            theme: "马拉松日与铜梁文化体验",
            activities: [
              {
                time: "上午",
                activity: "参加 重庆铜梁马拉松 比赛！",
                notes: "确保提前到达比赛起点，准备充分，享受比赛。",
              },
              {
                time: "下午",
                activity: "赛后放松，可以参观铜梁的历史文化景点。",
                notes: "铜梁有着丰富的历史文化，值得参观。",
              },
              {
                time: "晚餐",
                activity: "在铜梁的餐馆享用晚餐。",
                notes: "铜梁的餐馆提供丰盛的地方美食，适合放松休闲。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["铜梁本地特色餐馆", "铜梁农家乐"],
            sightseeingRecommendations: ["铜梁湖", "安居古镇"],
          },
        ],
      },
    },

    {
      id: "chongqing-fuling-half-marathon",
      name: "重庆涪陵白鹤梁半程马拉松",
      distance: "半程、5公里",
      date: "2024年10月27日",
      numberOfParticipants: "约8,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-fuling-half.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-fuling-half.jpeg"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1472",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,

      travelPlan: {
        title: "涪陵白鹤梁半马 - 涪陵3日跑游攻略",
        description:
          "结合涪陵白鹤梁半程马拉松，为您规划一个融合运动激情与涪陵人文自然景观的3日行程。",
        days: [
          {
            day: 1,
            theme: "抵达与涪陵初探",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达涪陵，入住推荐酒店（建议定在滨江路附近酒店，方便赛事出行）",
                notes: "选择靠近比赛起点的酒店，方便赛事准备。",
              },
              {
                time: "傍晚",
                activity: "游览白鹤梁水下博物馆，了解千年水文奇观",
                notes: "世界首座水下博物馆，涪陵必游景点。",
              },
              {
                time: "晚餐",
                activity: "品尝涪陵特色美食",
                notes: "推荐涪陵榨菜鱼、油醪糟等地方特色。",
              },
            ],
            hotelRecommendations: [
              "涪陵金科大酒店",
              "涪陵泽胜温泉酒店",
              "涪陵饭店",
            ],
            restaurantRecommendations: [
              "涪陵榨菜鱼老店",
              "滨江路美食街",
              "老字号油醪糟",
            ],
            sightseeingRecommendations: [
              "白鹤梁水下博物馆",
              "涪陵滨江公园",
              "周易园",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与武陵山大裂谷",
            activities: [
              {
                time: "上午",
                activity: "参加涪陵白鹤梁半程马拉松比赛",
                notes: "赛道沿长江而设，风景优美。",
              },
              {
                time: "下午",
                activity: "前往武陵山大裂谷景区",
                notes: "中国第一动感峡谷，壮观的地质奇观。",
              },
              {
                time: "晚餐",
                activity: "品尝武陵山农家菜",
                notes: "高山蔬菜和土鸡等特色食材。",
              },
            ],
            hotelRecommendations: ["武陵山森林酒店", "涪陵城区酒店"],
            restaurantRecommendations: ["武陵山农家乐", "涪陵城区特色餐馆"],
            sightseeingRecommendations: [
              "武陵山大裂谷",
              "816地下核工程",
              "点易洞",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-changjiahui-half-marathon",
      name: "重庆长嘉汇半程马拉松",
      distance: "半程、7.1公里",
      date: "2024年11月03日",
      numberOfParticipants: "约25,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-changjiahui-half.png"),
      routeImage: require("../assets/routeMap/chongqing-changjiahui-half.jpeg"),
      web: "https://www.cqnbmarathon.com/",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,

      travelPlan: {
        title: "长嘉汇半马 - 重庆3日精品跑游",
        description:
          "结合长嘉汇半程马拉松，为您规划一个融合都市跑马与两江四岸风光的精品行程。",
        days: [
          {
            day: 1,
            theme: "抵达与南滨路初探",
            activities: [
              {
                time: "下午",
                activity: "抵达重庆，入住南滨路沿线酒店",
                notes: "推荐长嘉汇附近酒店，方便赛事出行。",
              },
              {
                time: "傍晚",
                activity: "漫步南滨路，欣赏渝中半岛夜景",
                notes: "重庆最美滨江路，夜景绝佳观景点。",
              },
              {
                time: "晚餐",
                activity: "长嘉汇购物公园美食体验",
                notes: "汇集各类重庆特色餐饮。",
              },
            ],
            hotelRecommendations: [
              "重庆万豪酒店",
              "重庆喜来登大酒店",
              "重庆丽笙世嘉酒店",
            ],
            restaurantRecommendations: [
              "长嘉汇购物公园餐厅",
              "南滨路美食街",
              "弹子石老街火锅",
            ],
            sightseeingRecommendations: [
              "南滨路",
              "长嘉汇弹子石老街",
              "法国水师兵营旧址",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与都市文化",
            activities: [
              {
                time: "上午",
                activity: "参加长嘉汇半程马拉松比赛",
                notes: "赛道贯穿两江四岸核心区，都市景观丰富。",
              },
              {
                time: "下午",
                activity: "参观重庆规划展览馆",
                notes: "了解重庆城市发展历程。",
              },
              {
                time: "晚餐",
                activity: "洪崖洞民俗风貌区用餐",
                notes: "体验山城特色建筑与美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "洪崖洞餐厅",
              "解放碑美食街",
              "朝天门火锅",
            ],
            sightseeingRecommendations: [
              "重庆规划展览馆",
              "洪崖洞",
              "朝天门广场",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-kaiqiu-marathon",
      name: "重庆开州·汉丰湖马拉松",
      distance: "全程、半程、5公里",
      date: "2024年10月20日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-kaizhou.webp"),
      routeImage: require("../assets/routeMap/chongqing-kaizhou.jpeg"),
      web: null,
      isCAAcertified: true,
      travelPlan: {
        title: "开州汉丰湖马拉松 - 湖光山色3日游",
        description:
          "结合开州汉丰湖马拉松，为您规划一个融合湖景跑马与三峡风情的特色行程。",
        days: [
          {
            day: 1,
            theme: "抵达与汉丰湖初探",
            activities: [
              {
                time: "下午",
                activity: "抵达开州，入住汉丰湖周边酒店",
                notes: "选择湖景房可欣赏美丽湖光。",
              },
              {
                time: "傍晚",
                activity: "环汉丰湖步道漫步",
                notes: "感受国家湿地公园的生态美景。",
              },
              {
                time: "晚餐",
                activity: "品尝开州特色美食",
                notes: "推荐开州大混蒸、椒麻牛肉等。",
              },
            ],
            hotelRecommendations: ["开州假日酒店", "汉丰湖大酒店", "开州宾馆"],
            restaurantRecommendations: [
              "汉丰湖鱼庄",
              "开州特色餐馆",
              "滨湖美食街",
            ],
            sightseeingRecommendations: [
              "汉丰湖国家湿地公园",
              "开州举子园",
              "刘伯承同志纪念馆",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与雪宝山",
            activities: [
              {
                time: "上午",
                activity: "参加汉丰湖马拉松比赛",
                notes: "环湖赛道风景如画，空气清新。",
              },
              {
                time: "下午",
                activity: "前往雪宝山国家森林公园",
                notes: "重庆北部重要生态屏障。",
              },
              {
                time: "晚餐",
                activity: "雪宝山农家乐用餐",
                notes: "品尝高山生态食材。",
              },
            ],
            hotelRecommendations: ["雪宝山度假酒店", "开州城区酒店"],
            restaurantRecommendations: ["雪宝山农家乐", "开州城区餐馆"],
            sightseeingRecommendations: [
              "雪宝山国家森林公园",
              "谭家天坑",
              "温泉古镇",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-liangjianglongsheng-marathon",
      name: "重庆两江龙盛新城摇滚半程马拉松",
      distance: "半程、5公里",
      date: "2024年10月19日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-rock-half.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-rock-half.jpeg"),
      web: "http://weixin.cloudcq.com/wechat/thisInfo/9/1484",
      isCAAcertified: true,
      travelPlan: {
        title: "龙盛摇滚半马 - 音乐与运动3日狂欢",
        description:
          "结合摇滚主题半程马拉松，为您规划一个融合音乐、运动与两江新区现代风貌的特色行程。",
        days: [
          {
            day: 1,
            theme: "抵达与龙盛新城初探",
            activities: [
              {
                time: "下午",
                activity: "抵达两江新区，入住龙盛新城酒店",
                notes: "选择赛事起点附近酒店方便参赛。",
              },
              {
                time: "傍晚",
                activity: "游览龙兴古镇",
                notes: "感受现代新城中的历史韵味。",
              },
              {
                time: "晚餐",
                activity: "古镇特色餐馆用餐",
                notes: "体验传统与现代融合的美食。",
              },
            ],
            hotelRecommendations: [
              "两江新区酒店",
              "龙盛新城商务酒店",
              "龙兴古镇民宿",
            ],
            restaurantRecommendations: [
              "龙兴古镇餐馆",
              "两江新区美食街",
              "龙盛新城餐厅",
            ],
            sightseeingRecommendations: [
              "龙兴古镇",
              "两江国际影视城",
              "龙湾森林公园",
            ],
          },
          {
            day: 2,
            theme: "摇滚马拉松日与现代都市",
            activities: [
              {
                time: "上午",
                activity: "参加两江龙盛摇滚半程马拉松",
                notes: "享受音乐与跑步的激情碰撞。",
              },
              {
                time: "下午",
                activity: "参观重庆欢乐谷",
                notes: "释放压力，体验刺激游乐项目。",
              },
              {
                time: "晚餐",
                activity: "欢乐谷周边餐厅用餐",
                notes: "多种餐饮选择满足不同需求。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["欢乐谷主题餐厅", "两江新区特色餐馆"],
            sightseeingRecommendations: [
              "重庆欢乐谷",
              "两江新区中央公园",
              "重庆国际博览中心",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-10km-challenge",
      name: "中国田径协会10公里精英赛暨重庆10公里挑战赛",
      distance: "10公里、3.5公里",
      date: "2024年11月30日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-10K.jpeg"),
      routeImage: require("../assets/routeMap/chongqing-10K.jpg"),
      web: null,
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,

      travelPlan: {
        title: "重庆10公里挑战赛 - 南滨路2日跑游攻略",
        description:
          "结合重庆10公里挑战赛，为您规划一个融合都市跑马与两江四岸风光的精品行程。",
        days: [
          {
            day: 1,
            theme: "抵达与南滨路初探",
            activities: [
              {
                time: "下午",
                activity: "抵达重庆，入住南滨路沿线酒店",
                notes: "推荐东原1891附近酒店，方便赛事出行。",
              },
              {
                time: "傍晚",
                activity: "漫步南滨路，欣赏渝中半岛夜景",
                notes: "重庆最美滨江路，夜景绝佳观景点。",
              },
              {
                time: "晚餐",
                activity: "东原1891购物公园美食体验",
                notes: "汇集各类重庆特色餐饮。",
              },
            ],
            hotelRecommendations: [
              "重庆万豪酒店",
              "重庆喜来登大酒店",
              "重庆丽笙世嘉酒店",
            ],
            restaurantRecommendations: [
              "东原1891购物公园餐厅",
              "南滨路美食街",
              "龙门浩老街火锅",
            ],
            sightseeingRecommendations: [
              "南滨路",
              "龙门浩老街",
              "重庆开埠遗址公园",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与都市文化",
            activities: [
              {
                time: "上午",
                activity: "参加中国田径协会10公里精英赛比赛",
                notes: "赛道贯穿南滨路精华路段，都市景观丰富。",
              },
              {
                time: "下午",
                activity: "参观故宫文物南迁纪念馆",
                notes: "了解抗战时期文物南迁历史。",
              },
              {
                time: "晚餐",
                activity: "洪崖洞民俗风貌区用餐",
                notes: "体验山城特色建筑与美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "洪崖洞餐厅",
              "解放碑美食街",
              "朝天门火锅",
            ],
            sightseeingRecommendations: [
              "故宫文物南迁纪念馆",
              "慈云寺",
              "法国水师兵营旧址",
            ],
          },
        ],
      },
    },
    {
      id: "chongqing-rongchang-half-marathon",
      name: "重庆荣昌半程马拉松",
      distance: "半程、10公里、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约6,000人",
      image: require("../assets/pictures/MarathonPicture/chongqing-rongchang-half.png"),
      routeImage: require("../assets/routeMap/chongqing-rongchang-half.png"),
      web: null,
      isCAAcertified: false,
      travelPlan: {
        title: "荣昌半程马拉松 - 濑溪河2日文化之旅",
        description:
          "结合荣昌半程马拉松，为您规划一个融合跑步与荣昌非遗文化的特色行程。",
        days: [
          {
            day: 1,
            theme: "抵达与荣昌非遗体验",
            activities: [
              {
                time: "下午",
                activity: "抵达荣昌，入住马拉松广场附近酒店",
                notes: "选择靠近赛事起点的酒店方便参赛。",
              },
              {
                time: "傍晚",
                activity: "参观夏布小镇，体验荣昌非遗夏布制作",
                notes: "荣昌夏布是中国传统手工艺品代表。",
              },
              {
                time: "晚餐",
                activity: "品尝荣昌特色美食",
                notes: "推荐荣昌卤鹅、黄凉粉等地道小吃。",
              },
            ],
            hotelRecommendations: ["荣昌大酒店", "荣昌宾馆", "夏布小镇民宿"],
            restaurantRecommendations: [
              "荣昌卤鹅老店",
              "濑溪河鱼庄",
              "荣昌黄凉粉",
            ],
            sightseeingRecommendations: [
              "夏布小镇",
              "昌州故里",
              "濑溪河生态长廊",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与万灵古镇",
            activities: [
              {
                time: "上午",
                activity: "参加荣昌半程马拉松比赛",
                notes: "赛道沿濑溪河而设，风景优美。",
              },
              {
                time: "下午",
                activity: "游览万灵古镇（原路孔古镇）",
                notes: "重庆保存最完好的古镇之一。",
              },
              {
                time: "晚餐",
                activity: "古镇特色餐馆用餐",
                notes: "体验荣昌地方风味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["万灵古镇餐馆", "荣昌城区特色餐厅"],
            sightseeingRecommendations: [
              "万灵古镇",
              "濑溪河马拉松赛道",
              "荣昌陶博物馆",
            ],
          },
        ],
      },
    },
  ],

  //山西
  shanxi: [
    {
      id: "shanxi-gaoping-marathon",
      name: "高平马拉松赛",
      distance: "全程、半程、4公里",
      date: "2025年05月02日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/shanxi-gaoping-marathon.webp"),
      routeImage: require("../assets/routeMap/shanxi-gaoping-marathon.png"),
      web: "https://mp.weixin.qq.com/s/FFrmQIVP1CAUYwlDELUtfA?ref=runninginchina.org",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "高平马拉松 - 探寻长平古战场与炎帝故里2日之旅",
        description:
          "参加高平马拉松赛，跑过著名的长平之战古战场，结合赛事探访炎帝故里，感受厚重的华夏历史文化。",
        days: [
          {
            day: 1,
            theme: "抵达炎帝故里，触摸古战场遗风",
            activities: [
              {
                time: "下午",
                activity: "抵达高平市，入住酒店并领取参赛包",
                notes: "可选择乘坐高铁至高平东站或周边城市交通枢纽后转乘。",
              },
              {
                time: "傍晚",
                activity: "参观长平之战纪念馆或相关遗址区",
                notes: "了解两千多年前那场惊心动魄的战役，感受历史的苍凉。",
              },
              {
                time: "晚餐",
                activity: "品尝高平特色美食",
                notes: "推荐高平十大碗、烧豆腐、猪头肉等地方风味。",
              },
            ],
            hotelRecommendations: [
              "高平市星级酒店",
              "市区商务连锁酒店",
              "特色客栈",
            ],
            restaurantRecommendations: [
              "高平十大碗体验店",
              "特色烧豆腐餐馆",
              "面食馆（品尝山西面食）",
            ],
            sightseeingRecommendations: [
              "长平之战纪念馆/遗址公园",
              "高平市博物馆",
              "开化寺（宋代壁画）",
            ],
          },
          {
            day: 2,
            theme: "跑过历史长河，探访羊头山风光",
            activities: [
              {
                time: "上午",
                activity: "参加高平马拉松赛",
                notes:
                  "赛道或许会融入历史元素，体验在古战场区域奔跑的独特感受。",
              },
              {
                time: "下午",
                activity: "游览羊头山风景区（炎帝活动地）",
                notes:
                  "传说中炎帝神农在此尝百草、教稼穑，山色秀美，文化底蕴深厚。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用山西面食盛宴",
                notes: "山西面食种类繁多，值得好好品尝。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "地道山西面食馆",
              "市区高评分餐厅",
              "农家菜馆（羊头山附近若有）",
            ],
            sightseeingRecommendations: [
              "羊头山风景区",
              "炎帝陵（若时间和兴趣允许）",
              "定林寺",
              "马拉松赛道沿途",
            ],
          },
        ],
      },
    },

    {
      id: "shanxi-yuncheng-jishan-marathon",
      name: "稷山马拉松",
      distance: "全程、半程、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/shanxi-jishan-marathon.jpeg"),
      routeImage: require("../assets/routeMap/shanxi-jishan-marathon.webp"),
      web: "https://huajiansaishi.saihuitong.com/event?id=653195&mid=68000",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "稷山马拉松 - 探访农耕之源与古寺壁画2日之旅",
        description:
          "参加稷山马拉松，跑过后稷故里，结合赛事探访珍贵的青龙寺元代壁画和稷王庙，感受深厚的农耕文化。",
        days: [
          {
            day: 1,
            theme: "抵达农耕之源，探访古寺壁画",
            activities: [
              {
                time: "下午",
                activity: "抵达稷山县（可经运城中转），入住酒店并领取参赛包",
                notes: "提前规划交通，了解领物详情。",
              },
              {
                time: "傍晚",
                activity: "参观青龙寺，欣赏元代壁画艺术",
                notes: "青龙寺壁画是国宝级文物，艺术价值极高。",
              },
              {
                time: "晚餐",
                activity: "品尝稷山及运城地方风味",
                notes: "试试稷山麻花、各类山西面食等。",
              },
            ],
            hotelRecommendations: ["稷山县城内酒店", "商务宾馆"],
            restaurantRecommendations: [
              "当地特色面馆",
              "家常菜馆",
              "稷山麻花店",
            ],
            sightseeingRecommendations: [
              "青龙寺（必看）",
              "稷王庙（后稷庙）",
              "稷山县博物馆",
            ],
          },
          {
            day: 2,
            theme: "奔跑后稷故里，感受晋南文化",
            activities: [
              {
                time: "上午",
                activity: "参加稷山马拉松",
                notes: "在华夏农耕文明的重要发源地奔跑。",
              },
              {
                time: "下午",
                activity: "赛后放松，可参观马村砖雕墓（宋金墓群）",
                notes: "了解宋金时期的墓葬艺术和社会生活。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用山西晚餐",
                notes: "简单庆祝，回味晋南风情。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["县城餐馆", "运城风味菜馆"],
            sightseeingRecommendations: [
              "马拉松赛道",
              "马村砖雕墓（宋金墓）",
              "大佛寺",
            ],
          },
        ],
      },
    },
    {
      id: "shanxi-jinzhong-pingyao-half-marathon",
      name: "平遥古城半程马拉松",
      distance: "半程、10公里、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约7,000人",
      image: require("../assets/pictures/MarathonPicture/shanxi-pingyaogucheng-half.png"),
      routeImage: require("../assets/routeMap/shanxi-pingyakgucheng-half.png"),
      web: null,
      isCAAcertified: false,
      grade: null,
      gradeImage: null,
      travelPlan: {
        title: "平遥半马 - 穿越世界遗产跑进明清时光2日之旅",
        description:
          "参加独一无二的平遥古城半程马拉松，在世界文化遗产的石板路上奔跑，深度体验保存完好的明清古城。",
        days: [
          {
            day: 1,
            theme: "抵达世遗古城，沉浸明清时光",
            activities: [
              {
                time: "下午",
                activity: "抵达平遥古城站，入住古城内特色客栈并领物",
                notes: "强烈推荐住在古城内，体验更完整。高铁站距古城北门较近。",
              },
              {
                time: "傍晚",
                activity: "登古城墙观全貌，逛明清一条街，访日升昌票号",
                notes: "感受古城的格局，体验晋商文化的发源地。",
              },
              {
                time: "晚餐",
                activity: "品尝平遥特色美食",
                notes: "平遥牛肉、碗秃、莜面栲栳栳等不容错过。",
              },
            ],
            hotelRecommendations: [
              "平遥古城内传统民居客栈（强烈推荐）",
              "古城外酒店",
            ],
            restaurantRecommendations: [
              "古城内特色餐馆",
              "平遥牛肉老字号",
              "面食馆",
              "小吃街",
            ],
            sightseeingRecommendations: [
              "平遥古城墙",
              "明清一条街（南大街）",
              "日升昌票号",
              "平遥县衙",
            ],
          },
          {
            day: 2,
            theme: "穿越古城赛道，续探晋商文化",
            activities: [
              {
                time: "上午",
                activity: "参加平遥古城半程马拉松",
                notes: "在古老的街道和城墙下奔跑，体验感绝无仅有！",
              },
              {
                time: "下午",
                activity:
                  "继续探索古城：参观协同庆票号（地下金库）、镖局博物馆、城隍庙等",
                notes: "古城内景点众多，通票可覆盖大部分。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，观看《又见平遥》演出（可选）",
                notes: "大型情境体验剧，了解平遥故事，需另行购票。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "古城内其他特色餐馆",
              "咖啡馆/酒吧（放松）",
            ],
            sightseeingRecommendations: [
              "马拉松赛道本身",
              "协同庆钱庄博物馆",
              "华北第一镖局博物馆",
              "平遥文庙学宫",
              "城隍庙",
              "《又见平遥》演出（推荐）",
              "双林寺、镇国寺（古城外，需另外安排交通时间）",
            ],
          },
        ],
      },
    },
    {
      id: "shanxi-yangquan-niangziguan-half-marathon",
      name: "阳泉娘子关半程马拉松",
      distance: "半程、3公里欢乐跑",
      date: "2025年05月25日",
      numberOfParticipants: "约6000人",
      image: require("../assets/pictures/MarathonPicture/shanxi-yangquan-niangziguan-half.webp"),
      routeImage: require("../assets/routeMap/shanxi-yangchuanniangziguan-half.webp"),
      web: "https://mp.weixin.qq.com/s/UDOkEVP8n0vtmyOX32Ychg",
      isCAAcertified: true,
      grade: "A1",
      gradeImage: gradeA,
      feature: [
        {
          id: "niangziguan-2025-feature-1",
          title: "天下第九关赛道",
          description:
            "赛事围绕著名的娘子关景区进行，跑者可以体验在雄关古道上奔跑的独特感受。",
        },
        {
          id: "niangziguan-2025-feature-2",
          title: "历史与自然交融",
          description:
            "娘子关不仅有险峻的关隘，还有秀美的瀑布和水乡风光，赛道景观丰富。",
        },
      ],
      travelPlan: {
        title: "阳泉娘子关半程马拉松 - 雄关古韵3日跑旅行程",
        description:
          "参加2025阳泉娘子关半程马拉松，跑过“天下第九关”，体验山西的雄关风情与历史文化。",
        days: [
          {
            day: 1,
            theme: "抵达平定/阳泉与赛前准备/初识娘子关",
            activities: [
              {
                time: "下午",
                activity: "抵达阳泉市或平定县，前往酒店办理入住，领取参赛包。",
                notes: "比赛地点在平定县娘子关镇，可选择住在附近或阳泉市区。",
              },
              {
                time: "傍晚",
                activity: "提前游览娘子关景区部分区域，熟悉环境。",
                notes: "娘子关景区较大，合理安排时间。",
              },
              {
                time: "晚餐",
                activity: "品尝山西面食或平定本地特色菜。",
                notes: "山西面食种类丰富，赛前适量品尝。",
              },
            ],
            hotelRecommendations: [
              "娘子关景区附近客栈或酒店",
              "平定县城内酒店",
              "阳泉市区酒店 (交通需便利)",
            ],
            restaurantRecommendations: [
              "娘子关景区内餐馆 (家常菜)",
              "平定特色面馆",
            ],
            sightseeingRecommendations: ["娘子关关城", "娘子关瀑布"],
          },
          {
            day: 2,
            theme: "马拉松比赛日与关隘揽胜",
            activities: [
              {
                time: "上午",
                activity: "参加 2025阳泉娘子关半程马拉松！",
                notes: "在历史的足迹上奔跑，感受雄关魅力！",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，深度游览娘子关景区，如水上人家、平阳湖等。",
                notes: "根据体力选择游览范围。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛！品尝当地特色“过油肉”等地道山西菜。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上", "可尝试阳泉特色菜肴"],
            sightseeingRecommendations: [
              "娘子关水上人家",
              "固关长城 (如时间充裕且对长城感兴趣)",
            ],
          },
        ],
      },
    },
  ],

  //山东
  shandong: [
    {
      id: "shandong-heze-marathon",
      name: "山东菏泽马拉松",
      distance: "全程、半程、6公里",
      date: "2025年04月26日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/shandong-heze-marathon.webp"),
      routeImage: require("../assets/routeMap/shandong-heze-marathon.jpeg"),
      web: "https://race.shuzixindong.com/offline/#/pages/race/detail?raceId=1000191186",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "菏泽马拉松 - 牡丹盛开季2日赏花之旅",
        description:
          "在牡丹盛开的最美时节参加菏泽马拉松，结合赛事，深度畅游中国牡丹之都的核心景区曹州牡丹园。",
        days: [
          {
            day: 1,
            theme: "抵达花都，牡丹初体验",
            activities: [
              {
                time: "下午",
                activity: "抵达菏泽，入住酒店并领取参赛包",
                notes: "选择交通便利或靠近赛事区域的酒店，留意领物时间和地点。",
              },
              {
                time: "傍晚",
                activity: "初探牡丹园或市区游览",
                notes:
                  "可选择参观菏泽牡丹园或曹州百花园作为预热，或感受菏泽城市风貌。",
              },
              {
                time: "晚餐",
                activity: "品尝鲁西南风味",
                notes:
                  "推荐尝试菏泽面食、地方菜，或著名的单县羊肉汤（菏泽下辖县特产）。",
              },
            ],
            hotelRecommendations: [
              "菏泽银座颐庭酒店",
              "菏泽花都大酒店",
              "华美达酒店（菏泽汽车总站店）",
              "市区连锁酒店",
            ],
            restaurantRecommendations: [
              "地方特色菜馆（鲁菜）",
              "单县羊肉汤馆",
              "菏泽面食馆",
            ],
            sightseeingRecommendations: [
              "菏泽牡丹园",
              "曹州百花园",
              "天香公园",
              "冀鲁豫边区革命纪念馆（红色旅游）",
            ],
          },
          {
            day: 2,
            theme: "花海奔跑，畅游曹州牡丹园",
            activities: [
              {
                time: "上午",
                activity: "参加山东菏泽马拉松",
                notes: "享受在牡丹盛放的城市中奔跑的独特体验！",
              },
              {
                time: "下午",
                activity: "深度游览曹州牡丹园",
                notes:
                  "中国最大的牡丹主题公园，品种繁多，正值盛花期。建议穿着舒适鞋履，预留充足时间（3-4小时+）。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用特色鲁菜",
                notes: "可以选择当地评价好的鲁菜馆，品味地道山东风味。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "特色鲁菜馆",
              "牡丹主题餐厅（如有）",
              "菏泽水煎包",
            ],
            sightseeingRecommendations: [
              "曹州牡丹园（核心推荐）",
              "中国牡丹博物馆（位于曹州牡丹园内）",
              "古今园（也在牡丹园附近）",
            ],
          },
        ],
      },
    },
    {
      id: "shandong-liaocheng-half-marathon",
      name: "聊城半程马拉松",
      distance: "半程、10公里、5公里",
      date: "2025年05月01日",
      numberOfParticipants: "约15,000人",
      image: require("../assets/pictures/MarathonPicture/shandong-liaocheng-half.jpeg"),
      routeImage: require("../assets/routeMap/shandong-liaocheng-half.jpeg"),
      web: null,
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "聊城半马 - 江北水城2日环湖之旅",
        description:
          "参加聊城半程马拉松，深度体验独特的“湖中有城，城中有湖”的水城魅力，游览东昌湖与聊城古城。",
        days: [
          {
            day: 1,
            theme: "抵达水城，漫步湖中之城",
            activities: [
              {
                time: "下午",
                activity: "抵达聊城，入住酒店并领取参赛包",
                notes: "推荐选择东昌湖附近或古城周边的酒店。",
              },
              {
                time: "傍晚",
                activity: "游览聊城古城，登光岳楼",
                notes:
                  "感受中国北方现存最大、保存最完整的“湖中有城、城中有湖”格局，光岳楼是其标志性建筑。",
              },
              {
                time: "晚餐",
                activity: "品尝聊城当地特色小吃",
                notes: "可以试试聊城呱嗒、魏氏熏鸡、高唐驴肉等。",
              },
            ],
            hotelRecommendations: [
              "聊城阿尔卡迪亚国际温泉酒店",
              "东昌府宾馆",
              "古城附近精品酒店/民宿",
            ],
            restaurantRecommendations: ["呱嗒铺", "特色鲁菜馆", "东昌湖鱼馆"],
            sightseeingRecommendations: [
              "聊城古城",
              "光岳楼",
              "东昌湖（可考虑乘船）",
              "山陕会馆",
            ],
          },
          {
            day: 2,
            theme: "环湖奔跑，尽览水城风光",
            activities: [
              {
                time: "上午",
                activity: "参加聊城半程马拉松",
                notes: "赛道预计环绕东昌湖，尽情享受“江北水城”的湖光山色。",
              },
              {
                time: "下午",
                activity: "东昌湖畔放松或参观聊城中国运河文化博物馆",
                notes: "赛后可在湖边公园休息调整，或了解聊城与运河的历史渊源。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用美食",
                notes: "选择心仪的餐厅，好好犒劳自己一番。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "市区高评分餐厅",
              "鲁西风味菜馆",
              "临清烧麦（附近特色）",
            ],
            sightseeingRecommendations: [
              "东昌湖风景区",
              "聊城中国运河文化博物馆",
              "摩天轮（湖边）",
              "马拉松赛道本身也是一道风景",
            ],
          },
        ],
      },
    },
    {
      id: "shandong-weihai-rushan-half-marathon",
      name: "乳山半程马拉松",
      distance: "半程、4.7公里",
      date: "2025年05月11日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/shandong-rushan-half.png"),
      routeImage: require("../assets/routeMap/shandong-rushan-half.jpeg"),
      web: "https://www.marathon.org.cn/race/detail/XrYE2g8DvQbLm647y53e",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "乳山半马 - 畅跑银滩福地乐享山海2日之旅",
        description:
          "参加乳山半程马拉松，在“母爱圣地、幸福乳山”的赛道上奔跑，结合赛事游览银滩和大乳山风景区。",
        days: [
          {
            day: 1,
            theme: "抵达滨海福地，乐享银滩风情",
            activities: [
              {
                time: "下午",
                activity: "抵达乳山市（可经威海中转），入住酒店并领取参赛包",
                notes: "可选择住在市区或银滩旅游度假区内。",
              },
              {
                time: "傍晚",
                activity: "漫步银滩旅游度假区",
                notes: "感受中国北方第一长滩的魅力，享受海滨休闲时光。",
              },
              {
                time: "晚餐",
                activity: "品尝乳山海鲜，尤其是牡蛎",
                notes: "乳山牡蛎非常有名，时令海鲜值得一试。",
              },
            ],
            hotelRecommendations: [
              "乳山银滩度假酒店",
              "乳山市区酒店",
              "海景公寓",
            ],
            restaurantRecommendations: [
              "银滩附近海鲜餐厅",
              "牡蛎特色餐馆",
              "本地家常菜馆",
            ],
            sightseeingRecommendations: [
              "银滩旅游度假区",
              "福如东海文化园（银滩内）",
              "潮汐湖",
            ],
          },
          {
            day: 2,
            theme: "悦跑福地赛道，登临大乳山景",
            activities: [
              {
                time: "上午",
                activity: "参加乳山半程马拉松",
                notes: "赛道预计展现乳山的滨海风光或城市面貌。",
              },
              {
                time: "下午",
                activity: "游览大乳山滨海旅游度假区",
                notes:
                  "国家AAAA级景区，以“母爱温情、福地养生”为主题，山海景色优美。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用海滨晚餐",
                notes: "在海风中结束愉快的跑马行程。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "大乳山景区餐厅",
              "市区评价好的餐厅",
              "海鲜烧烤",
            ],
            sightseeingRecommendations: [
              "大乳山滨海旅游度假区（核心推荐）",
              "圣水宫（大乳山内）",
              "多福山国际养生旅游度假区",
              "马拉松赛道",
            ],
          },
        ],
      },
    },
    {
      id: "shandong-jinan-jiyang-half-marathon",
      name: "济阳区第二届半程马拉松",
      distance: "半程、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约5,000人",
      image: require("../assets/pictures/MarathonPicture/shandong-jiyang-half.png"),
      routeImage: require("../assets/routeMap/shandong-jiyang-half.png"),
      web: "https://mp.weixin.qq.com/s/wTm61YeTKUMCgr2m4O7X7w",
      isCAAcertified: false,
      travelPlan: {
        title: "济阳半马 - 黄河岸边体验济南北跨2日之旅",
        description:
          "参加济阳半程马拉松，感受济南“北起”战略下的新区活力，结合赛事体验黄河文化与当地风情。",
        days: [
          {
            day: 1,
            theme: "抵达济南北部，初识黄河风貌",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达济阳区（可经济南市区中转），入住酒店并领取参赛包",
                notes: "济阳位于黄河北岸，提前规划好交通方式。",
              },
              {
                time: "傍晚",
                activity: "游览济阳县城或附近的黄河公园/观景点",
                notes: "感受黄河的壮阔，或在县城公园散步放松。",
              },
              {
                time: "晚餐",
                activity: "品尝济南及济阳地方特色",
                notes: "可以尝试鲁菜、济南把子肉、甜沫等，或济阳本地菜肴。",
              },
            ],
            hotelRecommendations: ["济阳区内酒店", "商务连锁酒店"],
            restaurantRecommendations: [
              "本地鲁菜馆",
              "济南特色小吃店",
              "黄河鲤鱼特色餐厅（若有）",
            ],
            sightseeingRecommendations: [
              "黄河风景区（济阳段）",
              "济阳县博物馆",
              "澄波湖公园",
            ],
          },
          {
            day: 2,
            theme: "奔跑济阳赛道，感受新区脉搏",
            activities: [
              {
                time: "上午",
                activity: "参加济阳区半程马拉松",
                notes: "体验在济南新旧动能转换起步区核心区域奔跑。",
              },
              {
                time: "下午",
                activity: "赛后放松，可参观当地现代农业示范园或特色小镇",
                notes: "了解济阳作为农业大区的特色产业。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用当地晚餐",
                notes: "结束济阳跑马之旅。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["县城评价好的餐厅", "特色农家乐"],
            sightseeingRecommendations: [
              "马拉松赛道",
              "现代农业产业园",
              "安徒生童话主题乐园（若亲子）",
              "垛石民俗文化旅游村",
            ],
          },
        ],
      },
    },
  ],

  //河南
  henan: [
    {
      id: "henan-anyang-marathon",
      name: "安阳马拉松赛",
      distance: "全程、半程、5公里",
      date: "2025年04月13日⚠️（延期至4月26日）",
      numberOfParticipants: "约18,000人",
      image: require("../assets/pictures/MarathonPicture/henan-anyang-marathon.png"),
      routeImage: require("../assets/routeMap/henan-anyang-marathon.png"),
      web: "https://mp.weixin.qq.com/s/keDHB_ImNWse5YkRepAEAw",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "安阳马拉松 - 探寻殷墟与文字起源2日之旅",
        description:
          "结合安阳马拉松，深度体验这座千年古都的历史文化，探访殷墟遗址与中国文字博物馆。",
        days: [
          {
            day: 1,
            theme: "抵达安阳，探寻文字与殷商之源",
            activities: [
              {
                time: "下午",
                activity: "抵达安阳，入住酒店并领取参赛包",
                notes: "建议选择靠近市中心或赛事起终点区域的酒店。",
              },
              {
                time: "傍晚",
                activity: "参观中国文字博物馆",
                notes:
                  "系统了解汉字的起源与发展，感受中华文化魅力。建议提前预约。",
              },
              {
                time: "晚餐",
                activity: "品尝安阳特色美食",
                notes: "推荐安阳三熏、扁粉菜、粉浆饭等地道风味。",
              },
            ],
            hotelRecommendations: [
              "安阳迎宾馆",
              "华强诺华廷酒店",
              "安阳富力万达嘉华酒店",
              "市区快捷连锁酒店",
            ],
            restaurantRecommendations: [
              "安阳三熏老店",
              "特色扁粉菜馆",
              "豫菜馆（品尝河南菜）",
            ],
            sightseeingRecommendations: [
              "中国文字博物馆",
              "安阳市博物馆（若时间允许）",
              "文峰塔/天宁寺",
            ],
          },
          {
            day: 2,
            theme: "马拉松日，穿越殷墟访古",
            activities: [
              {
                time: "上午",
                activity: "参加安阳马拉松赛",
                notes: "在千年古都的赛道上奔跑，感受历史与现代的交融！",
              },
              {
                time: "下午",
                activity: "参观殷墟博物苑（殷墟遗址）",
                notes:
                  "世界文化遗产，甲骨文发现地，中国商代晚期都城遗址。预留充足时间（至少3-4小时）。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用丰盛晚餐",
                notes: "可以选择当地评价好的餐厅，犒劳自己。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "殷墟附近特色农家院",
              "市区高评分餐厅",
              "道口烧鸡（安阳下滑县特产，市区可买到）",
            ],
            sightseeingRecommendations: [
              "殷墟博物苑（必去）",
              "马拉松赛道沿途风光",
              "洹水公园（若有时间放松）",
            ],
          },
        ],
      },
    },
  ],

  //河北
  hebei: [
    {
      id: "hebei-qinhuangdao-marathon",
      name: "秦皇岛马拉松",
      distance: "全程、半程、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约17,000人",
      image: require("../assets/pictures/MarathonPicture/hebei-qinhuangdao-marathon.jpeg"),
      routeImage: require("../assets/routeMap/hebei-qinhuangdao-marathon.jpeg"),
      web: "https://mp.weixin.qq.com/s/EeM1cbDlmyHzpK8TPZFQOg?search_click_id=1590164944685399369-1745322809731-5024661858",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "秦皇岛马拉松 - 畅跑渤海之滨探寻长城起点2日之旅",
        description:
          "参加秦皇岛马拉松，在美丽的渤海之滨感受奔跑的快乐，结合赛事探访山海关、北戴河等著名景点。",
        days: [
          {
            day: 1,
            theme: "抵达滨海名城，探访长城起点",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达秦皇岛市（或北戴河/山海关站），入住酒店并领取参赛包",
                notes: "根据住宿地点和交通方式选择合适的站点。",
              },
              {
                time: "傍晚",
                activity: "游览山海关景区，参观“天下第一关”或老龙头",
                notes: "感受长城入海的壮丽，或登临雄关，提前确认景区关闭时间。",
              },
              {
                time: "晚餐",
                activity: "品尝秦皇岛海鲜或当地特色菜",
                notes: "靠海吃海，各类海鲜值得尝试。",
              },
            ],
            hotelRecommendations: [
              "秦皇岛市区酒店",
              "北戴河度假酒店",
              "山海关附近酒店",
            ],
            restaurantRecommendations: [
              "海鲜大排档/酒楼",
              "本地特色菜馆",
              "北戴河海鲜餐厅",
            ],
            sightseeingRecommendations: [
              "山海关景区（天下第一关、老龙头）",
              "孟姜女庙",
              "角山长城",
            ],
          },
          {
            day: 2,
            theme: "奔跑渤海之滨，畅游避暑胜地",
            activities: [
              {
                time: "上午",
                activity: "参加秦皇岛马拉松",
                notes: "享受在海滨城市奔跑的舒畅体验，赛道预计风光不错。",
              },
              {
                time: "下午",
                activity: "赛后放松，前往北戴河海滨游览",
                notes: "可在鸽子窝公园观海，或在海滩漫步，感受“夏都”的魅力。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用海滨晚餐",
                notes: "在海边餐厅庆祝，结束愉快的跑马之旅。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "北戴河海鲜餐厅",
              "市区评价好的餐厅",
              "特色烧烤",
            ],
            sightseeingRecommendations: [
              "马拉松赛道风光",
              "北戴河风景区（鸽子窝、老虎石、海滨浴场）",
              "秦皇求仙入海处",
              "秦皇岛野生动物园",
            ],
          },
        ],
      },
    },
    {
      id: "hebei-handan-shexian-half-marathon",
      name: "涉县半程马拉松",
      distance: "半程、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约7,000人",
      image: require("../assets/pictures/MarathonPicture/hebei-shexian-marathon.png"),
      routeImage: null,
      web: "https://mp.weixin.qq.com/s/LiA49taA6vNGBRbyP1Zy7A?search_click_id=12568634216911918178-1745322896770-3097153177",
      isCAAcertified: false,
      grade: null,
      gradeImage: null,
      travelPlan: {
        title: "涉县半马 - 跑太行红色圣地访娲皇宫阙2日之旅",
        description:
          "参加涉县半程马拉松，在太行山麓感受红色历史，结合赛事探访独特的娲皇宫悬空寺庙群。",
        days: [
          {
            day: 1,
            theme: "抵达太行圣地，追寻红色足迹",
            activities: [
              {
                time: "下午",
                activity: "抵达涉县（可经邯郸中转），入住酒店并领取参赛包",
                notes: "涉县位于太行山区，注意交通规划。",
              },
              {
                time: "傍晚",
                activity: "参观八路军一二九师司令部旧址",
                notes: "重温革命历史，感受红色文化教育。",
              },
              {
                time: "晚餐",
                activity: "品尝涉县地方特色",
                notes: "可以尝试涉县核桃相关食品或当地农家菜。",
              },
            ],
            hotelRecommendations: ["涉县县城内酒店", "商务宾馆"],
            restaurantRecommendations: [
              "当地特色餐馆",
              "农家乐",
              "品尝核桃宴（如有）",
            ],
            sightseeingRecommendations: [
              "八路军一二九师司令部旧址",
              "一二九师陈列馆",
              "韩王山",
            ],
          },
          {
            day: 2,
            theme: "奔跑太行山下，探访娲皇宫阙",
            activities: [
              {
                time: "上午",
                activity: "参加涉县半程马拉松",
                notes: "在太行山区的环境中奔跑，体验山地风光。",
              },
              {
                time: "下午",
                activity: "游览娲皇宫景区",
                notes:
                  "中国五大悬空寺之一，规模宏大，石刻精美，务必留足时间参观。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用当地晚餐",
                notes: "简单庆祝，回味涉县之旅。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["县城餐馆", "尝试其他地方菜"],
            sightseeingRecommendations: [
              "娲皇宫（核心推荐）",
              "清泉寺",
              "太行五指山（较远，需另行安排）",
              "马拉松赛道风景",
            ],
          },
        ],
      },
    },
    {
      id: "hebei-baoding-xushui-gwm-half-marathon",
      name: "长城汽车智慧工厂半程马拉松",
      distance: "半程、8公里、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/hebei-changchengfactory-half.png"),
      routeImage: require("../assets/routeMap/hebei-changchengfactory-half.jpeg"),
      web: "https://mp.weixin.qq.com/s/TGpFU5Z7roRSZeL_A5nKlQ",
      isCAAcertified: false,
      travelPlan: {
        title: "长城汽车半马 - 跑进智慧工厂体验保定文化2日之旅",
        description:
          "参加长城汽车智慧工厂半程马拉松，感受现代化工业园区的独特赛道，结合赛事游览历史文化名城保定。",
        days: [
          {
            day: 1,
            theme: "抵达京畿重镇，探访古城遗韵",
            activities: [
              {
                time: "下午",
                activity: "抵达保定市（或徐水区），入住酒店并领取参赛包",
                notes: "保定交通便利，高铁、火车均可达。",
              },
              {
                time: "傍晚",
                activity: "游览保定市区的古莲花池或直隶总督署",
                notes: "感受这座历史名城的文化底蕴。",
              },
              {
                time: "晚餐",
                activity: "品尝保定特色美食",
                notes: "著名的驴肉火烧一定要尝！还有白运章包子等。",
              },
            ],
            hotelRecommendations: [
              "保定市区酒店",
              "徐水区酒店",
              "连锁商务酒店",
            ],
            restaurantRecommendations: [
              "驴肉火烧老店",
              "白运章包子铺",
              "保定会馆（品尝直隶官府菜）",
            ],
            sightseeingRecommendations: [
              "古莲花池",
              "直隶总督署博物馆",
              "大慈阁",
              "保定军校纪念馆",
            ],
          },
          {
            day: 2,
            theme: "奔跑智慧工厂，感受工业脉搏",
            activities: [
              {
                time: "上午",
                activity: "参加长城汽车智慧工厂半程马拉松",
                notes: "体验在现代化汽车工厂园区内奔跑的独特经历。",
              },
              {
                time: "下午",
                activity: "赛后放松，可游览徐水当地公园或返回保定市区继续游览",
                notes: "根据个人兴趣和时间安排。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，再尝保定风味",
                notes: "结束独特的工业主题跑马之旅。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["徐水当地餐馆", "保定市区其他特色餐厅"],
            sightseeingRecommendations: [
              "马拉松赛道（感受工厂环境）",
              "徐水釜山（瀑河水库）",
              "保定市其他景点",
            ],
          },
        ],
      },
    },
  ],

  // 新疆
  xinjiang: [
    {
      id: "xinjiang-kuitun-races",
      name: "新疆奎屯马拉松系列赛 (含半马及10公里精英赛)",
      distance: "半程、10公里(精英组/大众组)、5公里",
      date: "2025年05月02日",
      numberOfParticipants: "约12,000人 (含精英赛)",
      image: require("../assets/pictures/MarathonPicture/xinjiang-kuitun-half.jpeg"),
      routeImage: require("../assets/routeMap/xinjiang-kuitun-half.png"),
      web: "https://kuitun.gusto.cn/",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "奎屯马拉松 - 感受兵地新城与北疆门户2日体验",
        description:
          "参加奎屯马拉松系列赛，体验天山北麓的兵地融合文化，感受这座北疆交通枢纽城市的活力。",
        days: [
          {
            day: 1, // 周四 - 赛前一天 (5月1日)
            theme: "抵达奎屯，感受兵团新城",
            activities: [
              {
                time: "下午",
                activity: "抵达奎屯市，入住酒店并领取参赛包",
                notes: "奎屯交通便利，可选择火车或飞机至附近机场再转车。",
              },
              {
                time: "傍晚",
                activity: "市区游览，初步感受奎屯市貌",
                notes: "可参观市中心广场、公园，了解奎屯作为兵团城市的发展。",
              },
              {
                time: "晚餐",
                activity: "品尝地道新疆美食",
                notes: "推荐新疆拌面、抓饭、烤肉、烤包子等。",
              },
            ],
            hotelRecommendations: [
              "奎屯宾馆",
              "奎屯市中心商务酒店",
              "连锁快捷酒店",
            ],
            restaurantRecommendations: [
              "知名新疆风味餐厅",
              "特色拌面馆",
              "清真寺附近小吃",
            ],
            sightseeingRecommendations: [
              "奎屯市中心广场",
              "西公园",
              "了解兵团文化的相关场所（若有）",
            ],
          },
          {
            day: 2, // 周五 - 比赛日 (5月2日)
            theme: "兵地同跑，展望北疆风光",
            activities: [
              {
                time: "上午",
                activity: "参加奎屯半程马拉松或10公里赛",
                notes:
                  "体验在新疆现代化城市奔跑的感觉，精英赛选手可关注高水平竞技。",
              },
              {
                time: "下午",
                activity: "赛后放松，或考虑前往独山子大峡谷（可选，需时较长）",
                notes:
                  "奎屯是通往伊犁、赛里木湖等北疆景区的门户。若时间充裕且交通方便，可考虑短途游览独山子大峡谷（距离奎屯约几十公里）。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，继续新疆美食探索",
                notes: "可以尝试大盘鸡、馕坑肉等。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "新疆特色大盘鸡店",
              "夜市小吃",
              "市区高评分餐厅",
            ],
            sightseeingRecommendations: [
              "马拉松赛道",
              "奎屯市容",
              "独山子大峡谷（可选，注意时间和交通安排）",
              "规划前往北疆其他景点的行程",
            ],
          },
        ],
      },
    },
    {
      id: "xinjiang-kuche-marathon",
      name: "库车马拉松",
      distance: "全程、半程、5公里",
      date: "2025年05月04日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/xinjiang-kuche-marathon.png"),
      routeImage: require("../assets/routeMap/xinijang-kuche-marathon.png"),
      web: "https://kuche.sport-china.cn/",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "库车马拉松 - 探秘古龟兹与丝路风情2日之旅",
        description:
          "参加库车马拉松，在古丝绸之路重镇奔跑，结合赛事探寻古龟兹国的历史遗迹和独特的南疆风情。",
        days: [
          {
            day: 1, // 周六 - 赛前一天 (5月3日)
            theme: "抵达龟兹故都，探访古城遗迹",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达库车市（可乘飞机至库车龟兹机场），入住酒店并领物",
                notes: "提前了解交通方式和领物信息。",
              },
              {
                time: "傍晚",
                activity: "参观苏巴什佛寺遗址或库车王府",
                notes: "感受古龟兹国的历史沧桑，苏巴什佛寺遗址是重要历史见证。",
              },
              {
                time: "晚餐",
                activity: "品尝库车特色美食",
                notes: "推荐库车大馕、羊肉串、手抓饭以及当地特色瓜果。",
              },
            ],
            hotelRecommendations: [
              "库车饭店",
              "库车天缘国际酒店",
              "当地特色客栈",
            ],
            restaurantRecommendations: [
              "当地维吾尔风味餐厅",
              "烤肉馕饼店",
              "水果巴扎",
            ],
            sightseeingRecommendations: [
              "苏巴什佛寺遗址",
              "库车王府",
              "库车大寺",
              "库车老城（部分区域）",
            ],
          },
          {
            day: 2, // 周日 - 比赛日 (5月4日)
            theme: "丝路奔跑，领略峡谷石窟",
            activities: [
              {
                time: "上午",
                activity: "参加库车马拉松",
                notes: "在充满历史感的赛道上奔跑，体验南疆风情。",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，或选择前往库车天山神秘大峡谷（可选，需包车或自驾，注意时间）",
                notes:
                  "库车周边有克孜尔千佛洞、天山神秘大峡谷等著名景点，但距离市区较远。赛后下午时间紧张，大峡谷相对近一些，但也需妥善安排交通和时间。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，回味龟兹风味",
                notes: "享受轻松的晚餐时光。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "市区特色餐馆",
              "夜市（若有）",
              "可以再尝尝库车大馕",
            ],
            sightseeingRecommendations: [
              "马拉松赛道",
              "库车博物馆",
              "库车天山神秘大峡谷（可选，务必规划好时间交通）",
              "克孜尔千佛洞（距离较远，赛后当天基本不现实，可考虑多停留一天前往）",
            ],
          },
        ],
      },
    },
    {
      id: "xinjiang-yiliriver-marathon",
      name: "伊犁河马拉松",
      distance: "全程/半程/5公里",
      date: "2025年5月18日",
      numberOfParticipants: "约15000人",
      image: require("../assets/pictures/MarathonPicture/xinjiang-yiliriver-marathon.jpeg"),
      // --- Placeholder ---
      routeImage: require("../assets/routeMap/xinjiang-yiliriver-marathon.png"),

      web: "https://ylhmls.xempower.cn/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      feature: [
        {
          id: "location-feature",
          title: "城市特色",
          description:
            "在“塞外江南”伊犁奔跑，体验伊犁河谷的壮美风光与多元文化。",
        },
        {
          id: "scenery",
          title: "沿途风光",
          description: "赛道可能沿伊犁河展开，风景优美，但具体以官方公布为准。",
        },
      ],
      travelPlan: {
        title: `伊犁河马拉松 - 塞外江南2日风情体验`,
        description: `结合伊犁河马拉松，领略伊犁河谷的自然风光和哈萨克风情。`,
        days: [
          {
            day: 1,
            theme: "抵达伊宁与城市初探",
            activities: [
              {
                time: "下午",
                activity: "抵达伊宁市，入住酒店。",
                notes: "伊宁是伊犁哈萨克自治州的首府。",
              },
              {
                time: "傍晚",
                activity:
                  "漫步伊犁河大桥，欣赏伊犁河景色；或前往喀赞其民俗旅游区感受当地民俗风情。",
                notes: "喀赞其保留了较为传统的维吾尔族民居和生活方式。",
              },
              {
                time: "晚餐",
                activity:
                  "品尝地道新疆美食，如烤羊肉串、抓饭、大盘鸡、拉条子等。",
                notes: "伊宁美食选择丰富。",
              },
            ],
            hotelRecommendations: [
              "伊宁瑞阳皇冠酒店",
              "伊宁美景大酒店",
              "伊宁市中心各类酒店",
              "喀赞其特色民宿",
            ],
            restaurantRecommendations: [
              "当地各类清真餐厅",
              "苏莱曼抓饭",
              "艾勒喀斯尔美食宫",
              "各类路边烧烤摊",
            ],
            sightseeingRecommendations: [
              "伊犁河大桥",
              "喀赞其民俗旅游区",
              "拜图拉清真寺",
              "伊犁州博物馆",
              "汉人街（体验当地巴扎）",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与草原风光",
            activities: [
              {
                time: "上午",
                activity: `参加 2025伊犁河马拉松 比赛！`,
                notes: "体验在伊犁河畔奔跑的感觉。",
              },
              {
                time: "下午",
                activity:
                  "赛后可选择前往附近的草原（如那拉提草原、喀拉峻草原，需较长交通时间，请提前规划）感受草原风光，或在伊宁市区休整。",
                notes:
                  "五月伊犁草原逐渐变绿，景色宜人，但著名草原距离伊宁市区较远。",
              },
              {
                time: "晚餐",
                activity:
                  "享用晚餐，购买一些新疆特产如干果、薰衣草制品（若当季）。",
                notes: "伊犁薰衣草盛花期通常在6-7月。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上"],
            sightseeingRecommendations: [
              "那拉提草原 (Nalati Grassland) - 距离远",
              "喀拉峻草原 (Kalajun Grassland) - 距离远",
              "赛里木湖 (Sayram Lake) - 距离远",
              "霍尔果斯口岸 (若时间充裕且感兴趣)",
              "图开沙漠",
            ],
          },
        ],
      },
    },
  ],

  // 湖北
  hubei: [
    {
      id: "hubei-enshi-laifeng-marathon",
      name: "湘鄂龙凤马拉松",
      distance: "全程、半程、8公里、7公里",
      date: "2025年05月02日",
      numberOfParticipants: "约23,000人",
      image: require("../assets/pictures/MarathonPicture/hubei-longshanlaifeng-marathon.png"),
      routeImage: require("../assets/routeMap/hubei-longshanlaifeng-marathon.jpeg"),
      web: "http://longfengmarathon.com/web/pc_website_template/#/index?website_id=29",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "湘鄂龙凤马拉松 - 探寻武陵秘境与土苗风情2日之旅",
        description:
          "参加湘鄂龙凤马拉松，深入武陵山区腹地，体验独特的土家族、苗族文化，奔跑在山水画卷之中。",
        days: [
          {
            day: 1,
            theme: "抵达边城来凤，初探土苗风情",
            activities: [
              {
                time: "下午",
                activity: "抵达来凤县，入住酒店并领取参赛包",
                notes:
                  "可选择飞抵恩施或周边城市机场/火车站后转乘交通工具前来凤。",
              },
              {
                time: "傍晚",
                activity: "游览来凤县城，感受土家苗寨氛围",
                notes: "可以逛逛县城街道，寻找当地特色建筑或文化标志。",
              },
              {
                time: "晚餐",
                activity: "品尝恩施及来凤地道美食",
                notes: "推荐尝试土家腊肉、合渣、油茶汤、社饭、各种酸菜等。",
              },
            ],
            hotelRecommendations: [
              "来凤县城内酒店",
              "特色民族风情客栈",
              "商务型酒店",
            ],
            restaurantRecommendations: [
              "土家风味餐馆",
              "苗家酸汤鱼",
              "当地特色小吃店",
            ],
            sightseeingRecommendations: [
              "来凤县城",
              "酉水河风光带（部分）",
              "当地民族文化广场或博物馆（若有）",
            ],
          },
          {
            day: 2,
            theme: "龙凤赛道奔跑，饱览山水画卷",
            activities: [
              {
                time: "上午",
                activity: "参加湘鄂龙凤马拉松",
                notes:
                  "赛道预计风景优美，穿越山水，充分展现恩施地区的自然生态。",
              },
              {
                time: "下午",
                activity: "赛后放松，或参观附近的仙佛寺",
                notes:
                  "仙佛寺是来凤县著名景点，若时间和体力允许，可以前往参观。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用土家特色宴",
                notes: "与跑友一同庆祝，体验丰盛的土家晚餐。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "特色土家菜馆",
              "庆祝晚宴餐厅",
              "农家乐（若赛道周边有）",
            ],
            sightseeingRecommendations: [
              "马拉松赛道风光",
              "仙佛寺",
              "杨梅古寨（若方便到达）",
              "体验当地非遗文化项目（如摆手舞）",
            ],
          },
        ],
      },
    },
  ],

  // 辽宁
  liaoning: [
    {
      id: "liaoning-dalian-marathon",
      name: "大连马拉松赛",
      distance: "全程、半程、7公里",
      date: "2025年05月11日",
      numberOfParticipants: "约33,000人",
      image: require("../assets/pictures/MarathonPicture/liaoning-dalian-marathon.jpg"),
      routeImage: require("../assets/routeMap/liaoning-dalian-marathon.jpg"),
      web: "https://www.dlmls.org/match/detail/myenroll?match_id=10258",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "大连马拉松 - 畅跑浪漫之都经典海岸线2日之旅",
        description:
          "参加中国历史最悠久的马拉松赛事之一，在大连这条风景如画的经典滨海赛道上，感受“浪漫之都”的魅力。",
        days: [
          {
            day: 1,
            theme: "抵达浪漫之都，感受海滨风情",
            activities: [
              {
                time: "下午",
                activity: "抵达大连市，入住酒店并领取参赛包",
                notes:
                  "大连交通便利，机场、火车站选择多样，酒店建议选在赛道附近或市中心。",
              },
              {
                time: "傍晚",
                activity: "游览星海广场，或漫步滨海路西段",
                notes:
                  "感受亚洲最大城市广场的气势，或提前熟悉部分赛道，欣赏海岸风光。",
              },
              {
                time: "晚餐",
                activity: "品尝大连特色海鲜",
                notes: "大连海鲜名声在外，种类丰富，不容错过。",
              },
            ],
            hotelRecommendations: [
              "星海广场周边酒店",
              "中山广场附近酒店",
              "滨海路沿线酒店",
            ],
            restaurantRecommendations: [
              "知名海鲜酒楼",
              "特色海鲜烧烤/排挡",
              "本地菜馆（尝尝焖子）",
            ],
            sightseeingRecommendations: [
              "星海广场",
              "滨海路",
              "中山广场（看近代建筑群）",
              "俄罗斯风情街",
            ],
          },
          {
            day: 2,
            theme: "驰骋最美赛道，畅享海风阳光",
            activities: [
              {
                time: "上午",
                activity: "参加第35届大连马拉松赛",
                notes: "享受奔跑在著名滨海路上的快感，阳光、海风伴你前行！",
              },
              {
                time: "下午",
                activity: "赛后放松，可前往付家庄或老虎滩海洋公园",
                notes: "选择一个海滨浴场放松，或参观著名的海洋主题公园。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，海鲜大餐继续！",
                notes: "用一顿丰盛的海鲜犒劳自己，庆祝完赛。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "海鲜自助餐",
              "高评分海鲜餐厅",
              "大连老菜馆",
            ],
            sightseeingRecommendations: [
              "滨海路（赛道精华）",
              "付家庄海滨浴场",
              "老虎滩海洋公园",
              "大连贝壳博物馆",
            ],
          },
        ],
      },
    },
    {
      id: "liaoning-huludao-marathon",
      name: "葫芦岛马拉松",
      distance: "全程、半程、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约12,000人",
      image: require("../assets/pictures/MarathonPicture/liaoning-huludao-marathon.png"),
      routeImage: require("../assets/routeMap/liaoning-huludao-marathon.png"),
      web: "https://mp.weixin.qq.com/s/eift6nbGgkLkhw841xlYxQ",
      isCAAcertified: false,
      grade: null,
      gradeImage: null,
      travelPlan: {
        title: "葫芦岛马拉松 - 探访关外古城与滨海风光2日之旅",
        description:
          "参加“跑遍辽宁”系列赛之葫芦岛站，结合赛事游览保存完好的兴城古城，体验关外海滨的独特魅力。",
        days: [
          {
            day: 1,
            theme: "抵达关外海滨，探访兴城古城",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达葫芦岛市，入住酒店（可选择葫芦岛市区或兴城市区）并领物",
                notes: "根据个人偏好和交通便利性选择住宿地。",
              },
              {
                time: "傍晚",
                activity: "深度游览兴城古城",
                notes: "中国保存最完好的四座明代古城之一，值得花时间细细品味。",
              },
              {
                time: "晚餐",
                activity: "品尝葫芦岛或兴城海鲜及地方菜",
                notes: "靠海吃海，同时可以尝试辽宁地方特色。",
              },
            ],
            hotelRecommendations: [
              "兴城古城内/外酒店",
              "葫芦岛市区酒店",
              "海滨度假酒店",
            ],
            restaurantRecommendations: [
              "兴城海鲜餐馆",
              "葫芦岛海鲜烧烤",
              "辽菜馆",
            ],
            sightseeingRecommendations: [
              "兴城古城（城墙、文庙、祖氏石坊等）",
              "兴城海滨风景区",
              "兴城首山",
            ],
          },
          {
            day: 2,
            theme: "畅跑滨海大道，乐享沙滩阳光",
            activities: [
              {
                time: "上午",
                activity: "参加葫芦岛马拉松",
                notes: "体验在辽宁滨海城市奔跑的乐趣。",
              },
              {
                time: "下午",
                activity: "赛后放松，可前往龙湾海滨或兴城海滨浴场",
                notes: "在沙滩上散步、休息，享受海边的闲适。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，品味海滨风味",
                notes: "继续享用当地海鲜或特色菜肴。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "海边餐厅",
              "本地人推荐的餐馆",
              "海鲜市场（可购买加工）",
            ],
            sightseeingRecommendations: [
              "马拉松赛道",
              "龙湾海滨",
              "兴城海滨浴场",
              "葫芦山庄（民俗文化）",
            ],
          },
        ],
      },
    },
  ],

  // 吉林
  jilin: [
    {
      id: "jilin-changchun-marathon",
      name: "长春马拉松",
      distance: "全程、半程、6.8公里欢乐跑",
      date: "2025年05月25日",
      numberOfParticipants: "约35000人",
      image: require("../assets/pictures/MarathonPicture/jilin-changchun-marathon.png"),
      routeImage: require("../assets/routeMap/jilin-changchun-marathon.jpg"),
      web: "https://www.changchunmarathon.com/",
      isCAAcertified: true,
      grade: "A1",
      gradeImage: gradeA,
      feature: [
        {
          id: "changchun-2025-feature-1",
          title: "北国春城风采",
          description:
            "赛道将展示长春这座“森林城”和“汽车城”的城市风貌与绿化成就。",
        },
        {
          id: "changchun-2025-feature-2",
          title: "大规模城市盛会",
          description: "作为东北地区的重要马拉松赛事，参赛人数众多，氛围热烈。",
        },
      ],
      travelPlan: {
        title: "长春马拉松 - 电影与森林之城3日跑旅",
        description:
          "参加2025长春马拉松，感受“北国春城”的魅力，探访电影摇篮与净月潭风光。",
        days: [
          {
            day: 1,
            theme: "抵达长春与赛前准备/伪满皇宫探秘",
            activities: [
              {
                time: "下午",
                activity: "抵达长春，前往酒店办理入住，领取参赛包。",
                notes: "建议选择南关区或赛道沿线交通便利的酒店。",
              },
              {
                time: "傍晚",
                activity: "参观伪满皇宫博物院，了解长春的一段特殊历史。",
                notes: "控制参观时间，避免劳累。",
              },
              {
                time: "晚餐",
                activity: "品尝东北菜或朝鲜族特色美食。",
                notes: "赛前饮食宜清淡。",
              },
            ],
            hotelRecommendations: [
              "长春香格里拉大酒店 (豪华)",
              "长春凯悦酒店 (高端)",
              "全季酒店或汉庭酒店 (经济连锁)",
            ],
            restaurantRecommendations: [
              "老昌春饼 (本地特色)",
              "元奶奶包饭 (朝鲜族风味)",
            ],
            sightseeingRecommendations: ["伪满皇宫博物院", "文化广场/人民大街"],
          },
          {
            day: 2,
            theme: "马拉松比赛日与净月潭漫游",
            activities: [
              {
                time: "上午",
                activity: "参加 2025长春马拉松！",
                notes: "在春城赛道上挥洒汗水！",
              },
              {
                time: "下午",
                activity: "赛后放松，可前往净月潭国家森林公园，享受森林氧吧。",
                notes: "公园较大，可选择电瓶车游览部分景点。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛！品尝地道的东北铁锅炖或烧烤。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上", "可尝试一些有特色的本地烧烤店"],
            sightseeingRecommendations: [
              "净月潭国家森林公园",
              "长影世纪城 (电影主题公园，如感兴趣且体力允许)",
            ],
          },
        ],
      },
    },
  ],

  // 安徽
  anhui: [
    {
      id: "anhui-anqing-huaining-marathon",
      name: "怀宁马拉松",
      distance: "全程、半程、6公里、3公里",
      date: "2025年05月11日",
      numberOfParticipants: "约10,000人",
      image: require("../assets/pictures/MarathonPicture/anhui-huaining-marathon.jpeg"),
      routeImage: require("../assets/routeMap/anhui-huaining-marathon.jpeg"),
      web: "待补充官方链接",
      isCAAcertified: true,
      grade: "B",
      gradeImage: gradeB,
      travelPlan: {
        title: "怀宁马拉松 - 探寻皖江文化与名人故里2日之旅",
        description:
          "参加怀宁马拉松，跑过陈独秀、邓稼先等名人故里，感受深厚的皖江文化底蕴和秀美的皖南风光。",
        days: [
          {
            day: 1,
            theme: "抵达文化之乡，探寻名人足迹",
            activities: [
              {
                time: "下午",
                activity: "抵达怀宁县（可经安庆中转），入住酒店并领取参赛包",
                notes: "提前规划好交通路线，留意领物信息。",
              },
              {
                time: "傍晚",
                activity: "参观陈独秀或邓稼先相关纪念场所（如故居、纪念馆）",
                notes: "了解怀宁的人文历史，感受先辈风采，请提前确认开放时间。",
              },
              {
                time: "晚餐",
                activity: "品尝怀宁及安庆地方特色菜",
                notes: "可以尝试皖河鱼鲜、怀宁贡糕、安庆包子等地道风味。",
              },
            ],
            hotelRecommendations: [
              "怀宁县城内酒店",
              "安庆市区酒店（若选择住在安庆）",
              "商务快捷酒店",
            ],
            restaurantRecommendations: [
              "特色徽菜馆",
              "当地家常菜馆",
              "安庆小吃店",
            ],
            sightseeingRecommendations: [
              "陈独秀故居与纪念馆",
              "邓稼先故居",
              "怀宁县博物馆",
              "独秀公园",
            ],
          },
          {
            day: 2,
            theme: "皖江奔跑，感受山水人文",
            activities: [
              {
                time: "上午",
                activity: "参加怀宁马拉松",
                notes: "赛道预计展现怀宁的自然风光与城乡面貌。",
              },
              {
                time: "下午",
                activity: "赛后放松，可游览孔雀东南飞文化园或县城周边",
                notes: "了解与怀宁相关的文学典故，或在县城公园散步放松。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，享用丰盛晚餐",
                notes: "与跑友分享喜悦，品尝更多当地美食。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "庆祝晚宴可选餐厅",
              "特色农家乐（若有）",
              "评价好的徽菜馆",
            ],
            sightseeingRecommendations: [
              "马拉松赛道风光",
              "孔雀东南飞文化园",
              "皖河风光带",
              "海子诗歌陈列馆（若对现代诗歌感兴趣）",
            ],
          },
        ],
      },
    },
  ],

  // 贵州
  guizhou: [
    {
      id: "guizhou-zunyi-marathon",
      name: "遵义马拉松",
      distance: "全程、半程、10公里、5公里",
      date: "2025年05月11日",
      numberOfParticipants: "约20,000人",
      image: require("../assets/pictures/MarathonPicture/guizhou-zunyi-marathon.png"),
      routeImage: null,
      web: "https://m.irunner.mobi/mix-race-apply/index.html?match_eng=67beac48d02cb#/grid",
      isCAAcertified: true,
      grade: "A (A1)",
      gradeImage: gradeA,
      travelPlan: {
        title: "遵义马拉松 - 跑过红色圣地体验多彩贵州2日之旅",
        description:
          "参加遵义马拉松，身处著名的“转折之城”，感受红色文化的熏陶，体验多彩贵州的独特魅力。",
        days: [
          {
            day: 1,
            theme: "抵达转折之城，重温红色记忆",
            activities: [
              {
                time: "下午",
                activity: "抵达遵义市（可乘飞机或高铁），入住酒店并领取参赛包",
                notes: "遵义交通便利，提前预订住宿和了解领物流程。",
              },
              {
                time: "傍晚",
                activity: "参观遵义会议会址及红军街",
                notes: "这是遵义的核心红色景点，建议预留充足时间。",
              },
              {
                time: "晚餐",
                activity: "品尝地道遵义及贵州风味",
                notes: "必尝遵义羊肉粉、豆花面，体验黔菜的酸辣特色。",
              },
            ],
            hotelRecommendations: [
              "遵义市中心酒店（红花岗区）",
              "会议会址附近酒店",
              "连锁商务酒店",
            ],
            restaurantRecommendations: [
              "老字号遵义羊肉粉店",
              "特色豆花面馆",
              "酸汤鱼火锅",
              "黔菜馆",
            ],
            sightseeingRecommendations: [
              "遵义会议会址",
              "遵义会议陈列馆",
              "红军街",
              "红军山烈士陵园",
            ],
          },
          {
            day: 2,
            theme: "跑过红色土地，品味黔北风味",
            activities: [
              {
                time: "上午",
                activity: "参加遵义马拉松",
                notes: "赛道预计会经过市区重要地标，感受城市活力与历史底蕴。",
              },
              {
                time: "下午",
                activity: "赛后放松，可参观遵义市博物馆或游览凤凰山公园",
                notes: "了解遵义更全面的历史文化，或登高望远放松身心。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛，继续探索贵州美食",
                notes: "可以尝试辣子鸡、恋爱豆腐果等特色小吃或菜肴。",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "特色辣子鸡店",
              "当地小吃集市（若有）",
              "高评分黔菜餐厅",
            ],
            sightseeingRecommendations: [
              "马拉松赛道风光",
              "遵义市博物馆",
              "凤凰山公园",
              "海龙囤（世界文化遗产，距离市区有一定距离，需单独安排时间）",
            ],
          },
        ],
      },
    },
  ],

  // 宁夏
  ningxia: [
    {
      id: "ningxia-yinchuan-marathon",
      name: "宁夏银川马拉松赛",
      distance: "全程/半程/3公里",
      date: "2025年5月18日",
      numberOfParticipants: "约28000人",
      image: require("../assets/pictures/MarathonPicture/ningxia-yinchuan-marathon.jpeg"),
      routeImage: require("../assets/routeMap/ningxia-yinchuan-marathon.png"),
      web: "https://yinchuanmarathon.shuzixindong.com/#/home",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      feature: [
        {
          id: "location-feature",
          title: "城市特色",
          description:
            "在“塞上江南”银川奔跑，感受西夏古都的历史底蕴与现代活力。",
        },
      ],
      travelPlan: {
        title: `银川马拉松 - 塞上江南2日文化与风光之旅`,
        description: `结合银川马拉松，探索宁夏首府的历史遗迹与独特的塞外风光。`,
        days: [
          {
            day: 1,
            theme: "抵达与西夏探秘",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达银川，入住酒店（可选择金凤区或兴庆区交通便利处）。",
                notes: "银川是历史文化名城，西夏王朝的故都。",
              },
              {
                time: "傍晚",
                activity: "参观宁夏博物馆，初步了解宁夏及西夏历史文化。",
                notes: "博物馆是快速了解一个地方的好窗口。",
              },
              {
                time: "晚餐",
                activity: "品尝当地特色手抓羊肉、羊杂碎等地道宁夏美食。",
                notes: "推荐尝试当地清真餐厅。",
              },
            ],
            hotelRecommendations: [
              "银川万达嘉华酒店",
              "银川凯宾斯基饭店",
              "银川国贸中心假日酒店",
              "金凤区近赛道起点酒店",
            ],
            restaurantRecommendations: [
              "老毛手抓(总店)",
              "国强手抓(新城总店)",
              "仙鹤楼",
              "迎宾楼",
              "德隆楼(新华街店)",
            ],
            sightseeingRecommendations: [
              "宁夏博物馆",
              "承天寺塔",
              "玉皇阁",
              "南关清真大寺",
              "新华步行街",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与影视城/王陵",
            activities: [
              {
                time: "上午",
                activity: `参加 2025宁夏银川马拉松赛 比赛！`,
                notes: "感受塞上湖城的赛道魅力。",
              },
              {
                time: "下午",
                activity: "赛后放松，可选择前往镇北堡西部影城或西夏王陵参观。",
                notes:
                  "西部影城是众多电影取景地；西夏王陵极具历史价值，距离市区有一定距离，需规划好时间。",
              },
              {
                time: "晚餐",
                activity: "在市区享用晚餐，或尝试当地特色小吃。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上或尝试其他当地餐厅", "富强面馆"],
            sightseeingRecommendations: [
              "镇北堡西部影城",
              "西夏王陵",
              "贺兰山岩画 (较远)",
              "沙湖 (较远)",
            ],
          },
        ],
      },
    },
  ],

  // 甘肃
  gansu: [
    {
      id: "gansu-lanzhou-lanzhoumalasong",
      name: "兰州马拉松",
      distance: "全程/半程/5.2公里健康跑/5.2公里家庭跑",
      date: "2025年05月25日",
      numberOfParticipants: "约40000人",
      image: require("../assets/pictures/MarathonPicture/gansu-lanzhou-marathon.jpeg"),
      routeImage: require("../assets/routeMap/gansu-lanzhou-marathon.jpeg"),
      web: "https://mp.weixin.qq.com/s?__biz=MzA5MjE1NTIwNw==&mid=2651343529&idx=1&sn=e1520f13c66c6520e1d25a4b2a31aa4f&chksm=8b8d9681bcfa1f97f35d5b86331935dffe8e42e920b9873ca9c783e4ec1d02a66f5dd34b5048&cur_album_id=3986863195083390989&scene=189#wechat_redirect",
      isCAAcertified: true,
      grade: "A1",
      gradeImage: gradeA,
      feature: [
        {
          id: "lanzhou-2025-feature-1",
          title: "黄河风情线赛道",
          description:
            "兰州马拉松以其独特的黄河风情线赛道闻名，跑者可以沿着母亲河奔跑，欣赏两岸风光。",
        },
        {
          id: "lanzhou-2025-feature-2",
          title: "金牌赛事品质",
          description:
            "作为国内知名的金牌赛事，兰州马拉松在赛事组织、跑者服务等方面均有较高水准。",
        },
      ],
      travelPlan: {
        title: "兰州马拉松 - 黄河边的奔跑与美食探索3日游",
        description:
          "参加2025兰州马拉松，体验母亲河畔的壮丽赛道，品尝地道的兰州牛肉面和西北风味。",
        days: [
          {
            day: 1,
            theme: "抵达兰州与赛前准备/黄河初见",
            activities: [
              {
                time: "下午",
                activity: "抵达兰州，前往酒店办理入住，领取参赛包。",
                notes: "建议选择靠近黄河风情线或市中心的酒店。",
              },
              {
                time: "傍晚",
                activity: "漫步黄河铁桥（中山桥），欣赏黄河夜景。",
                notes: "感受兰州的母亲河文化。",
              },
              {
                time: "晚餐",
                activity: "品尝正宗的兰州牛肉面，为第二天的比赛储备能量。",
                notes: "牛肉面是兰州的灵魂，但赛前不宜过量。",
              },
            ],
            hotelRecommendations: [
              "兰州皇冠假日酒店 (近黄河)",
              "兰州万达文华酒店 (市中心)",
              "亚朵酒店 (多家分店，品质连锁)",
            ],
            restaurantRecommendations: [
              "马子禄牛肉面 (老字号)",
              "舌尖尖牛肉面 (连锁)",
            ],
            sightseeingRecommendations: ["中山桥 (黄河铁桥)", "白塔山公园"],
          },
          {
            day: 2,
            theme: "马拉松比赛日与美食犒赏",
            activities: [
              {
                time: "上午",
                activity: "参加 2025兰州马拉松！",
                notes: "在黄河边尽情奔跑，感受西北的热情！",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可以去正宁路小吃夜市（傍晚开始）品尝各种当地小吃。",
                notes: "注意休息，根据体力决定是否前往。",
              },
              {
                time: "晚餐",
                activity: "庆祝完赛！品尝手抓羊肉、酿皮子等地道西北菜。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: [
              "忠华手抓大王 (手抓羊肉)",
              "正宁路小吃夜市 (各类小吃)",
            ],
            sightseeingRecommendations: [
              "甘肃省博物馆 (如有多余时间)",
              "水车博览园",
            ],
          },
        ],
      },
    },
  ],

  // 云南
  yunnan: [
    {
      id: "mile-half-marathon",
      name: "弥勒半程马拉松",
      distance: "半程、5公里",
      date: "2025年5月18日",
      numberOfParticipants: "约16000人",
      image: require("../assets/pictures/MarathonPicture/yunnan-mile-half.jpeg"),
      routeImage: require("../assets/routeMap/yunnan-mile-half.jpeg"),
      web: "https://www.sichuanbojiesports.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      feature: [
        {
          id: "location-feature",
          title: "城市特色",
          description: "在云南“福地”弥勒奔跑，体验温泉、红酒和宜人气候。",
        },
      ],
      travelPlan: {
        title: `弥勒半马 - 云南福地2日休闲体验之旅`,
        description: `结合弥勒半程马拉松，享受弥勒的温泉、美酒与休闲氛围。`,
        days: [
          {
            day: 1,
            theme: "抵达与红酒温泉乡",
            activities: [
              {
                time: "下午",
                activity: "抵达弥勒，入住酒店（可选择温泉酒店或市区酒店）。",
                notes: "弥勒以温泉和葡萄/红酒闻名。",
              },
              {
                time: "傍晚",
                activity:
                  "参观湖泉生态园，或前往云南红酒庄了解当地葡萄酒文化。",
                notes: "湖泉生态园是城市绿肺，环境优美。",
              },
              {
                time: "晚餐",
                activity: "品尝弥勒卤鸡、羊汤锅等当地特色美食。",
                notes: "可以搭配当地红酒。",
              },
            ],
            hotelRecommendations: [
              "湖泉酒店",
              "弥勒温泉酒店",
              "云南红酒庄酒店",
              "弥勒市区经济型酒店",
            ],
            restaurantRecommendations: [
              "老味道卤鸡米线",
              "弥勒土鸡馆",
              "红河谷风味餐厅",
              "湖泉生态园餐厅",
            ],
            sightseeingRecommendations: [
              "湖泉生态园",
              "云南红酒庄",
              "锦屏山风景区 (弥勒大佛)",
              "可邑小镇 (彝族阿细文化)",
            ],
          },
          {
            day: 2,
            theme: "半马日与休闲放松",
            activities: [
              {
                time: "上午",
                activity: `参加 2025弥勒半程马拉松 比赛！`,
                notes: "感受弥勒舒适的气候和赛道。",
              },
              {
                time: "下午",
                activity: "赛后选择泡温泉放松身心，或在市区闲逛购买特产。",
                notes: "弥勒温泉资源丰富，是跑后恢复的好方式。",
              },
              {
                time: "晚餐",
                activity: "享用特色晚餐后准备返程或继续旅程。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上"],
            sightseeingRecommendations: [
              "弥勒温泉度假区",
              "东风韵艺术小镇",
              "白龙洞风景区",
            ],
          },
        ],
      },
    },
    {
      id: "yunnan-dali-marathon",
      name: "澜沧江-湄公河合作大理马拉松",
      distance: "全程/半程/5.2公里/2公里",
      date: "2025年5月18日",
      numberOfParticipants: "约20000人",
      image: require("../assets/pictures/MarathonPicture/yunnan-dali-marathon.png"),
      routeImage: require("../assets/routeMap/yunnan-dali-marathon.jpeg"),
      web: "http://www.lmcdm.saihuitong.com/",
      isCAAcertified: true,
      grade: "A",
      gradeImage: gradeA,
      feature: [
        {
          id: "location-feature",
          title: "苍山洱海",
          description:
            "在风花雪月的大理奔跑，赛道很可能环绕洱海或靠近苍山，风景绝佳。",
        },
        {
          id: "international",
          title: "国际合作",
          description:
            "赛事名称冠以“澜沧江-湄公河合作”，可能具有一定的国际交流元素。",
        },
      ],
      travelPlan: {
        title: `大理马拉松 - 风花雪月2日休闲跑旅`,
        description: `结合大理马拉松，沉浸在苍山洱海的浪漫风光与白族文化之中。`,
        days: [
          {
            day: 1,
            theme: "抵达与古城洱海",
            activities: [
              {
                time: "下午",
                activity:
                  "抵达大理，入住酒店（可选择大理古城内或洱海边的客栈/酒店）。",
                notes: "大理是热门旅游目的地，住宿需尽早预订。",
              },
              {
                time: "傍晚",
                activity: "漫步大理古城，感受古城氛围；或前往洱海边欣赏日落。",
                notes: "古城内人民路、复兴路、洋人街是主要街道。",
              },
              {
                time: "晚餐",
                activity: "在古城内品尝白族特色菜，如酸辣鱼、饵块、乳扇等。",
                notes: "古城内餐厅众多，选择多样。",
              },
            ],
            hotelRecommendations: [
              "大理古城内特色客栈",
              "洱海海景酒店/客栈",
              "大理实力希尔顿酒店",
              "大理国际大酒店",
            ],
            restaurantRecommendations: [
              "梅子井酒家(人民路店)",
              "醉琉璃私房菜",
              "方舟胖子厨房",
              "再回首凉鸡米线",
              "杨记饵块",
            ],
            sightseeingRecommendations: [
              "大理古城",
              "洱海 (可选择乘船、骑行或自驾环湖)",
              "洋人街",
              "人民路",
              "床单厂艺术区",
            ],
          },
          {
            day: 2,
            theme: "马拉松日与苍山风光",
            activities: [
              {
                time: "上午",
                activity: `参加 2025澜沧江-湄公河合作大理马拉松 比赛！`,
                notes: "享受在苍洱风光中奔跑的独特体验。",
              },
              {
                time: "下午",
                activity:
                  "赛后可选择乘坐苍山索道，俯瞰洱海和古城全景；或前往崇圣寺三塔公园参观。",
                notes: "苍山有多条索道，可根据体力和时间选择。",
              },
              {
                time: "晚餐",
                activity: "在古城或下关城区享用晚餐。",
                notes: "",
              },
            ],
            hotelRecommendations: ["同上"],
            restaurantRecommendations: ["同上"],
            sightseeingRecommendations: [
              "苍山 (Cangshan Mountain - 感通索道/洗马潭索道)",
              "崇圣寺三塔 (Three Pagodas)",
              "喜洲古镇 (Xizhou Town - 白族建筑)",
              "周城 (扎染之乡)",
              "双廊古镇 (Shuanglang Town)",
            ],
          },
        ],
      },
    },
  ],

  //浙江
  zhejiang: [
    {
      id: "zhejiang-hangzhou-xihu-half",
      name: "西湖半程马拉松",
      distance: "半程",
      date: "2025年05月25日",
      numberOfParticipants: "约5000人",
      image: require("../assets/pictures/MarathonPicture/zhejiang-hangzhou-xihu-half.jpg"),
      routeImage: require("../assets/routeMap/zhejiang-hangzhou-xihu-half.webp"),
      web: "https://www.hlsports.net/marathon",
      isCAAcertified: true,
      grade: "A1",
      gradeImage: gradeA,
      feature: [
        {
          id: "xihu-2025-feature-1",
          title: "最美西湖赛道",
          description:
            "赛道环绕着世界文化遗产——杭州西湖，跑者可以尽览湖光山色，感受“人间天堂”的魅力。",
        },
        {
          id: "xihu-2025-feature-2",
          title: "高品质赛事服务",
          description:
            "作为A1级赛事，通常意味着更专业的组织、更完善的补给和更优质的参赛体验。",
        },
      ],
      travelPlan: {
        title: "杭州西湖半程马拉松 - 江南忆3日跑旅行程",
        description:
          "参加2025西湖半程马拉松，沉醉于杭州的湖光山色、丝绸茶文化与精致杭帮菜。",
        days: [
          {
            day: 1,
            theme: "抵达杭州与赛前准备/漫步西湖",
            activities: [
              {
                time: "下午",
                activity: "抵达杭州，前往酒店办理入住，领取参赛包。",
                notes: "建议选择西湖景区附近或交通便利的酒店。",
              },
              {
                time: "傍晚",
                activity: "漫步苏堤或白堤，欣赏西湖夕照，提前感受赛道氛围。",
                notes: "放松心情，适应杭州气候。",
              },
              {
                time: "晚餐",
                activity: "品尝地道杭帮菜，如西湖醋鱼、东坡肉。",
                notes: "选择清淡口味，为比赛储能。",
              },
            ],
            hotelRecommendations: [
              "杭州西子湖四季酒店 (顶级)",
              "杭州君悦酒店 (豪华，近西湖)",
              "桔子水晶酒店(西湖湖滨店) (中高端)",
            ],
            restaurantRecommendations: [
              "楼外楼 (传统杭帮菜)",
              "知味观·味庄 (百年老店)",
            ],
            sightseeingRecommendations: [
              "西湖 (苏堤、白堤)",
              "河坊街/南宋御街",
            ],
          },
          {
            day: 2,
            theme: "马拉松比赛日与龙井茶香",
            activities: [
              {
                time: "上午",
                activity: "参加 2025西湖半程马拉松！",
                notes: "尽情奔跑，享受最美赛道！",
              },
              {
                time: "下午",
                activity:
                  "赛后放松，可前往龙井村或梅家坞，品茗赏景，感受茶文化。",
                notes: "如体力允许，也可乘船游览三潭印月。",
              },
              {
                time: "晚餐",
                activity:
                  "庆祝完赛！在西湖边的餐厅享用美食，或尝试创意杭帮菜。",
                notes: "",
              },
            ],
            hotelRecommendations: [
              "同上",
              "或选择靠近灵隐寺、龙井区域的特色民宿",
            ],
            restaurantRecommendations: ["同上", "绿茶餐厅 (性价比高)"],
            sightseeingRecommendations: [
              "龙井村/梅家坞",
              "灵隐寺",
              "三潭印月 (乘船)",
            ],
          },
        ],
      },
    },
  ],
};
